//tdesign 全部图标
//来自  https://github.com/Tencent/tdesign-icons/blob/develop/packages/view/src/manifest.js
export const manifest = {
    filled: {
        Brand: {
            labelCN: '品牌',
            labelEn: 'Brand',
            icons: [
                {
                    name: 'logo-adobe-lightroom-filled',


                    keywords: ['Adobe Lightroom 标志', 'Adobe Lightroom徽标'],
                },
                {
                    name: 'logo-android-filled',


                    keywords: ['安卓标志', 'Android徽标"'],
                },
                {
                    name: 'logo-adobe-illustrate-filled',


                    keywords: ['Adobe Illustrator的logo', 'Adobe标志'],
                },
                {
                    name: 'logo-cinema4d-filled',


                    keywords: ['logo 电影4d', '电影4d标志'],
                },
                {
                    name: 'logo-adobe-photoshop-filled',


                    keywords: ['Adobe Photoshop的logo', 'Adobe Photoshop的标志', 'ps'],
                },
                {
                    name: 'logo-chrome-filled',


                    keywords: ['谷歌浏览器标志', '谷歌Chrome标识'],
                },
                {
                    name: 'logo-alipay-filled',


                    keywords: ['支付宝', 'alipay'],
                },
                {
                    name: 'logo-behance-filled',


                    keywords: ['logo-behance', '标志 Behance'],
                },
                {
                    name: 'logo-figma-filled',


                    keywords: ['logo设计', 'Figma制作'],
                },
                {
                    name: 'logo-facebook-filled',


                    keywords: [],
                },
                {
                    name: 'logo-ie-filled',


                    keywords: [],
                },
                {
                    name: 'logo-github-filled',


                    keywords: [],
                },
                {
                    name: 'logo-dribbble-filled',


                    keywords: ['logo设计', 'Dribbble作品'],
                },
                {
                    name: 'logo-framer-filled',


                    keywords: ['logo设计', '框架制作'],
                },
                {
                    name: 'logo-gitlab-filled',


                    keywords: ['标志-GitLab', '徽标-GitLab'],
                },
                {
                    name: 'logo-instagram-filled',


                    keywords: ['"logo-instagram', '标志Instagram"'],
                },
                {
                    name: 'logo-apple-filled',


                    keywords: ['苹果标志', '苹果公司徽标'],
                },
                {
                    name: 'logo-qq-filled',


                    keywords: ['"QQ标志', 'QQ徽标"'],
                },
                {
                    name: 'logo-twitter-filled',


                    keywords: ['推特'],
                },
                {
                    name: 'logo-wechatpay-filled',


                    keywords: ['微信支付标志', '微信支付标识'],
                },
                {
                    name: 'logo-wechat-stroke-filled',


                    keywords: ['微信图标', '描边微信'],
                },
                {
                    name: 'logo-youtube-filled',


                    keywords: ['"YouTube标志', 'YouTube徽标"'],
                },
                {
                    name: 'logo-cnb-filled',


                    keywords: ['CNB', '腾讯云原生构建'],
                },
                {
                    name: 'logo-miniprogram-filled',


                    keywords: ['小程序', '微信小程序'],
                },
            ],
        },
        Image: {
            labelCN: '图片',
            labelEn: 'Image',
            icons: [
                {
                    name: 'brightness-1-filled',


                    keywords: ['亮度', '光照度'],
                },
                {
                    name: 'adjustment-filled',


                    keywords: ['调整', '校准'],
                },
                {
                    name: 'animation-filled',


                    keywords: ['动画', '动画制作'],
                },
                {
                    name: 'circle-filled',


                    keywords: ['圆圈', '圆形'],
                },
                {
                    name: 'center-focus-strong-filled',


                    keywords: ['中心聚焦强', '中心重点突出'],
                },
                {
                    name: 'animation-1-filled',


                    keywords: ['动画', '动画制作'],
                },
                {
                    name: 'brightness-filled',


                    keywords: ['亮度', '光照度'],
                },
                {
                    name: 'contrast-1-filled',


                    keywords: ['对比', '强烈对比'],
                },
                {
                    name: 'exposure-filled',


                    keywords: ['曝光', '曝光量'],
                },
                {
                    name: 'fill-color-1-filled',


                    keywords: ['填充颜色', '填充色彩'],
                },
                {
                    name: 'filter-2-filled',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'filter-3-filled',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'face-retouching-filled',


                    keywords: ['面部修饰', '面部磨皮'],
                },
                {
                    name: 'image-add-filled',


                    keywords: ['图片添加', '添加图片'],
                },
                {
                    name: 'highlight-1-filled',


                    keywords: ['高亮', '强调'],
                },
                {
                    name: 'image-off-filled',


                    keywords: ['关闭图片', '图片关闭'],
                },
                {
                    name: 'image-1-filled',


                    keywords: ['图片', '图像'],
                },
                {
                    name: 'image-edit-filled',


                    keywords: ['图片编辑', '图像编辑'],
                },
                {
                    name: 'image-filled',


                    keywords: ['图片', '图像'],
                },
                {
                    name: 'image-error-filled',


                    keywords: ['图片错误', '图像错误'],
                },
                {
                    name: 'image-search-filled',


                    keywords: ['图片搜索', '图像搜索'],
                },
                {
                    name: 'markup-filled',


                    keywords: ['标记', '符号'],
                },
                {
                    name: 'measurement-filled',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'panorama-vertical-filled',


                    keywords: ['全景垂直', '垂直全景'],
                },
                {
                    name: 'measurement-1-filled',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'pantone-filled',


                    keywords: ['潘通色卡', 'Pantone颜色对照表'],
                },
                {
                    name: 'palette-filled',


                    keywords: ['调色板', '色彩面板'],
                },
                {
                    name: 'round-filled',


                    keywords: ['四舍五入', '舍入'],
                },
                {
                    name: 'panorama-horizontal-filled',


                    keywords: ['全景水平', '水平全景'],
                },
                {
                    name: 'portrait-filled',


                    keywords: ['肖像', '画像'],
                },
                {
                    name: 'saturation-filled',


                    keywords: ['饱和度', '饱和度'],
                },
                {
                    name: 'transform-filled',


                    keywords: ['转变', '变换'],
                },
                {
                    name: 'rectangle-filled',


                    keywords: ['长方形', '矩形'],
                },
                {
                    name: 'sharpness-filled',


                    keywords: ['清晰度', '锐度'],
                },
                {
                    name: 'visual-recognition-filled',


                    keywords: ['视觉识别', '视觉辨识'],
                },
            ],
        },
        Weather: {
            labelCN: '天气',
            labelEn: 'Weather',
            icons: [
                {
                    name: 'cloudy-day-filled',


                    keywords: ['多云天气', '多云天'],
                },
                {
                    name: 'fog-night-filled',


                    keywords: ['雾夜,雾中夜'],
                },
                {
                    name: 'cloudy-night-rain-filled',


                    keywords: ['多云夜晚雨', '阴天夜晚下雨'],
                },
                {
                    name: 'cloud-filled',


                    keywords: ['云', '云朵'],
                },
                {
                    name: 'fog-filled',


                    keywords: ['雾', '雾气'],
                },
                {
                    name: 'moon-filled',


                    keywords: ['月亮', '月球'],
                },
                {
                    name: 'fog-sunny-filled',


                    keywords: ['雾天', '晴朗天气'],
                },
                {
                    name: 'cloudy-rain-filled',


                    keywords: ['多云转雨', '阴雨天气'],
                },
                {
                    name: 'sun-fall-filled',


                    keywords: ['太阳落山', '日落西山'],
                },
                {
                    name: 'moon-rising-filled',


                    keywords: ['月亮升起', '月亮升起的时候'],
                },
                {
                    name: 'sunny-filled',


                    keywords: ['晴朗的', '阳光明媚的'],
                },
                {
                    name: 'moon-fall-filled',


                    keywords: ['月落', '月亮落下'],
                },
                {
                    name: 'cloudy-sunny-filled',


                    keywords: ['多云转晴', '阴转晴'],
                },
                {
                    name: 'cloudy-night-filled',


                    keywords: ['多云的夜晚', '多云的夜色'],
                },
                {
                    name: 'rain-light-filled',


                    keywords: ['雨光', '雨中的光线'],
                },
                {
                    name: 'thunderstorm-sunny-filled',


                    keywords: ['雷暴后的晴天', '晴朗天气后的雷暴'],
                },
                {
                    name: 'sun-rising-filled',


                    keywords: ['日出', '日出东方'],
                },
                {
                    name: 'thunderstorm-night-filled',


                    keywords: ['雷暴之夜', '夜晚的雷暴'],
                },
            ],
        },
        Media: {
            labelCN: '媒体',
            labelEn: 'Media',
            icons: [
                {
                    name: 'cd-filled',


                    keywords: ['"进入目录', '转到目录"'],
                },
                {
                    name: 'backward-filled',


                    keywords: ['向后看', '向后转'],
                },
                {
                    name: 'camera-1-filled',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'dv-filled',


                    keywords: [],
                },
                {
                    name: 'dvd-filled',


                    keywords: ['影碟', '激光唱片'],
                },
                {
                    name: 'download-2-filled',


                    keywords: ['下载', '下载文件'],
                },
                {
                    name: 'forward-filled',


                    keywords: ['前进', '进展'],
                },
                {
                    name: 'microphone-1-filled',


                    keywords: ['麦克风', '扩音器'],
                },
                {
                    name: 'guitar-filled',


                    keywords: ['吉他', '吉他', 'electric guitar', '电吉他'],
                },
                {
                    name: 'film-1-filled',


                    keywords: ['胶卷', '电影胶片'],
                },
                {
                    name: 'dart-board-filled',


                    keywords: [
                        '"dart board', 'dart board" 的两个可能的中文短语翻译为：“飞镖盘', '投镖靶”。',
                    ],
                },
                {
                    name: 'gamepad-1-filled',


                    keywords: ['游戏手柄', '游戏控制器'],
                },
                {
                    name: 'ipod-filled',


                    keywords: [
                        'iPod', '翻译为两个可能的中文短语为：\n1. 苹果音乐播放器,\n2. 苹果便携式音乐播放器。',
                    ],
                },
                {
                    name: 'movie-clapper-filled',


                    keywords: ['电影拍手', '电影拍掌'],
                },
                {
                    name: 'microphone-2-filled',


                    keywords: ['麦克风', '扩音器'],
                },
                {
                    name: 'microphone-filled',


                    keywords: ['麦克风', '扩音器'],
                },
                {
                    name: 'music-filled',


                    keywords: ['音乐', '音乐'],
                },
                {
                    name: 'pause-circle-filled',


                    keywords: ['暂停圆圈', '暂停圈'],
                },
                {
                    name: 'next-filled',


                    keywords: ['下一步', '下一个步骤'],
                },
                {
                    name: 'loudspeaker-filled',


                    keywords: ['喇叭', '扬声器'],
                },
                {
                    name: 'play-circle-filled',


                    keywords: ['播放循环', '循环播放'],
                },
                {
                    name: 'pause-circle-stroke-filled',


                    keywords: ['暂停圆形描边', '暂停圆圈描边'],
                },
                {
                    name: 'music-rectangle-add-filled',


                    keywords: ['音乐矩形添加', '矩形音乐添加'],
                },
                {
                    name: 'piano-filled',


                    keywords: ['钢琴', '钢琴', '钢琴'],
                },
                {
                    name: 'play-circle-stroke-filled',


                    keywords: ['播放圆形描边', '圆形循环描边'],
                },
                {
                    name: 'earphone-filled',


                    keywords: ['耳机', '耳朵耳机'],
                },
                {
                    name: 'calculator-filled',


                    keywords: ['计算器', '计算器具'],
                },
                {
                    name: 'play-demo-filled',


                    keywords: [
                        '"play-demo" 可以翻译为以下两个中文短语：\n\n1. 演示游戏', '演示程序\n2. 播放演示', '演示玩法',
                    ],
                },
                {
                    name: 'radio-1-filled',


                    keywords: ['无线电', '无线电波'],
                },
                {
                    name: 'play-rectangle-filled',


                    keywords: ['播放矩形', '矩形游戏'],
                },
                {
                    name: 'replay-filled',


                    keywords: ['重播', '重复播放'],
                },
                {
                    name: 'previous-filled',


                    keywords: ['之前的', '以前的'],
                },
                {
                    name: 'radio-2-filled',


                    keywords: ['无线电', '无线电波'],
                },
                {
                    name: 'screencast-filled',


                    keywords: ['屏幕录制', '屏幕快照'],
                },
                {
                    name: 'shutter-filled',


                    keywords: ['快门速度', '帘幕式快门', '朋友圈'],
                },
                {
                    name: 'sound-down-filled',


                    keywords: ['音量调低', '声音降低'],
                },
                {
                    name: 'sd-card-1-filled',


                    keywords: ['SD卡', '存储卡'],
                },
                {
                    name: 'play-circle-stroke-add-filled',


                    keywords: ['添加圆形播放图标笔触', '添加圆形播放图标描边'],
                },
                {
                    name: 'sound-mute-filled',


                    keywords: ['静音', '声音关闭'],
                },
                {
                    name: 'sound-high-filled',


                    keywords: ['响度高', '声音大'],
                },
                {
                    name: 'sound-filled',


                    keywords: ['声音', '音响'],
                },
                {
                    name: 'tape-filled',


                    keywords: ['磁带', '录像带'],
                },
                {
                    name: 'sound-low-filled',


                    keywords: ['低音', '低频'],
                },
                {
                    name: 'sound-up-filled',


                    keywords: [
                        '"sound-up" 可以翻译为以下两个中文短语：\n\n1. 扩音', '加大音量\n2. 闹钟响起', '发出声音',
                    ],
                },
                {
                    name: 'stop-circle-stroke-filled',


                    keywords: ['停止圆圈描边', '停止圆形描边'],
                },
                {
                    name: 'stop-circle-filled',


                    keywords: ['停止圆形', '停止圈'],
                },
                {
                    name: 'video-camera-2-filled',


                    keywords: ['电视摄像机', '录像机'],
                },
                {
                    name: 'sound-mute-1-filled',


                    keywords: ['静音', '禁用声音'],
                },
                {
                    name: 'video-camera-dollar-filled',


                    keywords: ['视频摄像头美元', '摄像机美元'],
                },
                {
                    name: 'video-camera-music-filled',


                    keywords: ['视频,相机,音乐,摄像机,音频'],
                },
                {
                    name: 'video-camera-minus-filled',


                    keywords: ['摄像头减法', '摄像机减法'],
                },
                {
                    name: 'video-library-filled',


                    keywords: ['视频库', '影视资料馆'],
                },
                {
                    name: 'video-camera-3-filled',


                    keywords: ['电视摄像机', '视频摄影机'],
                },
                {
                    name: 'video-camera-off-filled',


                    keywords: ['摄像头关闭', '摄像机关'],
                },
                {
                    name: 'video-camera-1-filled',


                    keywords: ['电视摄像机', '视频摄影机'],
                },
                {
                    name: 'video-filled',


                    keywords: ['视频', '录像'],
                },
            ],
        },
        Charts: {
            labelCN: '图表',
            labelEn: 'Charts',
            icons: [
                {
                    name: 'chart-area-filled',


                    keywords: ['图表区域', '绘图区'],
                },
                {
                    name: 'chart-area-multi-filled',


                    keywords: ['图表区域多', '图表区域众多'],
                },
                {
                    name: 'activity-filled',


                    keywords: ['活动', '行动'],
                },
                {
                    name: 'chart-column-filled',


                    keywords: ['列图表', '柱状图'],
                },
                {
                    name: 'chart-bubble-filled',


                    keywords: ['图表气泡', '气泡图'],
                },
                {
                    name: 'chart-bar-filled',


                    keywords: ['条形图', '柱状图'],
                },
                {
                    name: 'chart-3d-filled',


                    keywords: ['图表', '图表展示'],
                },
                {
                    name: 'fork-filled',


                    keywords: ['分叉', '分支'],
                },
                {
                    name: 'chart-ring-1-filled',


                    keywords: ['圆环图,环形图'],
                },
                {
                    name: 'chart-radar-filled',


                    keywords: ['图表雷达', '雷达图表'],
                },
                {
                    name: 'chart-pie-filled',


                    keywords: ['图表饼图', '饼状图'],
                },
                {
                    name: 'table-split-filled',


                    keywords: ['表格分割', '表格拆分'],
                },
                {
                    name: 'chart-combo-filled',


                    keywords: ['图表组合', '图表组合框'],
                },
                {
                    name: 'sequence-filled',


                    keywords: ['序列', '顺序'],
                },
                {
                    name: 'tree-square-dot-vertical-filled',


                    keywords: ['树形圆点垂直', '树状圆点垂直布局'],
                },
                {
                    name: 'chart-ring-filled',


                    keywords: ['圆环图', '环形图'],
                },
                {
                    name: 'table-filled',


                    keywords: ['桌子', '餐桌'],
                },
                {
                    name: 'tree-round-dot-filled',


                    keywords: ['树形圆点', '树形点'],
                },
                {
                    name: 'chart-stacked-filled',


                    keywords: ['图表堆叠', '堆叠图表'],
                },
                {
                    name: 'usercase-filled',


                    keywords: ['大写形式', '首字母大写'],
                },
                {
                    name: 'tree-round-dot-vertical-filled',


                    keywords: ['树形圆点垂直', '树状圆点垂直分布'],
                },
                {
                    name: 'usercase-link-filled',


                    keywords: ['用户案例链接', '用户故事链接'],
                },
                {
                    name: 'tree-square-dot-filled',


                    keywords: ['树形圆点', '树状圆点'],
                },
                {
                    name: 'table-add-filled',


                    keywords: [
                        'table-add 可以翻译为以下两个中文短语：\n\n1. 表格添加,\n2. 加入表格',
                    ],
                },
            ],
        },
        Development: {
            labelCN: '开发',
            labelEn: 'Development',
            icons: [
                {
                    name: 'cursor-filled',


                    keywords: ['光标', '指示器'],
                },
                {
                    name: 'git-pull-request-filled',


                    keywords: ['拉取请求', '合并请求'],
                },
                {
                    name: 'git-branch-filled',


                    keywords: ['git 分支', 'Git 枝干'],
                },
                {
                    name: 'bug-filled',


                    keywords: ['臭虫', '虫子'],
                },
                {
                    name: 'git-merge-filled',


                    keywords: ['合并 Git', '合并分支'],
                },
                {
                    name: 'git-repository-private-filled',


                    keywords: ['git私有仓库', 'git私有存储库'],
                },
                {
                    name: 'css3-filled',


                    keywords: [],
                },
                {
                    name: 'git-repository-commits-filled',


                    keywords: ['git仓库提交记录', 'Git仓库的提交历史'],
                },
                {
                    name: 'git-commit-filled',


                    keywords: ['提交', '提交记录'],
                },
                {
                    name: 'html5-filled',


                    keywords: ['超文本标记语言5', 'HTML5'],
                },
                {
                    name: 'terminal-rectangle-filled',


                    keywords: ['终端矩形', '终端窗口矩形'],
                },
                {
                    name: 'sitemap-filled',


                    keywords: ['网站地图', '站点地图'],
                },
                {
                    name: 'git-repository-filled',


                    keywords: ['git仓库', 'Git存储库'],
                },
                {
                    name: 'terminal-window-filled',


                    keywords: ['终端窗口', '终端视窗'],
                },
            ],
        },
        Maps: {
            labelCN: '地图',
            labelEn: 'Maps',
            icons: [
                {
                    name: 'compass-1-filled',


                    keywords: ['罗盘,指南针'],
                },
                {
                    name: 'earth-filled',


                    keywords: ['地球', ',地球的'],
                },
                {
                    name: 'location-filled',


                    keywords: ['位置', '所在地'],
                },
                {
                    name: 'indicator-filled',


                    keywords: ['指标', '指标', '指标', '指标'],
                },
                {
                    name: 'camera-2-filled',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'compass-filled',


                    keywords: ['罗盘,指南针,导航,定位'],
                },
                {
                    name: 'location-reduction-filled',


                    keywords: ['地点缩减', '位置降低'],
                },
                {
                    name: 'location-parking-place-filled',


                    keywords: ['"位置', '停车场"', '"地点', '停车位"'],
                },
                {
                    name: 'location-setting-filled',


                    keywords: ['位置设置', '位置配置'],
                },
                {
                    name: 'map-add-filled',


                    keywords: ['地图添加', '映射添加'],
                },
                {
                    name: 'map-cancel-filled',


                    keywords: ['取消映射', '取消地图'],
                },
                {
                    name: 'map-blocked-filled',


                    keywords: ['地图阻止', '地图被封锁'],
                },
                {
                    name: 'map-aiming-filled',


                    keywords: ['瞄准地图', '地图定位'],
                },
                {
                    name: 'map-3d-filled',


                    keywords: ['地图数据', '地图可视化'],
                },
                {
                    name: 'map-bubble-filled',


                    keywords: ['地图气泡', '气泡地图'],
                },
                {
                    name: 'map-collection-filled',


                    keywords: ['映射集合', '映射-集合'],
                },
                {
                    name: 'map-connection-filled',


                    keywords: ['地图连接', '映射连接'],
                },
                {
                    name: 'location-enlargement-filled',


                    keywords: ['位置放大', '扩大定位'],
                },
                {
                    name: 'location-error-filled',


                    keywords: ['位置错误', '定位错误'],
                },
                {
                    name: 'map-chat-filled',


                    keywords: ['地图聊天', '地图交流'],
                },
                {
                    name: 'map-edit-filled',


                    keywords: ['地图编辑', '地图修改'],
                },
                {
                    name: 'map-information-1-filled',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-distance-filled',


                    keywords: ['地图距离', '行驶距离'],
                },
                {
                    name: 'map-checked-filled',


                    keywords: ['地图已检查', '地图已核对'],
                },
                {
                    name: 'map-double-filled',


                    keywords: ['映射双重', '双重映射'],
                },
                {
                    name: 'map-grid-filled',


                    keywords: ['地图网格', '网格地图'],
                },
                {
                    name: 'map-location-filled',


                    keywords: ['地图位置', '地理位置'],
                },
                {
                    name: 'map-information-filled',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-navigation-filled',


                    keywords: ['地图导航', '导航地图'],
                },
                {
                    name: 'map-marked-filled',


                    keywords: ['地图标记', '地图上的标记'],
                },
                {
                    name: 'map-locked-filled',


                    keywords: ['地图锁定', '锁定地图'],
                },
                {
                    name: 'map-information-2-filled',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-filled',


                    keywords: ['地图', '地图册'],
                },
                {
                    name: 'map-safety-filled',


                    keywords: ['地图安全', '安全性映射'],
                },
                {
                    name: 'map-search-filled',


                    keywords: ['地图搜索', '地图查找'],
                },
                {
                    name: 'map-outline-filled',


                    keywords: ['地图轮廓', '地图边界'],
                },
                {
                    name: 'map-search-1-filled',


                    keywords: ['地图搜索', '地图查找'],
                },
                {
                    name: 'map-route-planning-filled',


                    keywords: ['地图路线规划', '路径规划'],
                },
                {
                    name: 'navigation-arrow-filled',


                    keywords: ['导航箭头', '导航指示箭头'],
                },
                {
                    name: 'map-ruler-filled',


                    keywords: ['地图尺', '比例尺'],
                },
                {
                    name: 'mobile-navigation-filled',


                    keywords: ['移动导航', '行动导航'],
                },
                {
                    name: 'map-setting-filled',


                    keywords: ['地图设置', '地图配置'],
                },
                {
                    name: 'pin-filled',


                    keywords: ['pin', '针,钉子,别针'],
                },
                {
                    name: 'street-road-1-filled',


                    keywords: ['街道', '道路'],
                },
                {
                    name: 'subway-line-filled',


                    keywords: ['地铁路线', '地铁线路'],
                },
                {
                    name: 'street-road-filled',


                    keywords: ['街道', '道路'],
                },
                {
                    name: 'map-unlocked-filled',


                    keywords: ['解锁地图', '打开地图'],
                },
                {
                    name: 'traffic-events-filled',


                    keywords: ['交通事件', '交通事故'],
                },
                {
                    name: 'traffic-filled',


                    keywords: ['交通', '流量'],
                },
            ],
        },
        Math: {
            labelCN: '数学',
            labelEn: 'Math',
            icons: [
                {
                    name: 'bifurcate-filled',


                    keywords: ['分支', '分叉'],
                },
                {
                    name: 'coordinate-system-filled',


                    keywords: ['坐标系', '坐标系统'],
                },
                {
                    name: 'delta-filled',


                    keywords: ['delta', '差值', '变化量'],
                },
                {
                    name: 'calculation-1-filled',


                    keywords: ['计算', '运算'],
                },
                {
                    name: 'mathematics-filled',


                    keywords: ['数学', '数学知识'],
                },
                {
                    name: 'combination-filled',


                    keywords: ['组合', '组成'],
                },
                {
                    name: 'ruler-filled',


                    keywords: ['尺子', '尺', '度量尺'],
                },
            ],
        },
        Gestures: {
            labelCN: '手势',
            labelEn: 'Gestures',
            icons: [
                {
                    name: 'gesture-expansion-filled',


                    keywords: ['手势扩展', '手势扩大'],
                },
                {
                    name: 'gesture-click-filled',


                    keywords: ['手势点击', '手势触摸'],
                },
                {
                    name: 'gesture-applause-filled',


                    keywords: ['手势鼓掌', '掌声手势'],
                },
                {
                    name: 'gesture-left-filled',


                    keywords: ['手势向左', '向左挥动'],
                },
                {
                    name: 'gesture-down-filled',


                    keywords: ['手势向下', '向下手势'],
                },
                {
                    name: 'gesture-open-filled',


                    keywords: ['手势打开', '手势开启'],
                },
                {
                    name: 'gesture-press-filled',


                    keywords: ['手势按压', '手势触摸'],
                },
                {
                    name: 'gesture-pray-filled',


                    keywords: ['祈祷手势', '祈祷动作'],
                },
                {
                    name: 'gesture-right-filled',


                    keywords: ['手势向右', '向右的手势'],
                },
                {
                    name: 'gesture-right-slip-filled',


                    keywords: ['手势向右滑', '向右滑动手势'],
                },
                {
                    name: 'gesture-slide-up-filled',


                    keywords: ['手势上滑', '手势向上滑动'],
                },
                {
                    name: 'gesture-left-slip-filled',


                    keywords: ['左手滑', '左侧滑动'],
                },
                {
                    name: 'gesture-slide-left-and-right-filled',


                    keywords: ['手势左右滑动', '左右手势滑动'],
                },
                {
                    name: 'gesture-ranslation-filled',


                    keywords: ['手势翻译', '手势转录'],
                },
                {
                    name: 'gesture-typing-filled',


                    keywords: ['手势输入', '手势打字'],
                },
                {
                    name: 'gesture-wipe-down-filled',


                    keywords: ['手势向下挥动', '向下挥手'],
                },
                {
                    name: 'gesture-up-filled',


                    keywords: ['手势向上', '手势上抬'],
                },
                {
                    name: 'undertake-delivery-filled',


                    keywords: ['承担交付', '负责送货'],
                },
                {
                    name: 'thumb-down-2-filled',


                    keywords: ['点赞', '点踩'],
                },
                {
                    name: 'undertake-environment-protection-filled',


                    keywords: ['承担环境保护', '进行环境保护'],
                },
                {
                    name: 'undertake-transaction-filled',


                    keywords: ['承担事务', '进行交易'],
                },
                {
                    name: 'thumb-down-1-filled',


                    keywords: ['拇指向下', '翘起大拇指表示不喜欢'],
                },
                {
                    name: 'undertake-hold-up-filled',


                    keywords: ['承担', '举行', '抢劫'],
                },
                {
                    name: 'gesture-up-and-down-filled',


                    keywords: ['手势上下', '手势上下来回'],
                },
                {
                    name: 'wave-bye-filled',


                    keywords: ['"Wave goodbye', 'say goodbye"'],
                },
                {
                    name: 'thumb-up-1-filled',


                    keywords: ['点赞', '翘起大拇指'],
                },
                {
                    name: 'thumb-up-2-filled',


                    keywords: ['点赞', '翘起大拇指'],
                },
                {
                    name: 'wave-left-filled',


                    keywords: ['波浪左', '左边波浪'],
                },
                {
                    name: 'undertake-filled',


                    keywords: ['承担', '执行'],
                },
                {
                    name: 'wave-right-filled',


                    keywords: ['右波浪', '右边波形'],
                },
            ],
        },
        Buildings: {
            labelCN: '建筑',
            labelEn: 'Buildings',
            icons: [
                {
                    name: 'archway-filled',


                    keywords: ['拱道,拱形通道'],
                },
                {
                    name: 'attic-1-filled',


                    keywords: ['屋顶室', '阁楼'],
                },
                {
                    name: 'archway-1-filled',


                    keywords: ['拱道,拱形通道'],
                },
                {
                    name: 'bridge-1-filled',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'architecture-hui-style-filled',


                    keywords: ['架构汇风格', '架构hui风格'],
                },
                {
                    name: 'bridge-5-filled',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'building-2-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'bridge-6-filled',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-2-filled',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'building-1-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'attic-filled',


                    keywords: ['屋顶室', '阁楼'],
                },
                {
                    name: 'building-3-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-1-filled',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'building-4-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-2-filled',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'building-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'building-5-filled',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-3-filled',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'castle-6-filled',


                    keywords: ['城堡', '城堡', '城堡'],
                },
                {
                    name: 'castle-5-filled',


                    keywords: ['城堡', '城堡', '城堡'],
                },
                {
                    name: 'castle-7-filled',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'castle-filled',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'chimney-filled',


                    keywords: ['烟囱', '炊烟'],
                },
                {
                    name: 'castle-4-filled',


                    keywords: ['城堡', '城堡建筑'],
                },
                {
                    name: 'chimney-2-filled',


                    keywords: ['烟囱', '炊烟'],
                },
                {
                    name: 'church-filled',


                    keywords: ['教堂', '礼拜场所'],
                },
                {
                    name: 'city-11-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-10-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-1-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-13-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-15-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-2-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'chimney-1-filled',


                    keywords: ['烟囱', '炊烟'],
                },
                {
                    name: 'city-5-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-12-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-6-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-4-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-14-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-3-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-9-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-7-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-ancient-2-filled',


                    keywords: ['城市古迹', '古代城市'],
                },
                {
                    name: 'curtain-filled',


                    keywords: ['窗帘', '帷幕'],
                },
                {
                    name: 'city-ancient-filled',


                    keywords: ['城市古迹', '古代城市'],
                },
                {
                    name: 'city-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'dam-1-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-3-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-5-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-7-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'city-ancient-1-filled',


                    keywords: ['城市古迹', '古代城市'],
                },
                {
                    name: 'dam-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'city-8-filled',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'dam-6-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-4-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'forest-filled',


                    keywords: ['森林,树林'],
                },
                {
                    name: 'dam-2-filled',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'hospital-1-filled',


                    keywords: ['医院', '诊所'],
                },
                {
                    name: 'ferris-wheel-filled',


                    keywords: ['"旋转木马', '摩天轮"'],
                },
                {
                    name: 'double-storey-filled',


                    keywords: ['双层住宅', '双层楼'],
                },
                {
                    name: 'mosque-1-filled',


                    keywords: ['清真寺', '清真寺'],
                },
                {
                    name: 'hospital-filled',


                    keywords: ['医院', '病院'],
                },
                {
                    name: 'monument-filled',


                    keywords: ['纪念碑,纪念建筑物'],
                },
                {
                    name: 'houses-2-filled',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'lighthouse-filled',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'houses-filled',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'lighthouse-1-filled',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'houses-1-filled',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'museum-1-filled',


                    keywords: ['博物馆', '博物馆', '美术馆'],
                },
                {
                    name: 'museum-2-filled',


                    keywords: ['博物馆', '美术馆'],
                },
                {
                    name: 'palace-2-filled',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'palace-1-filled',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'mosque-filled',


                    keywords: ['清真寺', '清真寺'],
                },
                {
                    name: 'museum-filled',


                    keywords: ['博物馆', '美术馆'],
                },
                {
                    name: 'palace-4-filled',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'palace-3-filled',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'opera-filled',


                    keywords: ['歌剧', '歌剧表演'],
                },
                {
                    name: 'pyramid-maya-filled',


                    keywords: ['金字塔-maya', '金字塔式maya'],
                },
                {
                    name: 'sailing-hotel-filled',


                    keywords: ['航海酒店', '航行旅馆'],
                },
                {
                    name: 'patio-filled',


                    keywords: ['露台', '庭院'],
                },
                {
                    name: 'pyramid-filled',


                    keywords: ['金字塔', '金字塔结构'],
                },
                {
                    name: 'shimen-filled',


                    keywords: ['石们', '石门'],
                },
                {
                    name: 'pearl-of-the-orient-filled',


                    keywords: ['东方之珠', '东方明珠'],
                },
                {
                    name: 'lighthouse-2-filled',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'shop-5-filled',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'statue-of-jesus-filled',


                    keywords: ['耶稣雕像', '耶稣塑像'],
                },
                {
                    name: 'shop-2-filled',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'teahouse-filled',


                    keywords: ['茶室', '茶馆'],
                },
                {
                    name: 'shop-4-filled',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'shop-3-filled',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'palace-filled',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'tower-1-filled',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-2-filled',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-filled',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-clock-filled',


                    keywords: ['钟楼,塔钟'],
                },
                {
                    name: 'window-1-filled',


                    keywords: ['窗户', '窗户'],
                },
                {
                    name: 'tower-3-filled',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'window-filled',


                    keywords: ['窗户', '窗户'],
                },
                {
                    name: 'town-filled',


                    keywords: ['"town', 'city" 或 "township', 'urban area"'],
                },
                {
                    name: 'temple-filled',


                    keywords: ['寺庙', '寺院'],
                },
                {
                    name: 'shop-1-filled',


                    keywords: ['商店', '铺子'],
                },
            ],
        },
        Document: {
            labelCN: '文档',
            labelEn: 'Document',
            icons: [
                {
                    name: 'chat-bubble-add-filled',


                    keywords: ['气泡添加', '添加聊天气泡'],
                },
                {
                    name: 'clear-filled',


                    keywords: ['清除', '澄清'],
                },
                {
                    name: 'add-circle-filled',


                    keywords: ['添加圆形', '画圆'],
                },
                {
                    name: 'clear-formatting-filled',


                    keywords: ['清除格式', '去除格式'],
                },
                {
                    name: 'chat-bubble-1-filled',


                    keywords: ['聊天气泡', '聊天泡泡'],
                },

                {
                    name: 'frame-filled',


                    keywords: ['框架', '结构'],
                },
                {
                    name: 'member-filled',


                    keywords: ['会员', '成员'],
                },
                {
                    name: 'filter-1-filled',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'merge-cells-filled',


                    keywords: ['合并单元格', '单元格合并'],
                },
                {
                    name: 'share-1-filled',


                    keywords: ['分享', '共享'],
                },
                {
                    name: 'quote-filled',


                    keywords: ['引号', '双引号', '符号'],
                },
                {
                    name: 'seal-filled',


                    keywords: ['印章', '封印'],
                },
            ],
        },
        Communication: {
            labelCN: '沟通',
            labelEn: 'Communication',
            icons: [
                {
                    name: 'chat-add-filled',


                    keywords: ['添加聊天', '聊天添加'],
                },
                {
                    name: 'chat-bubble-locked-filled',


                    keywords: ['聊天气泡被锁定', '聊天气泡被封锁'],
                },
                {
                    name: 'chat-bubble-history-filled',


                    keywords: ['聊天气泡历史', '聊天记录历史'],
                },
                {
                    name: 'chat-checked-filled',


                    keywords: ['已检查聊天记录', '已核对聊天记录'],
                },
                {
                    name: 'chat-error-filled',


                    keywords: ['聊天错误', '交流失误'],
                },
                {
                    name: 'chat-double-filled',


                    keywords: ['聊天双重', '双重聊天'],
                },
                {
                    name: 'chat-bubble-smile-filled',


                    keywords: ['聊天气泡微笑', '笑脸聊天泡'],
                },
                {
                    name: 'chat-heart-filled',


                    keywords: ['聊天之心', '心形聊天'],
                },
                {
                    name: 'chat-message-filled',


                    keywords: ['聊天信息', '聊天记录'],
                },
                {
                    name: 'chat-filled',


                    keywords: ['聊天', '对话'],
                },
                {
                    name: 'chat-clear-filled',


                    keywords: ['清空聊天记录', '清除聊天内容'],
                },
                {
                    name: 'chat-setting-filled',


                    keywords: ['聊天设置', '聊天配置'],
                },
                {
                    name: 'chat-poll-filled',


                    keywords: ['聊天投票', '聊天民意调查'],
                },
                {
                    name: 'questionnaire-filled',


                    keywords: ['问卷', '调查问卷'],
                },
                {
                    name: 'chat-off-filled',


                    keywords: ['聊关闭,聊天关闭'],
                },
                {
                    name: 'questionnaire-double-filled',


                    keywords: ['问卷双份', '双份问卷'],
                },
                {
                    name: 'tips-filled',


                    keywords: ['提示', '小费'],
                },
                {
                    name: 'chat-bubble-filled',


                    keywords: ['聊天气泡', '聊天泡泡'],
                },
                {
                    name: 'tips-double-filled',


                    keywords: ['提示双份', '提示双重'],
                },
            ],
        },
        File: {
            labelCN: '文件',
            labelEn: 'File',
            icons: [
                {
                    name: 'bill-filled',


                    keywords: ['帐单', '账单'],
                },
                {
                    name: 'book-open-filled',


                    keywords: ['书打开', '书翻开'],
                },
                {
                    name: 'book-unknown-filled',


                    keywords: ['书未知', '未知之书'],
                },
                {
                    name: 'collection-filled',


                    keywords: ['集合', '集合体'],
                },
                {
                    name: 'catalog-filled',


                    keywords: ['目录', '登记簿'],
                },
                {
                    name: 'copy-filled',


                    keywords: ['复制,拷贝'],
                },
                {
                    name: 'coupon-filled',


                    keywords: ['优惠券', '折扣券'],
                },
                {
                    name: 'certificate-filled',


                    keywords: ['证书', '证明书'],
                },
                {
                    name: 'course-filled',


                    keywords: ['课程', '教程'],
                },
                {
                    name: 'file-add-1-filled',


                    keywords: ['文件添加', '添加文件'],
                },
                {
                    name: 'file-add-filled',


                    keywords: ['文件添加', '添加文件'],
                },
                {
                    name: 'file-code-1-filled',


                    keywords: ['文件代码', '代码文件'],
                },
                {
                    name: 'file-code-filled',


                    keywords: ['文件代码', '代码文件'],
                },
                {
                    name: 'file-1-filled',


                    keywords: ['文件,档案'],
                },
                {
                    name: 'file-blocked-filled',


                    keywords: ['文件被阻止', '文件被屏蔽'],
                },
                {
                    name: 'file-copy-filled',


                    keywords: ['文件复制', '档案复制'],
                },
                {
                    name: 'file-export-filled',


                    keywords: ['文件导出', '文件输出'],
                },
                {
                    name: 'discount-filled',


                    keywords: ['折扣', '降价'],
                },
                {
                    name: 'file-download-filled',


                    keywords: ['文件下载', '下载文件'],
                },
                {
                    name: 'file-excel-filled',


                    keywords: ['文件', '电子表格', '表格文件'],
                },
                {
                    name: 'file-filled',


                    keywords: ['文件,档案'],
                },
                {
                    name: 'file-icon-filled',


                    keywords: ['文件图标', '文件图标'],
                },
                {
                    name: 'file-image-filled',


                    keywords: ['文件图片', '图片文件'],
                },
                {
                    name: 'file-import-filled',


                    keywords: ['文件导入', '档案汇入'],
                },
                {
                    name: 'file-music-filled',


                    keywords: ['音乐文件', '音频文件'],
                },
                {
                    name: 'file-locked-filled',


                    keywords: ['文件锁定', '文件被锁定'],
                },
                {
                    name: 'file-minus-filled',


                    keywords: ['文件减一', '文件移除一个'],
                },
                {
                    name: 'file-onenote-filled',


                    keywords: ['文件-onenote', '文件-onenote笔记'],
                },
                {
                    name: 'file-safety-filled',


                    keywords: ['文件安全', '安全性文件'],
                },
                {
                    name: 'file-outlook-filled',


                    keywords: ['文件 outlook', 'Outlook 文件'],
                },
                {
                    name: 'file-search-filled',


                    keywords: ['文件搜索', '查找文件'],
                },
                {
                    name: 'file-powerpoint-filled',


                    keywords: ['文件,PowerPoint,演示文稿'],
                },
                {
                    name: 'file-paste-filled',


                    keywords: ['文件粘贴', '档案贴上'],
                },
                {
                    name: 'file-pdf-filled',


                    keywords: ['文件-PDF', 'PDF文件'],
                },
                {
                    name: 'file-word-filled',


                    keywords: ['文件词', 'word 文件'],
                },
                {
                    name: 'file-transmit-double-filled',


                    keywords: ['文件传输双重', '文件传输双份'],
                },
                {
                    name: 'file-unknown-filled',


                    keywords: ['未知的文件', '不识别的文件'],
                },
                {
                    name: 'file-unlocked-filled',


                    keywords: ['文件未锁定', '文件解锁'],
                },
                {
                    name: 'file-teams-filled',


                    keywords: ['文件团队', '文件组'],
                },
                {
                    name: 'file-zip-filled',


                    keywords: ['文件压缩', '档案压缩'],
                },
                {
                    name: 'file-setting-filled',


                    keywords: ['文件设置', '文件配置'],
                },
                {
                    name: 'folder-1-filled',


                    keywords: ['文件夹', '档案夹'],
                },
                {
                    name: 'folder-add-1-filled',


                    keywords: ['添加文件夹', '文件夹添加'],
                },
                {
                    name: 'folder-blocked-filled',


                    keywords: ['文件夹被阻止', '文件夹受限制'],
                },
                {
                    name: 'folder-export-filled',


                    keywords: ['文件夹导出', '文件夹共享'],
                },
                {
                    name: 'folder-filled',


                    keywords: ['文件夹,档案夹'],
                },
                {
                    name: 'folder-details-filled',


                    keywords: ['文件夹详情', '文件夹信息'],
                },
                {
                    name: 'folder-import-filled',


                    keywords: ['文件夹导入', '文件夹引入'],
                },
                {
                    name: 'folder-add-filled',


                    keywords: ['添加文件夹', '添加快捷方式到文件夹'],
                },
                {
                    name: 'folder-locked-filled',


                    keywords: ['文件夹锁定', '文件夹被锁定'],
                },
                {
                    name: 'folder-move-filled',


                    keywords: ['文件夹移动', '文件夹迁移'],
                },
                {
                    name: 'file-transmit-filled',


                    keywords: ['文件传输', '文件传送'],
                },
                {
                    name: 'folder-off-filled',


                    keywords: ['文件夹关闭', '文件夹取消'],
                },
                {
                    name: 'folder-search-filled',


                    keywords: ['文件夹搜索', '文件夹查找'],
                },
                {
                    name: 'folder-open-1-filled',


                    keywords: ['文件夹打开', '文件夹展开'],
                },
                {
                    name: 'folder-open-filled',


                    keywords: ['文件夹打开', '文件夹展开'],
                },
                {
                    name: 'folder-setting-filled',


                    keywords: ['文件夹设置', '文件夹配置'],
                },
                {
                    name: 'folder-zip-filled',


                    keywords: ['文件夹压缩', '档案夹压缩'],
                },
                {
                    name: 'music-1-filled',


                    keywords: ['音乐', '歌曲'],
                },
                {
                    name: 'media-library-filled',


                    keywords: ['媒体库', '媒体资料库'],
                },
                {
                    name: 'music-2-filled',


                    keywords: ['乐谱', '音乐作品'],
                },
                {
                    name: 'folder-unlocked-filled',


                    keywords: ['文件夹未锁定', '文件夹解锁'],
                },
                {
                    name: 'paste-filled',


                    keywords: ['粘贴', '贴上'],
                },
                {
                    name: 'screen-4k-filled',


                    keywords: ['screen', '屏蔽', '筛选'],
                },
                {
                    name: 'folder-shared-filled',


                    keywords: ['文件夹共享', '文件夹共用'],
                },
                {
                    name: 'folder-minus-filled',


                    keywords: ['文件夹减一', '减一文件夹'],
                },
                {
                    name: 'task-add-filled',


                    keywords: ['任务添加', '添加任务'],
                },
                {
                    name: 'task-1-filled',


                    keywords: ['任务', '工作'],
                },
                {
                    name: 'subtitle-filled',


                    keywords: ['字幕', '字幕翻译'],
                },
                {
                    name: 'hd-filled',


                    keywords: ['高清', '高清晰度'],
                },
                {
                    name: 'task-double-filled',


                    keywords: ['任务加倍', '工作量翻倍'],
                },
                {
                    name: 'task-error-filled',


                    keywords: ['任务错误', '任务出错'],
                },
                {
                    name: 'task-filled',


                    keywords: ['任务', '工作'],
                },
                {
                    name: 'task-marked-filled',


                    keywords: ['任务标记', '任务打标'],
                },
                {
                    name: 'task-setting-filled',


                    keywords: ['任务设定', '任务设置'],
                },
                {
                    name: 'task-time-filled',


                    keywords: ['任务时间', '工作时长'],
                },
                {
                    name: 'ticket-filled',


                    keywords: ['票', '票据'],
                },
                {
                    name: 'template-filled',


                    keywords: ['模板', '模板', '模板', '模板', '模板'],
                },
                {
                    name: 'task-visible-filled',


                    keywords: ['任务可见', '任务可视'],
                },
                {
                    name: 'task-checked-filled',


                    keywords: ['任务完成', '任务检查'],
                },
                {
                    name: 'task-location-filled',


                    keywords: ['任务地点', '工作地点'],
                },
            ],
        },
        Arrows: {
            labelCN: '箭头',
            labelEn: 'Arrows',
            icons: [
                {
                    name: 'arrow-down-circle-filled',


                    keywords: ['箭头向下圆圈', '向下箭头圆圈'],
                },
                {
                    name: 'arrow-down-rectangle-filled',


                    keywords: ['箭头向下矩形', '箭头下矩形'],
                },
                {
                    name: 'arrow-left-right-circle-filled',


                    keywords: ['左右箭头圆圈', '左右箭头循环'],
                },
                {
                    name: 'arrow-left-down-circle-filled',


                    keywords: ['箭头向左下圆圈', '箭头左下方向圆圈'],
                },
                {
                    name: 'arrow-left-circle-filled',


                    keywords: ['向左箭头圆圈', '左向圆圈箭头'],
                },
                {
                    name: 'arrow-right-circle-filled',


                    keywords: ['箭头向右圆圈', '箭头右向圆圈'],
                },
                {
                    name: 'arrow-left-up-circle-filled',


                    keywords: ['箭头向左上圆圈', '箭头左上方圆形'],
                },
                {
                    name: 'backtop-rectangle-filled',


                    keywords: ['后顶矩形', '后部矩形'],
                },
                {
                    name: 'arrow-right-down-circle-filled',


                    keywords: ['箭头右下圆圈', '箭头右下方向', '右下角带箭头的圆圈'],
                },
                {
                    name: 'chevron-down-rectangle-filled',


                    keywords: ['箭头向下矩形', '箭头向下长方形'],
                },
                {
                    name: 'arrow-triangle-down-filled',


                    keywords: ['箭头三角形向下', '箭头三角向下'],
                },
                {
                    name: 'chevron-left-rectangle-filled',


                    keywords: ['"箭头左矩形', '左箭头矩形"'],
                },
                {
                    name: 'arrow-triangle-up-filled',


                    keywords: ['箭头向上三角形', '箭头在上三角'],
                },
                {
                    name: 'chevron-left-circle-filled',


                    keywords: [
                        '"chevron-left-circle" 可以翻译为以下两个中文短语：\n\n1. 左箭头的圆圈,\n2. 左向箭头的圆形符号',
                    ],
                },
                {
                    name: 'chevron-right-rectangle-filled',


                    keywords: ['箭头右矩形', '箭头右方矩形'],
                },
                {
                    name: 'arrow-right-up-circle-filled',


                    keywords: ['箭头向右上方循环', '箭头右上方旋转'],
                },
                {
                    name: 'arrow-up-down-circle-filled',


                    keywords: ['上箭头圆圈', '下箭头圆圈'],
                },
                {
                    name: 'chevron-right-circle-filled',


                    keywords: ['箭头向右圆圈', '右箭头圆圈'],
                },
                {
                    name: 'arrow-up-circle-filled',


                    keywords: ['箭头向上圆圈', '箭头朝上的圆圈'],
                },
                {
                    name: 'chevron-down-circle-filled',


                    keywords: ['箭头向下圆圈', '向下箭头圆圈'],
                },
                {
                    name: 'chevron-up-rectangle-filled',


                    keywords: ['箭头向上矩形', '箭头向上的长方形'],
                },
                {
                    name: 'chevron-up-circle-filled',


                    keywords: ['箭头向上圆圈', '箭头向上圆圈图标'],
                },
            ],
        },
        User: {
            labelCN: '用户',
            labelEn: 'User',
            icons: [
                {
                    name: 'cooperate-filled',


                    keywords: ['合作', '协作'],
                },
                {
                    name: 'certificate-1-filled',


                    keywords: ['证书', '证明书'],
                },
                {
                    name: 'personal-information-filled',


                    keywords: ['个人信息', '个人资料'],
                },
                {
                    name: 'flag-4-filled',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'user-1-filled',


                    keywords: ['用户', '顾客'],
                },
                {
                    name: 'user-arrow-down-filled',


                    keywords: ['用户向下箭头', '用户箭头向下'],
                },
                {
                    name: 'user-arrow-right-filled',


                    keywords: ['用户向右箭头', '用户右箭头'],
                },
                {
                    name: 'education-filled',


                    keywords: ['教育', '教育体制'],
                },
                {
                    name: 'user-arrow-left-filled',


                    keywords: ['用户向左箭头', '用户左箭头'],
                },
                {
                    name: 'user-add-filled',


                    keywords: ['添加用户', '增加用户'],
                },
                {
                    name: 'user-arrow-up-filled',


                    keywords: ['用户向上箭头', '用户上箭头'],
                },
                {
                    name: 'user-blocked-filled',


                    keywords: ['用户被阻止', '用户被屏蔽'],
                },
                {
                    name: 'user-checked-1-filled',


                    keywords: ['用户已勾选', '用户已检查'],
                },
                {
                    name: 'user-circle-filled',


                    keywords: ['用户圈', '用户圈子'],
                },
                {
                    name: 'user-avatar-filled',


                    keywords: ['用户头像', '用户图像'],
                },
                {
                    name: 'user-checked-filled',


                    keywords: ['用户已勾选', '用户已检查'],
                },
                {
                    name: 'user-business-filled',


                    keywords: ['用户业务', '顾客商业'],
                },
                {
                    name: 'user-clear-filled',


                    keywords: ['用户清除', '用户清理'],
                },
                {
                    name: 'user-error-1-filled',


                    keywords: ['用户错误', '误操作'],
                },
                {
                    name: 'user-filled',


                    keywords: ['用户', '顾客'],
                },
                {
                    name: 'user-invisible-filled',


                    keywords: ['用户不可见', '用户隐形'],
                },
                {
                    name: 'user-password-filled',


                    keywords: ['用户密码', '用户名与密码'],
                },
                {
                    name: 'user-marked-filled',


                    keywords: ['用户标记', '用户标注'],
                },
                {
                    name: 'user-setting-filled',


                    keywords: ['用户设置', '用户配置'],
                },
                {
                    name: 'user-list-filled',


                    keywords: ['用户列表', '用户清单'],
                },
                {
                    name: 'user-search-filled',


                    keywords: ['用户搜索', '搜寻用户'],
                },
                {
                    name: 'user-talk-1-filled',


                    keywords: ['用户讨论', '用户交流'],
                },
                {
                    name: 'user-locked-filled',


                    keywords: ['用户锁定', '用户被锁定'],
                },
                {
                    name: 'user-safety-filled',


                    keywords: ['用户安全', '安全性'],
                },
                {
                    name: 'user-time-filled',


                    keywords: ['用户时间', '耗时'],
                },
                {
                    name: 'user-unknown-filled',


                    keywords: ['未知用户', '未知之人'],
                },
                {
                    name: 'user-unlocked-filled',


                    keywords: ['用户解锁', '用户解除锁定'],
                },
                {
                    name: 'user-talk-off-1-filled',


                    keywords: ['用户禁言', '用户被禁言'],
                },
                {
                    name: 'user-transmit-filled',


                    keywords: ['用户传输', '用户传送'],
                },
                {
                    name: 'user-visible-filled',


                    keywords: ['用户可见的', '对用户可见'],
                },
                {
                    name: 'user-talk-filled',


                    keywords: ['用户讨论', '用户交流'],
                },
                {
                    name: 'usergroup-clear-filled',


                    keywords: ['用户组清除', '用户组清空'],
                },
                {
                    name: 'usergroup-add-filled',


                    keywords: ['用户组添加', '用户群组创建'],
                },
                {
                    name: 'verify-filled',


                    keywords: ['核实', '验证'],
                },
                {
                    name: 'usergroup-filled',


                    keywords: ['用户组', '用户群组'],
                },
                {
                    name: 'user-vip-filled',


                    keywords: ['用户会员', 'VIP用户'],
                },
            ],
        },
        Component: {
            labelCN: '组件',
            labelEn: 'Component',
            icons: [
                {
                    name: 'calendar-filled',


                    keywords: ['日历', '月份表'],
                },
                {
                    name: 'component-breadcrumb-filled',


                    keywords: ['面包屑组件', '路径导航组件'],
                },
                {
                    name: 'component-divider-horizontal-filled',


                    keywords: ['水平分隔组件', '水平组件分隔线'],
                },
                {
                    name: 'card-filled',


                    keywords: ['卡片', '牌'],
                },
                {
                    name: 'component-checkbox-filled',


                    keywords: ['组件复选框', '组件选择框'],
                },
                {
                    name: 'component-divider-vertical-filled',


                    keywords: ['垂直分隔组件', '垂直组件分割线'],
                },
                {
                    name: 'button-filled',


                    keywords: ['按钮', '按钮'],
                },
                {
                    name: 'chat-bubble-error-filled',


                    keywords: ['聊天气泡错误', '错误信息气泡'],
                },
                {
                    name: 'component-input-filled',


                    keywords: ['组件输入', '组件式输入'],
                },
                {
                    name: 'component-layout-filled',


                    keywords: ['组件布局', '组件排版'],
                },
                {
                    name: 'component-dropdown-filled',


                    keywords: ['组件下拉菜单', '组件下拉选择框'],
                },
                {
                    name: 'component-steps-filled',


                    keywords: ['组件步骤', '组件式步骤'],
                },
                {
                    name: 'component-space-filled',


                    keywords: ['组件空间', '组件领域'],
                },
                {
                    name: 'expand-down-filled',


                    keywords: ['展开向下', '展开收缩'],
                },
                {
                    name: 'form-filled',


                    keywords: ['表格', '表格形式'],
                },
                {
                    name: 'icon-filled',


                    keywords: ['图标', '图标', '图标', '图标'],
                },
                {
                    name: 'expand-up-filled',


                    keywords: ['扩展向上', '向上扩展'],
                },
                {
                    name: 'horizontal-filled',


                    keywords: ['水平线', '水平面'],
                },
                {
                    name: 'component-switch-filled',


                    keywords: ['组件开关', '组件式开关'],
                },
                {
                    name: 'page-head-filled',


                    keywords: ['页面头部', '页面顶端'],
                },
                {
                    name: 'menu-filled',


                    keywords: ['菜单', '菜单项'],
                },
                {
                    name: 'slideshow-filled',


                    keywords: ['幻灯片展示', '幻灯片演示'],
                },
                {
                    name: 'table-2-filled',


                    keywords: ['表格', '表格形式'],
                },
                {
                    name: 'tab-filled',


                    keywords: ['制表符', '表格符号'],
                },
                {
                    name: 'scroll-bar-filled',


                    keywords: ['滚动条', '滚动条'],
                },
                {
                    name: 'tag-filled',


                    keywords: ['标签', '标签'],
                },
                {
                    name: 'typography-filled',


                    keywords: ['排版', '字体设计'],
                },
                {
                    name: 'vertical-filled',


                    keywords: ['垂直的', '竖直的'],
                },
                {
                    name: 'component-grid-filled',


                    keywords: ['组件网格', '组件布局'],
                },
            ],
        },
        System: {
            labelCN: '系统',
            labelEn: 'System',
            icons: [
                {
                    name: 'add-rectangle-filled',


                    keywords: ['添加矩形', '绘制矩形'],
                },
                {
                    name: 'app-filled',


                    keywords: ['应用程序', '应用软件'],
                },
                {
                    name: 'check-rectangle-filled',


                    keywords: ['检查矩形', '校验矩形'],
                },
                {
                    name: 'dashboard-filled',


                    keywords: ['仪表板', '控制面板'],
                },
                {
                    name: 'application-filled',


                    keywords: ['应用程序', '应用程式'],
                },
                {
                    name: 'filter-off-filled',


                    keywords: ['过滤关闭', '过滤掉'],
                },
                {
                    name: 'filter-clear-filled',


                    keywords: ['过滤清除', '筛选清除'],
                },
                {
                    name: 'hard-disk-storage-filled',


                    keywords: ['硬盘存储', '硬盘储存'],
                },
                {
                    name: 'filter-sort-filled',


                    keywords: ['过滤排序', '筛选排序'],
                },
                {
                    name: 'hourglass-filled',


                    keywords: ['沙漏', '时计'],
                },
                {
                    name: 'mail-filled',


                    keywords: ['邮件', '邮件通讯'],
                },
                {
                    name: 'logo-windows-filled',


                    keywords: ['"logo-windows', 'windows徽标"'],
                },
                {
                    name: 'minus-rectangle-filled',


                    keywords: ['负矩形', '减矩形'],
                },
                {
                    name: 'filter-filled',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'system-application-filled',


                    keywords: ['系统应用', '应用程序系统'],
                },
                {
                    name: 'service-filled',


                    keywords: ['服务', '服务项目'],
                },
                {
                    name: 'relativity-filled',


                    keywords: ['相对论', '相对性理论'],
                },
                {
                    name: 'system-3-filled',


                    keywords: ['系统', '体系'],
                },
                {
                    name: 'queue-filled',


                    keywords: ['队列', '排队'],
                },
                {
                    name: 'share-filled',


                    keywords: ['分享', '共享'],
                },
                {
                    name: 'system-components-filled',


                    keywords: ['系统组件', '系统组成部件'],
                },
                {
                    name: 'system-coordinate-filled',


                    keywords: ['系统坐标', '系统坐标系'],
                },
                {
                    name: 'system-blocked-filled',


                    keywords: ['系统阻塞', '禁用系统'],
                },
                {
                    name: 'system-interface-filled',


                    keywords: ['系统接口', '系统界面'],
                },
                {
                    name: 'control-platform-filled',


                    keywords: ['控制平台', '控制面板'],
                },
                {
                    name: 'system-device-filled',


                    keywords: ['系统设备', '机器装置'],
                },
                {
                    name: 'system-log-filled',


                    keywords: ['系统日志', '系统记录'],
                },
                {
                    name: 'system-code-filled',


                    keywords: ['系统代码', '系统编码'],
                },
                {
                    name: 'system-marked-filled',


                    keywords: ['系统标记', '系统打标'],
                },
                {
                    name: 'system-search-filled',


                    keywords: ['系统搜索', '系统查找'],
                },
                {
                    name: 'system-locked-filled',


                    keywords: ['系统锁定', '操作系统锁定'],
                },
                {
                    name: 'system-messages-filled',


                    keywords: ['系统消息', '系统信息'],
                },
                {
                    name: 'system-location-filled',


                    keywords: ['系统位置', '设备位置'],
                },
                {
                    name: 'system-regulation-filled',


                    keywords: ['系统调节', '制度性规定'],
                },
                {
                    name: 'system-setting-filled',


                    keywords: ['系统设置', '系统设定'],
                },
                {
                    name: 'view-module-filled',


                    keywords: ['视图模块', '视图组件'],
                },
                {
                    name: 'system-unlocked-filled',


                    keywords: ['系统解锁', '解锁系统'],
                },
                {
                    name: 'system-storage-filled',


                    keywords: ['系统存储', '储存系统'],
                },
            ],
        },
        Alert: {
            labelCN: '警报',
            labelEn: 'Alert',
            icons: [
                {
                    name: 'close-circle-filled',


                    keywords: ['闭环', '闭路'],
                },
                {
                    name: 'check-circle-filled',


                    keywords: ['圆圈复选', '勾选圆圈'],
                },
                {
                    name: 'close-octagon-filled',


                    keywords: ['八角形闭口,闭式八角形'],
                },
                {
                    name: 'error-circle-filled',


                    keywords: ['错误圆圈', '错误圈'],
                },
                {
                    name: 'delete-time-filled',


                    keywords: ['删除时间', '删除时刻', '垃圾桶'],
                },
                {
                    name: 'help-circle-filled',


                    keywords: ['帮助圈', '支援圈'],
                },
                {
                    name: 'minus-circle-filled',


                    keywords: ['负圈,减圆'],
                },
                {
                    name: 'error-triangle-filled',


                    keywords: ['错误三角形', '错误三角'],
                },
                {
                    name: 'notification-add-filled',


                    keywords: ['通知添加', '添加通知', '铃铛'],
                },
                {
                    name: 'info-circle-filled',


                    keywords: ['信息圈', '资讯圈'],
                },
                {
                    name: 'shield-error-filled',


                    keywords: ['盾牌错误', '盾形错误'],
                },
                {
                    name: 'time-filled',


                    keywords: ['时光', '时间'],
                },
                {
                    name: 'notification-error-filled',


                    keywords: ['通知错误', '错误通知', '铃铛'],
                },
                {
                    name: 'notification-filled',


                    keywords: ['通知', '通报', '铃铛'],
                },
            ],
        },
        Emoji: {
            labelCN: '表情',
            labelEn: 'Emoji',
            icons: [
                {
                    name: 'angry-filled',


                    keywords: ['生气', '愤怒'],
                },
                {
                    name: 'awkward-filled',


                    keywords: ['尴尬', '不自在'],
                },
                {
                    name: 'bad-laugh-filled',


                    keywords: [],
                },
                {
                    name: 'calm-filled',


                    keywords: ['宁静', '平静'],
                },
                {
                    name: 'calm-1-filled',


                    keywords: ['冷静', '平静'],
                },
                {
                    name: 'crack-filled',


                    keywords: ['裂痕', '缝隙'],
                },
                {
                    name: 'depressed-filled',


                    keywords: ['沮丧的', '情绪低落的'],
                },
                {
                    name: 'crooked-smile-filled',


                    keywords: ['歪嘴笑', '歪斜的微笑'],
                },
                {
                    name: 'despise-filled',


                    keywords: ['轻视', '鄙视'],
                },
                {
                    name: 'doge-filled',


                    keywords: ['狗狗', '狗的'],
                },
                {
                    name: 'dissatisfaction-filled',


                    keywords: ['不满意', '不满'],
                },
                {
                    name: 'cat-filled',


                    keywords: ['猫', '猫科动物'],
                },
                {
                    name: 'cry-loudly-filled',


                    keywords: ['大声哭泣', '哭出声来'],
                },
                {
                    name: 'emo-emotional-filled',


                    keywords: ['情绪化', '感性'],
                },
                {
                    name: 'feel-at-ease-filled',


                    keywords: ['感觉自在', '感到舒适'],
                },
                {
                    name: 'excited-filled',


                    keywords: ['激动的', '兴奋的'],
                },
                {
                    name: 'flip-smiling-face-filled',


                    keywords: ['翻白眼', '微笑脸'],
                },
                {
                    name: 'ferocious-filled',


                    keywords: ['凶猛的', '激烈的'],
                },
                {
                    name: 'giggle-filled',


                    keywords: ['“咯咯笑”', '“哈哈大笑”'],
                },
                {
                    name: 'excited-1-filled',


                    keywords: ['激动的', '兴奋的'],
                },
                {
                    name: 'happy-filled',


                    keywords: ['快乐', '高兴'],
                },
                {
                    name: 'pout-filled',


                    keywords: ['噘嘴', '嘟囔'],
                },
                {
                    name: 'joyful-filled',


                    keywords: ['欢乐的', '快乐的'],
                },
                {
                    name: 'open-mouth-filled',


                    keywords: ['张嘴', '咧嘴'],
                },
                {
                    name: 'serenity-filled',


                    keywords: ['宁静', '安详'],
                },
                {
                    name: 'cry-and-laugh-filled',


                    keywords: ['哭笑不得', '啼笑皆非'],
                },
                {
                    name: 'look-around-filled',


                    keywords: ['环顾四周', '四处看看'],
                },
                {
                    name: 'shutup-filled',


                    keywords: ['闭嘴', '别说话'],
                },
                {
                    name: 'sleep-filled',


                    keywords: ['睡觉', '睡眠'],
                },
                {
                    name: 'roast-filled',


                    keywords: ['烤', '烧烤'],
                },
                {
                    name: 'sinister-smile-filled',


                    keywords: ['邪恶的微笑', '阴险的笑容'],
                },
                {
                    name: 'smile-filled',


                    keywords: ['微笑', '笑容'],
                },
                {
                    name: 'sneer-filled',


                    keywords: ['讥讽', '冷笑'],
                },
                {
                    name: 'speechless-1-filled',


                    keywords: ['哑口无言', '说不出话来'],
                },
                {
                    name: 'surprised-1-filled',


                    keywords: ['吃惊', '惊讶'],
                },
                {
                    name: 'surprised-filled',


                    keywords: ['吃惊', '惊讶'],
                },
                {
                    name: 'speechless-filled',


                    keywords: ['哑口无言', '说不出话来'],
                },
                {
                    name: 'swear-2-filled',


                    keywords: ['发誓', '咒语'],
                },
                {
                    name: 'swear-1-filled',


                    keywords: ['发誓', '咒语'],
                },
                {
                    name: 'uncomfortable-2-filled',


                    keywords: ['不舒适的', '不自在的'],
                },
                {
                    name: 'uncomfortable-filled',


                    keywords: ['不舒适', '不自在'],
                },
                {
                    name: 'unhappy-1-filled',


                    keywords: ['不开心的', '不高兴的'],
                },
                {
                    name: 'uncomfortable-1-filled',


                    keywords: ['不舒适', '不自在'],
                },
                {
                    name: 'wink-filled',


                    keywords: ['眨眼', '频眨眼'],
                },
                {
                    name: 'no-expression-filled',


                    keywords: ['无表达式', '不表达式'],
                },
                {
                    name: 'wry-smile-filled',


                    keywords: ['歪嘴笑', '嘴角上扬'],
                },
                {
                    name: 'unhappy-filled',


                    keywords: ['不开心的', '不高兴的'],
                },
            ],
        },
        Action: {
            labelCN: '行动',
            labelEn: 'Action',
            icons: [
                {
                    name: 'alarm-add-filled',


                    keywords: ['添加闹钟', '增加闹钟'],
                },
                {
                    name: 'address-book-filled',


                    keywords: ['通讯录', '电话簿'],
                },
                {
                    name: 'alarm-off-filled',


                    keywords: ['闹钟关闭', '取消闹钟'],
                },
                {
                    name: 'alarm-filled',


                    keywords: ['闹钟', '警报'],
                },
                {
                    name: 'article-filled',


                    keywords: ['文章', '文章内容'],
                },
                {
                    name: 'assignment-checked-filled',


                    keywords: ['作业检查', '任务核对'],
                },
                {
                    name: 'accessibility-filled',


                    keywords: ['无障碍', '访问便利'],
                },
                {
                    name: 'assignment-error-filled',


                    keywords: ['作业错误', '分配错误'],
                },
                {
                    name: 'assignment-code-filled',


                    keywords: ['作业代码', '分配代码'],
                },
                {
                    name: 'backup-filled',


                    keywords: ['备份', '数据备份'],
                },
                {
                    name: 'assignment-user-filled',


                    keywords: ['作业用户', '分配用户'],
                },
                {
                    name: 'assignment-filled',


                    keywords: ['作业', '分配任务'],
                },
                {
                    name: 'bookmark-add-filled',


                    keywords: ['书签添加', '添加书签'],
                },
                {
                    name: 'bookmark-double-filled',


                    keywords: ['书签双重', '双重书签'],
                },
                {
                    name: 'analytics-filled',


                    keywords: ['分析', '剖析'],
                },
                {
                    name: 'book-filled',


                    keywords: ['书,书籍'],
                },
                {
                    name: 'bookmark-minus-filled',


                    keywords: ['书签减一', '书签减号'],
                },
                {
                    name: 'browse-off-filled',


                    keywords: ['浏览关闭', '浏览退出'],
                },
                {
                    name: 'bug-report-filled',


                    keywords: ['错误报告', '错误报告'],
                },
                {
                    name: 'calendar-event-filled',


                    keywords: ['日历事件', '事件日历'],
                },
                {
                    name: 'browse-gallery-filled',


                    keywords: ['浏览图库', '查看图库'],
                },
                {
                    name: 'bookmark-filled',


                    keywords: ['书签', '书签'],
                },
                {
                    name: 'calendar-1-filled',


                    keywords: ['日历', '月份表'],
                },
                {
                    name: 'calendar-2-filled',


                    keywords: ['日历', '时间表'],
                },
                {
                    name: 'calendar-edit-filled',


                    keywords: ['日历编辑', '日程安排编辑'],
                },
                {
                    name: 'cart-add-filled',


                    keywords: ['购物车添加', '添加到购物车'],
                },
                {
                    name: 'chart-add-filled',


                    keywords: ['图表添加', '图表新增'],
                },
                {
                    name: 'cart-filled',


                    keywords: ['购物车', '购物篮'],
                },
                {
                    name: 'chart-filled',


                    keywords: ['图表', '表格'],
                },
                {
                    name: 'browse-filled',


                    keywords: ['浏览', '浏览网页'],
                },
                {
                    name: 'bookmark-checked-filled',


                    keywords: ['已标记为已读', '已加书签'],
                },
                {
                    name: 'close-rectangle-filled',


                    keywords: ['闭合矩形', '关闭矩形'],
                },
                {
                    name: 'chat-bubble-help-filled',


                    keywords: ['气泡帮助', '聊天帮助气泡'],
                },
                {
                    name: 'copyright-filled',


                    keywords: ['版权', '著作权'],
                },
                {
                    name: 'creditcard-filled',


                    keywords: ['信用卡', '信用卡通'],
                },
                {
                    name: 'cardmembership-filled',


                    keywords: ['卡片会员资格', '会员卡资格'],
                },
                {
                    name: 'color-invert-filled',


                    keywords: ['色彩反转', '颜色颠倒'],
                },
                {
                    name: 'creditcard-add-filled',


                    keywords: ['信用卡添加', '添加信用卡'],
                },
                {
                    name: 'dashboard-1-filled',


                    keywords: ['仪表板', '控制面板'],
                },
                {
                    name: 'delete-1-filled',


                    keywords: ['删除', '删去', '垃圾桶'],
                },
                {
                    name: 'explore-filled',


                    keywords: ['探索', '调查'],
                },
                {
                    name: 'creditcard-off-filled',


                    keywords: ['信用卡关闭', '信用卡停用'],
                },
                {
                    name: 'edit-off-filled',


                    keywords: ['关闭编辑', '禁用编辑'],
                },
                {
                    name: 'explore-off-filled',


                    keywords: ['探索关闭', '探索离线'],
                },
                {
                    name: 'edit-filled',


                    keywords: ['编辑', '校正'],
                },
                {
                    name: 'extension-off-filled',


                    keywords: ['扩展关闭', '扩展禁用'],
                },
                {
                    name: 'fact-check-filled',


                    keywords: ['事实核查', '事实查证'],
                },
                {
                    name: 'file-attachment-filled',


                    keywords: ['文件附件', '附件文件'],
                },
                {
                    name: 'file-restore-filled',


                    keywords: ['文件恢复', '档案还原'],
                },
                {
                    name: 'flag-2-filled',


                    keywords: ['国旗', '旗帜'],
                },
                {
                    name: 'extension-filled',


                    keywords: ['扩展', '拓展'],
                },
                {
                    name: 'flag-filled',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'flight-takeoff-filled',


                    keywords: ['飞机起飞', '起飞航班'],
                },
                {
                    name: 'flag-1-filled',


                    keywords: ['国旗', '旗帜'],
                },
                {
                    name: 'flag-3-filled',


                    keywords: ['国旗', '旗帜'],
                },
                {
                    name: 'flip-to-back-filled',


                    keywords: ['翻转背面的', '翻到背面'],
                },
                {
                    name: 'gift-filled',


                    keywords: ['礼物', '赠品'],
                },
                {
                    name: 'delete-filled',


                    keywords: ['删除', '删去', '垃圾桶'],
                },
                {
                    name: 'heart-filled',


                    keywords: ['心情', '心脏'],
                },
                {
                    name: 'home-filled',


                    keywords: ['家园', '家乡'],
                },
                {
                    name: 'grid-add-filled',


                    keywords: ['网格添加', '网格新增'],
                },
                {
                    name: 'grid-view-filled',


                    keywords: ['网格视图', '网格布局'],
                },
                {
                    name: 'https-filled',


                    keywords: ['超文本传输协议,安全超文本传输协议'],
                },
                {
                    name: 'help-rectangle-filled',


                    keywords: ['帮助矩形', '辅助矩形'],
                },
                {
                    name: 'install-desktop-filled',


                    keywords: ['安装桌面', '桌面安装'],
                },
                {
                    name: 'flip-to-front-filled',


                    keywords: ['翻转正面', '翻到正面'],
                },
                {
                    name: 'internet-filled',


                    keywords: ['因特网', '互联网'],
                },
                {
                    name: 'institution-filled',


                    keywords: ['机构', '机构单位'],
                },
                {
                    name: 'flight-landing-filled',


                    keywords: ['航班降落', '飞行着陆'],
                },
                {
                    name: 'institution-checked-filled',


                    keywords: ['机构审核', '机构核查'],
                },
                {
                    name: 'key-filled',


                    keywords: ['密钥', '密钥信息'],
                },
                {
                    name: 'install-mobile-filled',


                    keywords: ['安装手机', '手机安装'],
                },
                {
                    name: 'leaderboard-filled',


                    keywords: ['排行榜', '得分榜'],
                },
                {
                    name: 'lighting-circle-filled',


                    keywords: ['灯光圈', '灯光圆'],
                },
                {
                    name: 'lock-on-filled',


                    keywords: ['锁定', '开锁'],
                },
                {
                    name: 'lightbulb-filled',


                    keywords: ['电灯泡', '灯泡'],
                },
                {
                    name: 'location-1-filled',


                    keywords: ['位置', '所在地'],
                },
                {
                    name: 'lock-time-filled',


                    keywords: ['锁定时间', '上锁时间'],
                },
                {
                    name: 'mark-as-unread-filled',


                    keywords: ['标记为未读', '设为未读'],
                },
                {
                    name: 'lock-off-filled',


                    keywords: ['锁定关闭', '封锁关闭'],
                },
                {
                    name: 'mobile-shortcut-filled',


                    keywords: ['移动快捷方式', '手机快捷方式'],
                },
                {
                    name: 'mobile-blocked-filled',


                    keywords: ['手机被屏蔽', '手机被限制'],
                },
                {
                    name: 'money-filled',


                    keywords: ['"资金', '财富"'],
                },
                {
                    name: 'module-filled',


                    keywords: ['模块', '模组'],
                },
                {
                    name: 'mobile-list-filled',


                    keywords: ['移动列表', '流动清单'],
                },
                {
                    name: 'notification-circle-filled',


                    keywords: ['通知圆圈', '圆形通知', '铃铛'],
                },
                {
                    name: 'print-filled',


                    keywords: ['打印', '输出'],
                },
                {
                    name: 'saving-pot-filled',


                    keywords: ['"saving pot', '储蓄罐"'],
                },
                {
                    name: 'search-filled',


                    keywords: ['搜索', '搜寻'],
                },
                {
                    name: 'search-error-filled',


                    keywords: ['搜索错误', '搜索失误'],
                },
                {
                    name: 'outbox-filled',


                    keywords: ['发件箱', '发件文件夹'],
                },
                {
                    name: 'secured-filled',


                    keywords: [],
                },
                {
                    name: 'lightbulb-circle-filled',


                    keywords: ['电灯泡,圆形', '电球', '灯泡', '圈形'],
                },
                {
                    name: 'rocket-filled',


                    keywords: ['火箭', '航天器'],
                },
                {
                    name: 'pending-filled',


                    keywords: ['待处理', '待决'],
                },
                {
                    name: 'send-filled',


                    keywords: ['发送', '传送'],
                },
                {
                    name: 'send-cancel-filled',


                    keywords: ['发送取消', '发出取消'],
                },
                {
                    name: 'setting-1-filled',


                    keywords: ['设置', '配置'],
                },
                {
                    name: 'setting-filled',


                    keywords: ['设置', '配置'],
                },
                {
                    name: 'shop-filled',


                    keywords: ['商店', '铺子'],
                },
                {
                    name: 'star-filled',


                    keywords: ['星星', '星星们'],
                },
                {
                    name: 'sticky-note-filled',


                    keywords: ['便利贴', '粘性便签'],
                },
                {
                    name: 'terminal-rectangle-1-filled',


                    keywords: ['终端矩形', '终端长方形'],
                },
                {
                    name: 'theaters-filled',


                    keywords: ['剧院,电影院,演出场所,剧场'],
                },
                {
                    name: 'thumb-down-filled',


                    keywords: ['点赞', '点踩'],
                },
                {
                    name: 'support-filled',


                    keywords: ['支持', '支援'],
                },
                {
                    name: 'thumb-up-filled',


                    keywords: ['点赞', '翘起大拇指'],
                },
                {
                    name: 'server-filled',


                    keywords: ['服务器', '服务器'],
                },
                {
                    name: 'tools-filled',


                    keywords: ['工具', '器具'],
                },
                {
                    name: 'verified-filled',


                    keywords: ['验证过的', '已核实的'],
                },
                {
                    name: 'view-agenda-filled',


                    keywords: ['日程视图', '议程视图'],
                },
                {
                    name: 'vehicle-filled',


                    keywords: ['车辆', '轿车'],
                },
                {
                    name: 'tools-circle-filled',


                    keywords: ['工具圈', '工具之圈'],
                },
                {
                    name: 'view-in-ar-filled',


                    keywords: ['增强现实查看', '扩增实境视野'],
                },
                {
                    name: 'wallet-filled',


                    keywords: ['皮夹', '钱包'],
                },
                {
                    name: 'work-filled',


                    keywords: ['工作', '作业'],
                },
                {
                    name: 'store-filled',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'wealth-filled',


                    keywords: ['财富', '财产'],
                },
                {
                    name: 'work-history-filled',


                    keywords: ['工作经历', '工作历程'],
                },
                {
                    name: 'zoom-in-filled',


                    keywords: ['放大', '放大视野'],
                },
                {
                    name: 'wealth-1-filled',


                    keywords: ['财富', '财产'],
                },
                {
                    name: 'work-off-filled',


                    keywords: ['工作休息', '休息工作'],
                },
                {
                    name: 'zoom-out-filled',


                    keywords: ['缩小', '缩小尺寸'],
                },
            ],
        },
        Device: {
            labelCN: '设备',
            labelEn: 'Device',
            icons: [
                {
                    name: 'battery-add-filled',


                    keywords: ['电池添加', '添加电池'],
                },
                {
                    name: 'airplay-wave-filled',


                    keywords: ['AirPlay波形', 'AirPlay声波'],
                },
                {
                    name: 'battery-filled',


                    keywords: ['电池', '电池组'],
                },
                {
                    name: 'audio-filled',


                    keywords: ['音频', '声音'],
                },
                {
                    name: 'battery-charging-filled',


                    keywords: ['电池充电', '蓄电池充电'],
                },
                {
                    name: 'call-1-filled',


                    keywords: ['调用', '呼叫'],
                },
                {
                    name: 'call-cancel-filled',


                    keywords: ['取消呼叫', '撤销调用'],
                },
                {
                    name: 'call-filled',


                    keywords: ['调用', '呼叫'],
                },
                {
                    name: 'battery-low-filled',


                    keywords: ['电量低', '低电量'],
                },
                {
                    name: 'call-incoming-filled',


                    keywords: ['来电', '来电接入'],
                },
                {
                    name: 'camera-filled',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'camera-off-filled',


                    keywords: ['相机关闭', '关闭相机'],
                },
                {
                    name: 'call-off-filled',


                    keywords: ['取消订单', '撤回订单'],
                },
                {
                    name: 'call-forwarded-filled',


                    keywords: ['呼叫转发', '转发呼叫'],
                },
                {
                    name: 'cpu-filled',


                    keywords: ['中央处理器', '电脑处理器'],
                },
                {
                    name: 'cast-filled',


                    keywords: ['投掷', '投掷动作'],
                },
                {
                    name: 'data-error-filled',


                    keywords: ['数据错误', '错误数据'],
                },
                {
                    name: 'data-checked-filled',


                    keywords: ['已检查', '已勾选'],
                },
                {
                    name: 'data-base-filled',


                    keywords: ['数据库', '数据库系统'],
                },
                {
                    name: 'desktop-1-filled',


                    keywords: ['桌面', '桌面环境'],
                },
                {
                    name: 'data-search-filled',


                    keywords: ['数据搜索', '搜寻数据'],
                },
                {
                    name: 'film-filled',


                    keywords: ['胶卷', '电影胶片'],
                },
                {
                    name: 'data-filled',


                    keywords: ['数据', '资讯'],
                },
                {
                    name: 'gamepad-filled',


                    keywords: ['游戏手柄', '游戏控制器'],
                },
                {
                    name: 'desktop-filled',


                    keywords: ['桌面', '桌面环境'],
                },
                {
                    name: 'flashlight-filled',


                    keywords: ['手电筒', '手电筒'],
                },
                {
                    name: 'device-filled',


                    keywords: ['设备', '装置'],
                },
                {
                    name: 'hotspot-wave-filled',


                    keywords: ['热点波', '热点波浪'],
                },
                {
                    name: 'install-filled',


                    keywords: ['安装', '装置'],
                },
                {
                    name: 'hard-drive-filled',


                    keywords: ['硬盘驱动器', '硬盘'],
                },
                {
                    name: 'mobile-filled',


                    keywords: ['移动电话', '行动电话'],
                },
                {
                    name: 'mobile-vibrate-filled',


                    keywords: ['手机振动', '手机震动模式'],
                },
                {
                    name: 'gps-filled',


                    keywords: ['全球定位系统', '导航系统'],
                },
                {
                    name: 'keyboard-filled',


                    keywords: ['键盘', '键盘', '键盘', '键盘'],
                },
                {
                    name: 'mode-dark-filled',


                    keywords: ['暗黑模式,深色主题'],
                },
                {
                    name: 'phone-locked-filled',


                    keywords: ['手机锁定', '禁用电话'],
                },
                {
                    name: 'mode-light-filled',


                    keywords: ['模式轻型', '模式亮型'],
                },
                {
                    name: 'phone-search-filled',


                    keywords: ['手机搜索', '查找手机'],
                },
                {
                    name: 'router-wave-filled',


                    keywords: ['路由波动', '路由波动'],
                },
                {
                    name: 'rotate-locked-filled',


                    keywords: ['旋转锁定', '旋转上锁'],
                },
                {
                    name: 'save-filled',


                    keywords: ['保存', '存储'],
                },
                {
                    name: 'mouse-filled',


                    keywords: ['鼠标', '鼠标器'],
                },
                {
                    name: 'sim-card-1-filled',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'sim-card-2-filled',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'laptop-filled',


                    keywords: ['笔记本电脑', '便携式电脑'],
                },
                {
                    name: 'remote-wave-filled',


                    keywords: ['远程波动', '远程波'],
                },
                {
                    name: 'tv-2-filled',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'sim-card-filled',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'tv-1-filled',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'tv-filled',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'sd-card-filled',


                    keywords: ['SD卡', '存储卡'],
                },
                {
                    name: 'usb-filled',


                    keywords: ['通用串行总线', 'USB'],
                },
                {
                    name: 'watch-filled',


                    keywords: ['看', '监视'],
                },
                {
                    name: 'wifi-1-filled',


                    keywords: ['无线网络', '无线互联网'],
                },
                {
                    name: 'wifi-off-1-filled',


                    keywords: ['关闭wifi', '关闭无线网络'],
                },
                {
                    name: 'uninstall-filled',


                    keywords: ['卸载', '取消安装'],
                },
                {
                    name: 'widget-filled',


                    keywords: ['部件', '组件'],
                },
                {
                    name: 'video-camera-filled',


                    keywords: ['video camera', '摄像机'],
                },
            ],
        },
        Design: {
            labelCN: '设计',
            labelEn: 'Design',
            icons: [
                {
                    name: 'brush-filled',


                    keywords: ['画笔', '画笔', '毛笔'],
                },
                {
                    name: 'collage-filled',


                    keywords: ['拼贴画', '拼贴'],
                },
                {
                    name: 'anticlockwise-filled',


                    keywords: ['逆时针', '逆时针方向'],
                },
                {
                    name: 'contrast-filled',


                    keywords: ['对比', '强烈对比'],
                },
                {
                    name: 'clear-formatting-1-filled',


                    keywords: ['清除格式', '去除格式'],
                },
                {
                    name: 'edit-1-filled',


                    keywords: ['编辑', '校正'],
                },
                {
                    name: 'edit-2-filled',


                    keywords: ['编辑,校订'],
                },
                {
                    name: 'focus-filled',


                    keywords: ['焦点', '焦点集中'],
                },
                {
                    name: 'fill-color-filled',


                    keywords: ['填充颜色', '着色填充'],
                },
                {
                    name: 'frame-1-filled',


                    keywords: ['框架', '结构'],
                },
                {
                    name: 'layout-filled',


                    keywords: ['布局', '排列'],
                },
                {
                    name: 'ink-filled',


                    keywords: ['墨水', '墨水', '染料', '颜料'],
                },
                {
                    name: 'measurement-2-filled',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'layers-filled',


                    keywords: ['层', '层次'],
                },
                {
                    name: 'pen-ball-filled',


                    keywords: ['"pen ball', '乒乓球', '弹球"'],
                },
                {
                    name: 'palette-1-filled',


                    keywords: ['调色板', '色彩面板'],
                },
                {
                    name: 'pen-brush-filled',


                    keywords: ['笔刷', '毛笔'],
                },
                {
                    name: 'pen-mark-filled',


                    keywords: ['笔迹', '笔记'],
                },
                {
                    name: 'mirror-filled',


                    keywords: ['镜子', '镜子的反面'],
                },
                {
                    name: 'root-list-filled',


                    keywords: ['根列表', '根目录列表'],
                },
                {
                    name: 'pen-filled',


                    keywords: ['钢笔', '毛笔'],
                },
                {
                    name: 'sip-filled',


                    keywords: [
                        '"sip"可以翻译为以下两个中文短语：\n\n1. 小口喝', '啜饮\n2. 吸饮', '轻啜',
                    ],
                },
                {
                    name: 'textbox-filled',


                    keywords: ['文本框', '输入框'],
                },
                {
                    name: 'slice-filled',


                    keywords: ['片断', '部分'],
                },
                {
                    name: 'transform-1-filled',


                    keywords: ['转变', '转换'],
                },
                {
                    name: 'pen-quill-filled',


                    keywords: ['钢笔', '毛笔'],
                },
                {
                    name: 'table-1-filled',


                    keywords: ['桌子', '餐桌'],
                },
            ],
        },
        Foods: {
            labelCN: '食品',
            labelEn: 'Foods',
            icons: [
                {
                    name: 'banana-filled',


                    keywords: ['香蕉', '香蕉的'],
                },
                {
                    name: 'bamboo-shoot-filled',


                    keywords: ['竹笋', '竹的嫩芽'],
                },
                {
                    name: 'bean-filled',


                    keywords: ['豆子', '豆荚'],
                },
                {
                    name: 'bread-filled',


                    keywords: ['面包', '面包'],
                },
                {
                    name: 'apple-filled',


                    keywords: ['苹果', '苹果公司'],
                },
                {
                    name: 'cabbage-filled',


                    keywords: ['卷心菜', '包菜'],
                },
                {
                    name: 'beer-filled',


                    keywords: ['啤酒', '啤酒', '啤酒'],
                },
                {
                    name: 'barbecue-filled',


                    keywords: ['烧烤', '烤肉'],
                },
                {
                    name: 'broccoli-filled',


                    keywords: ['西兰花', '花椰菜'],
                },
                {
                    name: 'cake-filled',


                    keywords: ['蛋糕', '糕点'],
                },
                {
                    name: 'cheese-filled',


                    keywords: ['奶酪', '芝士'],
                },
                {
                    name: 'cherry-filled',


                    keywords: ['樱桃', '樱桃树'],
                },
                {
                    name: 'bone-filled',


                    keywords: ['骨头', '骨骼'],
                },
                {
                    name: 'corn-filled',


                    keywords: ['玉米,玉蜀黍'],
                },
                {
                    name: 'chinese-cabbage-filled',


                    keywords: ['白菜', '中国白菜'],
                },
                {
                    name: 'cola-filled',


                    keywords: ['可乐', '可乐饮料'],
                },
                {
                    name: 'candy-filled',


                    keywords: ['糖果', '糖果', '甜蜜', '甜美的食品'],
                },
                {
                    name: 'drumstick-filled',


                    keywords: ['鼓棒', '鼓槌'],
                },
                {
                    name: 'eggplant-filled',


                    keywords: ['茄子', '茄子'],
                },
                {
                    name: 'chili-filled',


                    keywords: ['辣椒', '辣椒酱'],
                },
                {
                    name: 'garlic-filled',


                    keywords: ['大蒜', '蒜'],
                },
                {
                    name: 'drink-filled',


                    keywords: ['喝酒', '饮品'],
                },
                {
                    name: 'grape-filled',


                    keywords: ['葡萄', '葡萄园'],
                },
                {
                    name: 'hamburger-filled',


                    keywords: ['汉堡包', '汉堡'],
                },
                {
                    name: 'ice-cream-filled',


                    keywords: ['冰淇淋', '冰琪淋'],
                },
                {
                    name: 'lemon-filled',


                    keywords: ['柠檬', '柠檬水'],
                },
                {
                    name: 'lemon-slice-filled',


                    keywords: ['柠檬片', '柠檬切片'],
                },
                {
                    name: 'fish-filled',


                    keywords: ['鱼', '鱼类'],
                },
                {
                    name: 'liquor-filled',


                    keywords: ['酒', '酒精饮料'],
                },
                {
                    name: 'mushroom-1-filled',


                    keywords: ['蘑菇', '蕈类'],
                },
                {
                    name: 'fries-filled',


                    keywords: ['薯片', '炸薯条'],
                },
                {
                    name: 'milk-filled',


                    keywords: ['牛奶', '牛奶', '乳制品'],
                },
                {
                    name: 'mushroom-filled',


                    keywords: ['蘑菇', '蕈类'],
                },
                {
                    name: 'nut-filled',


                    keywords: ['坚果', '坚果类'],
                },
                {
                    name: 'noodle-filled',


                    keywords: ['面条', '米线'],
                },
                {
                    name: 'pear-filled',


                    keywords: ['梨', '梨花'],
                },
                {
                    name: 'meat-pepper-filled',


                    keywords: ['辣椒炒肉', '辣味肉类'],
                },
                {
                    name: 'radish-filled',


                    keywords: ['萝卜', '白萝卜'],
                },
                {
                    name: 'popsicle-filled',


                    keywords: ['冰棍', '冰棒'],
                },
                {
                    name: 'peach-filled',


                    keywords: ['桃子', '桃子'],
                },
                {
                    name: 'pea-filled',


                    keywords: ['豌豆', '豌豆属'],
                },
                {
                    name: 'rice-filled',


                    keywords: ['米', '大米'],
                },
                {
                    name: 'sausage-filled',


                    keywords: ['腊肠', '香肠'],
                },
                {
                    name: 'pumpkin-filled',


                    keywords: ['南瓜', '南瓜派'],
                },
                {
                    name: 'tomato-filled',


                    keywords: ['番茄', '番茄酱'],
                },
                {
                    name: 'tea-filled',


                    keywords: ['茶', '茶饮料', '茶点', '茶水'],
                },
                {
                    name: 'tangerinr-filled',


                    keywords: ['丹吉尔', '坦吉尔'],
                },
                {
                    name: 'shrimp-filled',


                    keywords: ['虾', '虾仁'],
                },
                {
                    name: 'rice-ball-filled',


                    keywords: ['饭团', '米饭球'],
                },
                {
                    name: 'sandwich-filled',


                    keywords: ['夹心面包', '三明治'],
                },
                {
                    name: 'watermelon-filled',


                    keywords: ['西瓜', '水瓜'],
                },
            ],
        },
    },
    outline: {
        Brand: {
            labelCN: '品牌',
            labelEn: 'Brand',
            icons: [
                {
                    name: 'logo-adobe-illustrate',


                    keywords: ['Adobe Illustrator的logo', 'Adobe标志Illustrator'],
                },
                {
                    name: 'logo-apple',


                    keywords: ['苹果标志', '苹果公司徽标'],
                },
                {
                    name: 'logo-adobe-lightroom',


                    keywords: ['Adobe Lightroom 标志', 'Adobe Lightroom徽标'],
                },
                {
                    name: 'logo-chrome',


                    keywords: ['谷歌浏览器标志', '谷歌Chrome标识'],
                },
                {
                    name: 'logo-dribbble',


                    keywords: ['logo设计', 'Dribbble作品'],
                },
                {
                    name: 'logo-alipay',


                    keywords: ['支付宝', 'alipay'],
                },
                {
                    name: 'logo-behance',


                    keywords: ['logo-behance', '标志 Behance'],
                },
                {
                    name: 'logo-codesandbox',


                    keywords: ['代码沙盒标志', '标志代码沙盒'],
                },
                {
                    name: 'logo-cinema4d',


                    keywords: ['logo 电影4d', '标志Cinema4D'],
                },
                {
                    name: 'logo-figma',


                    keywords: ['logo设计', 'Figma制作'],
                },
                {
                    name: 'logo-android',


                    keywords: ['安卓标志', 'Android Logo'],
                },
                {
                    name: 'logo-framer',


                    keywords: ['logo设计', '框架制作'],
                },
                {
                    name: 'logo-codepen',


                    keywords: ['代码之盾', '标志设计'],
                },
                {
                    name: 'logo-gitlab',


                    keywords: ['标志-GitLab', '徽标-GitLab'],
                },
                {
                    name: 'logo-qq',


                    keywords: ['"QQ标志', 'QQ徽标"'],
                },
                {
                    name: 'logo-instagram',


                    keywords: ['"Instagram徽标', 'Instagram标志"'],
                },
                {
                    name: 'logo-facebook',


                    keywords: [
                        '"logo-facebook" 可以翻译为以下两个可能的中文短语：\n\n1. 脸书标志', 'Facebook标志\n2. 脸谱网徽标', 'Facebook图标',
                    ],
                },
                {
                    name: 'logo-ie',


                    keywords: [],
                },
                {
                    name: 'logo-github',


                    keywords: [],
                },
                {
                    name: 'logo-twitter',


                    keywords: [
                        '"logo-twitter" 可以翻译为以下两个可能的中文短语：\n\n1. Twitter 的标志,\n2. 推特的徽标',
                    ],
                },
                {
                    name: 'logo-adobe-photoshop',


                    keywords: ['Adobe Photoshop的logo', 'Adobe Photoshop的标志', 'ps'],
                },
                {
                    name: 'logo-wecom',


                    keywords: ['企业微信标志', '企业微信标识', '企微'],
                },
                {
                    name: 'logo-youtube',


                    keywords: ['"YouTube标志', 'YouTube徽标"'],
                },
                {
                    name: 'logo-wechat-stroke',


                    keywords: ['微信图标', '描边微信'],
                },
                {
                    name: 'logo-wechatpay',


                    keywords: ['微信支付标志', '微信支付标识'],
                },
                {
                    name: 'logo-cnb',


                    keywords: ['CNB', '腾讯云原生构建'],
                },
                {
                    name: 'logo-miniprogram',


                    keywords: ['小程序', '微信小程序'],
                },
            ],
        },
        Charts: {
            labelCN: '图表',
            labelEn: 'Charts',
            icons: [
                {
                    name: 'calculation',


                    keywords: ['计算', '运算'],
                },
                {
                    name: 'activity',


                    keywords: ['活动', '行动'],
                },
                {
                    name: 'chart-area-multi',


                    keywords: ['图表区域多', '图表区域众多'],
                },
                {
                    name: 'chart-3d',


                    keywords: ['图表', '图表数据'],
                },
                {
                    name: 'chart-bar',


                    keywords: ['条形图', '柱状图'],
                },
                {
                    name: 'chart-line-data-1',


                    keywords: ['折线图数据', '曲线图数据'],
                },
                {
                    name: 'chart-area',


                    keywords: ['图表区域', '绘图区'],
                },
                {
                    name: 'chart-bubble',


                    keywords: ['图表气泡', '气泡图'],
                },
                {
                    name: 'chart-column',


                    keywords: ['列图表', '柱状图'],
                },
                {
                    name: 'chart-line-data',


                    keywords: ['折线图数据', '曲线图数据'],
                },
                {
                    name: 'chart-combo',


                    keywords: ['图表组合', '图表组合框'],
                },
                {
                    name: 'chart-line-multi',


                    keywords: ['折线图多线', '多线折线图'],
                },
                {
                    name: 'chart-line',


                    keywords: ['折线图', '线形图'],
                },
                {
                    name: 'chart-maximum',


                    keywords: ['图表最大值', '最高的图表数值'],
                },
                {
                    name: 'chart-pie',


                    keywords: ['图表饼图', '饼状图'],
                },
                {
                    name: 'chart-radar',


                    keywords: ['图表雷达', '雷达图表'],
                },
                {
                    name: 'chart-radial',


                    keywords: ['图表径向', '径向图表'],
                },
                {
                    name: 'chart-median',


                    keywords: ['中位数图表', ' median chart'],
                },
                {
                    name: 'chart-scatter',


                    keywords: ['图表散点', '坐标散点'],
                },
                {
                    name: 'chart-ring',


                    keywords: ['图表环形', '圆形图表'],
                },
                {
                    name: 'chart-minimum',


                    keywords: ['图表最小值', '图表最低值'],
                },
                {
                    name: 'chart-ring-1',


                    keywords: ['图表环形', '圆形图表'],
                },
                {
                    name: 'table-add',


                    keywords: ['table-add', '添加表格'],
                },
                {
                    name: 'sequence',


                    keywords: ['序列', '顺序'],
                },
                {
                    name: 'object-storage',


                    keywords: ['对象存储', '物体存储'],
                },
                {
                    name: 'chart-stacked',


                    keywords: ['图表堆叠', '堆叠图表'],
                },
                {
                    name: 'fork',


                    keywords: ['分叉', '分支'],
                },
                {
                    name: 'table-split',


                    keywords: ['表格分割', '表格拆分'],
                },
                {
                    name: 'tree-round-dot-vertical',


                    keywords: ['树形圆点垂直', '树状圆点垂直分布'],
                },
                {
                    name: 'chart-analytics',


                    keywords: ['图表分析', '图表统计'],
                },
                {
                    name: 'tree-round-dot',


                    keywords: ['树形圆点', '树状圆点'],
                },
                {
                    name: 'tree-square-dot-vertical',


                    keywords: ['树形圆点垂直', '树状圆点垂直布局'],
                },
                {
                    name: 'usercase-link',


                    keywords: ['用户案例链接', '用户案例的链接'],
                },
                {
                    name: 'tree-square-dot',


                    keywords: ['树形圆点', '树状圆点'],
                },
                {
                    name: 'usercase',


                    keywords: ['用户案例', '用例'],
                },
                {
                    name: 'table',


                    keywords: ['桌子', '餐桌'],
                },
            ],
        },
        Image: {
            labelCN: '图片',
            labelEn: 'Image',
            icons: [
                {
                    name: 'adjustment',


                    keywords: ['调整', '校准'],
                },
                {
                    name: 'animation-1',


                    keywords: ['动画', '动画制作'],
                },
                {
                    name: 'animation',


                    keywords: ['动画', '动画制作'],
                },
                {
                    name: 'brightness-1',


                    keywords: ['亮度', '光照度'],
                },
                {
                    name: 'brightness',


                    keywords: ['亮度', '光照度'],
                },
                {
                    name: 'filter-1',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'filter-2',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'contrast-1',


                    keywords: ['对比', '强烈对比'],
                },
                {
                    name: 'circle',


                    keywords: ['圆圈', '圆形'],
                },
                {
                    name: 'exposure',


                    keywords: ['曝光', '曝光量'],
                },
                {
                    name: 'center-focus-strong',


                    keywords: ['中心聚焦强烈', '中心重点突出'],
                },
                {
                    name: 'fill-color-1',


                    keywords: ['填充颜色', '填充色彩'],
                },
                {
                    name: 'highlight-1',


                    keywords: ['高亮', '强调'],
                },
                {
                    name: 'image-off',


                    keywords: ['关闭图片', '图片关闭'],
                },
                {
                    name: 'image-edit',


                    keywords: ['图片编辑', '图像编辑'],
                },
                {
                    name: 'face-retouching',


                    keywords: ['面部修饰', '人像精修'],
                },
                {
                    name: 'image-error',


                    keywords: ['图片错误', '图像错误'],
                },
                {
                    name: 'filter-3',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'image',


                    keywords: ['图片', '图像'],
                },
                {
                    name: 'image-1',


                    keywords: ['图片', '图像'],
                },
                {
                    name: 'image-add',


                    keywords: ['图片添加', '添加图片'],
                },
                {
                    name: 'measurement',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'markup',


                    keywords: ['标记', '符号'],
                },
                {
                    name: 'portrait',


                    keywords: ['肖像', '画像'],
                },
                {
                    name: 'image-search',


                    keywords: ['图片搜索', '图像搜索'],
                },
                {
                    name: 'panorama-vertical',


                    keywords: ['全景垂直', '垂直全景'],
                },
                {
                    name: 'pantone',


                    keywords: ['潘通色卡', ' Pantone配色系统'],
                },
                {
                    name: 'panorama-horizontal',


                    keywords: ['全景水平', '水平全景'],
                },
                {
                    name: 'rectangle',


                    keywords: ['长方形', '矩形'],
                },
                {
                    name: 'saturation',


                    keywords: ['饱和度', '饱和度'],
                },
                {
                    name: 'round',


                    keywords: ['四舍五入', '舍入'],
                },
                {
                    name: 'transform-2',


                    keywords: ['转变', '变换'],
                },
                {
                    name: 'sharpness',


                    keywords: ['清晰度', '锐度'],
                },
                {
                    name: 'measurement-1',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'visual-recognition',


                    keywords: ['视觉识别', '视觉辨识'],
                },
                {
                    name: 'palette',


                    keywords: ['调色板', '色彩面板'],
                },
                {
                    name: 'transform',


                    keywords: ['转变', '变换'],
                },
            ],
        },
        Weather: {
            labelCN: '天气',
            labelEn: 'Weather',
            icons: [
                {
                    name: 'celsius',


                    keywords: ['摄氏', '度'],
                },
                {
                    name: 'cloudy-day',


                    keywords: ['多云天气', '多云天'],
                },
                {
                    name: 'cloudy-rain',


                    keywords: ['多云转雨', '阴雨天气'],
                },
                {
                    name: 'cloudy-sunny',


                    keywords: ['多云转晴', '阴天转晴天'],
                },
                {
                    name: 'cloudy-night',


                    keywords: ['多云的夜晚', '多云的夜色'],
                },
                {
                    name: 'cloud',


                    keywords: ['云', '云朵'],
                },
                {
                    name: 'fog-night',


                    keywords: ['雾夜', '夜雾'],
                },
                {
                    name: 'fog',


                    keywords: ['雾', '雾气'],
                },
                {
                    name: 'fog-sunny',


                    keywords: ['雾天', '晴朗天气'],
                },
                {
                    name: 'moon-fall',


                    keywords: ['月落', '月亮落下'],
                },
                {
                    name: 'rain-heavy',


                    keywords: ['雨水量大', '雨势沉重'],
                },
                {
                    name: 'rain-medium',


                    keywords: ['雨中等', '中雨'],
                },
                {
                    name: 'moon-rising',


                    keywords: ['月亮升起', '月亮升起的时候'],
                },
                {
                    name: 'rainbow',


                    keywords: ['彩虹', '彩虹桥'],
                },
                {
                    name: 'cloudy-night-rain',


                    keywords: ['多云夜晚雨', '阴天夜晚下雨'],
                },
                {
                    name: 'sun-rising',


                    keywords: ['日出', '日出东方'],
                },
                {
                    name: 'fahrenheit-scale',


                    keywords: ['华氏温标', '华氏温度'],
                },
                {
                    name: 'rain-light',


                    keywords: ['雨光', '雨中的光线'],
                },
                {
                    name: 'snowflake',


                    keywords: ['雪花', '雪花片'],
                },
                {
                    name: 'sun-fall',


                    keywords: ['太阳落山', '日落西山'],
                },
                {
                    name: 'thunderstorm',


                    keywords: ['雷暴', '暴风雨'],
                },
                {
                    name: 'sunny',


                    keywords: ['晴天', '日光灿烂'],
                },
                {
                    name: 'windy-rain',


                    keywords: ['有风的雨', '刮风下雨'],
                },
                {
                    name: 'windy',


                    keywords: ['有风的', '多风的'],
                },
                {
                    name: 'thunder',


                    keywords: ['雷声,打雷'],
                },
                {
                    name: 'thunderstorm-sunny',


                    keywords: ['雷暴后的晴天', '晴朗后的雷暴'],
                },
                {
                    name: 'thunderstorm-night',


                    keywords: ['雷暴之夜', '夜晚的雷暴'],
                },
                {
                    name: 'moon',


                    keywords: ['月亮', '月球'],
                },
                {
                    name: 'tornado',


                    keywords: ['旋风', '龙卷风'],
                },
            ],
        },
        Maps: {
            labelCN: '地图',
            labelEn: 'Maps',
            icons: [
                {
                    name: 'compass-1',


                    keywords: ['罗盘,指南针,导航,导航仪'],
                },
                {
                    name: 'indicator',


                    keywords: ['指标', '指标', '指标', '指标'],
                },
                {
                    name: 'earth',


                    keywords: ['地球', '', '蓝球'],
                },
                {
                    name: 'location-error',


                    keywords: ['位置错误', '定位错误'],
                },
                {
                    name: 'camera-2',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'compass',


                    keywords: ['罗盘,指南针,导航,定位'],
                },
                {
                    name: 'location-reduction',


                    keywords: ['地点缩减', '位置降低'],
                },
                {
                    name: 'location-setting',


                    keywords: ['位置设置', '定位设置'],
                },
                {
                    name: 'location-enlargement',


                    keywords: ['位置放大', '扩大定位'],
                },
                {
                    name: 'location-parking-place',


                    keywords: ['"位置', '停车场"', '"地点', '停车位"'],
                },
                {
                    name: 'location',


                    keywords: ['位置', '所在地'],
                },
                {
                    name: 'map-3d',


                    keywords: ['地图数据', '地图信息'],
                },
                {
                    name: 'map-cancel',


                    keywords: ['取消映射', '取消地图'],
                },
                {
                    name: 'downscale',


                    keywords: ['缩减规模', '降低分辨率'],
                },
                {
                    name: 'map-blocked',


                    keywords: ['地图阻止', '地图被封锁'],
                },
                {
                    name: 'map-chat',


                    keywords: ['地图聊天', '地图交流'],
                },
                {
                    name: 'map-checked',


                    keywords: ['映射已检查', '映射检查过'],
                },
                {
                    name: 'map-bubble',


                    keywords: ['地图气泡', '气泡地图'],
                },
                {
                    name: 'map-connection',


                    keywords: ['地图连接', '映射连接'],
                },
                {
                    name: 'map-distance',


                    keywords: ['地图距离', '行驶距离'],
                },
                {
                    name: 'map-aiming',


                    keywords: ['瞄准地图', '地图定位'],
                },
                {
                    name: 'map-collection',


                    keywords: ['映射集合', '映射-集合'],
                },
                {
                    name: 'map-double',


                    keywords: ['映射翻倍', '地图加倍'],
                },
                {
                    name: 'map-information-2',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-grid',


                    keywords: ['地图网格', '网格地图'],
                },
                {
                    name: 'map-information',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-location',


                    keywords: ['地图位置', '地理位置'],
                },
                {
                    name: 'map-information-1',


                    keywords: ['地图信息', '地图资料'],
                },
                {
                    name: 'map-edit',


                    keywords: ['地图编辑', '地图修改'],
                },
                {
                    name: 'map-navigation',


                    keywords: ['地图导航', '导航地图'],
                },
                {
                    name: 'map-locked',


                    keywords: ['地图锁定', '锁定地图'],
                },
                {
                    name: 'map-outline',


                    keywords: ['地图轮廓', '地图边界'],
                },
                {
                    name: 'map-marked',


                    keywords: ['地图标记', '地图上的标记'],
                },
                {
                    name: 'map-ruler',


                    keywords: ['地图尺', '比例尺'],
                },
                {
                    name: 'map-safety',


                    keywords: ['地图安全', '安全性映射'],
                },
                {
                    name: 'map-search',


                    keywords: ['地图搜索', '地图查找'],
                },
                {
                    name: 'map-unlocked',


                    keywords: ['解锁地图', '打开地图'],
                },
                {
                    name: 'map-setting',


                    keywords: ['地图设置', '地图配置'],
                },
                {
                    name: 'map-route-planning',


                    keywords: ['地图路线规划', '路径规划'],
                },
                {
                    name: 'map-search-1',


                    keywords: ['地图搜索', '地图查找'],
                },
                {
                    name: 'map-add',


                    keywords: ['地图添加', '映射添加'],
                },
                {
                    name: 'pin',


                    keywords: ['针', '钉子'],
                },
                {
                    name: 'navigation-arrow',


                    keywords: ['导航箭头', '导航指示箭头'],
                },
                {
                    name: 'map',


                    keywords: ['地图', '地图册'],
                },
                {
                    name: 'subway-line',


                    keywords: ['地铁路线', '地铁线路'],
                },
                {
                    name: 'street-road',


                    keywords: ['街道', '道路'],
                },
                {
                    name: 'traffic-events',


                    keywords: ['交通事件', '交通事故'],
                },
                {
                    name: 'upscale',


                    keywords: ['向上采样', '提高分辨率'],
                },
                {
                    name: 'street-road-1',


                    keywords: ['街道', '道路'],
                },
                {
                    name: 'traffic',


                    keywords: ['交通', '流量'],
                },
                {
                    name: 'mobile-navigation',


                    keywords: ['移动导航', '行动导航'],
                },
            ],
        },
        Development: {
            labelCN: '开发',
            labelEn: 'Development',
            icons: [
                {
                    name: 'braces',


                    keywords: ['牙套', '矫正器'],
                },
                {
                    name: 'bug',


                    keywords: ['程序错误', '缺陷'],
                },
                {
                    name: 'command',


                    keywords: ['指令', '命令'],
                },
                {
                    name: 'code-1',


                    keywords: [],
                },
                {
                    name: 'code',


                    keywords: [],
                },
                {
                    name: 'cursor',


                    keywords: ['光标', '指示器'],
                },
                {
                    name: 'css3',


                    keywords: [],
                },
                {
                    name: 'code-off',


                    keywords: ['代码关闭', '代码禁用'],
                },
                {
                    name: 'git-commit',


                    keywords: ['提交', '提交记录'],
                },
                {
                    name: 'git-merge',


                    keywords: ['合并 Git 仓库', '合并分支'],
                },
                {
                    name: 'git-pull-request',


                    keywords: ['拉取请求', '合并请求'],
                },
                {
                    name: 'git-branch',


                    keywords: ['git分支', 'Git的支'],
                },
                {
                    name: 'git-repository',


                    keywords: ['git仓库', 'Git存储库'],
                },
                {
                    name: 'parentheses',


                    keywords: ['括号', '括号'],
                },
                {
                    name: 'html5',


                    keywords: ['超文本标记语言5', 'HTML5'],
                },
                {
                    name: 'git-repository-private',


                    keywords: ['私有Git仓库', 'Git私有仓库'],
                },
                {
                    name: 'git-repository-commits',


                    keywords: ['git仓库提交记录', 'Git仓库的提交历史'],
                },
                {
                    name: 'sitemap',


                    keywords: ['网站地图', '站点地图'],
                },
                {
                    name: 'brackets',


                    keywords: ['括号', '括号'],
                },
                {
                    name: 'terminal',


                    keywords: ['终端', '终端机'],
                },
                {
                    name: 'terminal-rectangle',


                    keywords: ['终端矩形', '终端长方形'],
                },
                {
                    name: 'terminal-window',


                    keywords: ['终端窗口', '终端视窗'],
                },
            ],
        },
        Letters: {
            labelCN: '字母',
            labelEn: 'Letters',
            icons: [
                {
                    name: 'letters-c',


                    keywords: [
                        '字母c可以翻译为以下两个中文短语：\n\n1. 字母C,\n2. c字母。',
                    ],
                },
                {
                    name: 'letters-f',


                    keywords: [],
                },
                {
                    name: 'letters-e',


                    keywords: ['字母-e可以翻译为以下两个中文短语：\n\n电子', '元素'],
                },
                {
                    name: 'letters-a',


                    keywords: ['字母表-a', '字母a'],
                },
                {
                    name: 'letters-d',


                    keywords: [],
                },
                {
                    name: 'letters-g',


                    keywords: [],
                },
                {
                    name: 'letters-b',


                    keywords: ['字母b的翻译可以是“字母b', 'b字母”。'],
                },
                {
                    name: 'letters-h',


                    keywords: ['信函-H', '字母-H'],
                },
                {
                    name: 'letters-k',


                    keywords: [],
                },
                {
                    name: 'letters-l',


                    keywords: [
                        '字母-l 翻译为两个可能的中文短语是："字母l', '字母L"。\n\n首先',
                        '我分析了原始问题中的关键点：“letters-l”需要翻译成中文短语。由于“letters”是复数形式',
                        '而“-l”是一个常见的英文小写字母',
                        '因此这里的翻译应该保持原样',
                        '只是转换成中文。\n\n接着',
                        '我考虑到中文中对于英文单词的直接翻译通常就是其本身的发音加上相应的汉字',
                        '所以“letters”翻译为“字母”',
                        '“-l”作为字母l的表示',
                        '直接翻译为“l”。\n\n最后',
                        '根据任务要求',
                        '需要将翻译后的短语用逗号隔开',
                        '因此最终答案是：“字母l', '字母L”。',
                    ],
                },
                {
                    name: 'letters-i',


                    keywords: [],
                },
                {
                    name: 'letters-m',


                    keywords: ['字母m的翻译可以是“妈妈', '妈”'],
                },
                {
                    name: 'letters-j',


                    keywords: [],
                },
                {
                    name: 'letters-n',


                    keywords: ['信函-n', '字母表-n'],
                },
                {
                    name: 'letters-q',


                    keywords: ['字母q', '字母q的中文翻译', '字母q的中文表示'],
                },
                {
                    name: 'letters-p',


                    keywords: [
                        '字母p的翻译可以是“字母p', '字母P”。\n\n首先',
                        '我分析了原始问题中的关键点：“letters-p”需要翻译成中文短语。由于“letters”是“字母”的意思',
                        '而“-p”在这里指的是小写的英文字母“p”',
                        '所以翻译时应该保持原样',
                        '即“字母p”。但是',
                        '问题要求翻译成两个可能的中文短语',
                        '这里可能存在一个误解',
                        '因为单个英文单词通常只有一个标准的中文翻译。然而',
                        '为了满足问题的要求',
                        '我可以提供一个常见的翻译和一个不太常见的翻译',
                        '即用中文谐音或者意译的方式来表达。\n\n在这里',
                        '我选择了“字母p”作为最常见的翻译',
                        '并且为了满足两个短语的要求',
                        '我提供了“字母P”作为第二个翻译',
                        '这里的“P”是大写的形式',
                        '虽然在实际使用中大小写通常不会影响意义',
                        '但在某些情况下',
                        '如打字错误或者特定上下文中',
                        '大小写可能会被区分对待。\n\n因此',
                        '根据问题的要求',
                        '我提供了“字母p', '字母P”作为答案。',
                    ],
                },
                {
                    name: 'letters-s',


                    keywords: [
                        '字母s可以翻译为以下两个中文短语：\n\n1. 字母S,\n2. s字母。',
                    ],
                },
                {
                    name: 'letters-r',


                    keywords: [],
                },
                {
                    name: 'letters-t',


                    keywords: [
                        '字母t的翻译可以是"字母T"或者"t字母"。\n首先',
                        '我分析了原始问题中的关键点：“letters-t”需要翻译成中文短语。这里的“letters”指的是英文字母',
                        '而“-t”是这个字母的一个变体',
                        '通常在英语中不单独作为一个字母使用',
                        '而是作为其他单词的一部分',
                        '比如在“water”中的“t”。但是',
                        '由于问题中没有提供更多的上下文信息',
                        '我假设这里的“-t”是指英文字母“t”。\n接着',
                        '我将“letters-t”翻译为中文。在中文中',
                        '“字母”是用来指代英文的“letters”',
                        '而“-t”作为字母“t”的表示',
                        '可以直接翻译为“字母T”。但是',
                        '由于“-t”在中文中没有特定的含义',
                        '它也可以被翻译为“t字母”',
                        '这样的翻译保留了“-t”作为字母的一部分的信息。\n最后',
                        '根据问题的要求',
                        '我将两个翻译后的短语用逗号隔开',
                        '得到最终答案：“字母T', 't字母”。',
                    ],
                },
                {
                    name: 'letters-w',


                    keywords: [],
                },
                {
                    name: 'letters-o',


                    keywords: [
                        '字母o的两种可能中文短语翻译为："字母o', '圆形符号"。\n首先',
                        '我分析了原始问题中的关键点：“letters-o”需要翻译成中文短语',
                        '并且要求是两个可能的短语。这里的“letters”指的是英文字母',
                        '而“-o”是字母o的形态。在中文中',
                        '字母o通常直接翻译为“字母o”',
                        '但考虑到可能需要两个不同的短语来描述它',
                        '我提供了两种可能的解释：一种是直接描述其作为字母的身份',
                        '即“字母o”；另一种是描述其形状',
                        '即“圆形符号”。这样的翻译既保留了原字母的特征',
                        '也提供了关于其形状的信息',
                        '满足了问题的要求。',
                    ],
                },
                {
                    name: 'letters-v',


                    keywords: [],
                },
                {
                    name: 'letters-z',


                    keywords: ['字母z的两种可能中文短语翻译为：\n\n子母字母', 'z字母'],
                },
                {
                    name: 'letters-x',


                    keywords: [
                        '字母x的两种可能中文短语翻译为："神秘的X', '字母X"。\n首先',
                        '我分析了原始问题中的关键点：“letters-x”需要翻译成中文',
                        '并且要求翻译成两个可能的短语。这里的“letters”指的是字母',
                        '而“-x”是字母x。在中文中',
                        '字母x可以直接翻译成“X”',
                        '而要表达“神秘的X”这样的含义',
                        '可以将其翻译为“神秘的X”。因此',
                        '我提供了两种可能的中文短语',
                        '即用逗号隔开的“神秘的X', '字母X”。这样的翻译既保留了原字母的表示',
                        '也提供了对字母x的一种可能含义的翻译。',
                    ],
                },
                {
                    name: 'letters-u',


                    keywords: [],
                },
                {
                    name: 'letters-y',


                    keywords: [
                        '字母y可以翻译为以下两个中文短语：\n\n1. 字母y', '英文字母y\n2. y字母', '英语中的y字母',
                    ],
                },
            ],
        },
        Media: {
            labelCN: '媒体',
            labelEn: 'Media',
            icons: [
                {
                    name: 'calculator',


                    keywords: ['计算器', '计算器具'],
                },
                {
                    name: 'camera-1',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'backward',


                    keywords: ['向后', '向后看'],
                },
                {
                    name: 'cd',


                    keywords: ['光盘', '唱片'],
                },
                {
                    name: 'dvd',


                    keywords: ['光盘', '数字化视频光盘'],
                },
                {
                    name: 'download-2',


                    keywords: ['下载', '下载文件'],
                },
                {
                    name: 'gamepad-1',


                    keywords: ['游戏手柄', '游戏控制器'],
                },
                {
                    name: 'dart-board',


                    keywords: ['"dart board', '飞镖靶子"'],
                },
                {
                    name: 'film-1',


                    keywords: ['胶卷', '电影胶片'],
                },
                {
                    name: 'earphone',


                    keywords: ['耳机', '耳机'],
                },
                {
                    name: 'forward',


                    keywords: ['转发', '转送'],
                },
                {
                    name: 'guitar',


                    keywords: ['吉他', '吉它'],
                },
                {
                    name: 'dv',


                    keywords: [
                        '"dv" 可以翻译为两个可能的中文短语：\n\n1. 数字视频,\n2. 数码摄像机。',
                    ],
                },
                {
                    name: 'microphone-1',


                    keywords: ['麦克风', '麦克风', '扩音器'],
                },
                {
                    name: 'ipod',


                    keywords: ['"ipod', '苹果音乐播放器"\n"ipod', '便携式音乐播放器"'],
                },
                {
                    name: 'microphone-2',


                    keywords: ['麦克风', '扩音器'],
                },
                {
                    name: 'music-rectangle-add',


                    keywords: ['音乐矩形添加', '矩形音乐添加'],
                },
                {
                    name: 'movie-clapper',


                    keywords: ['电影拍手', '电影拍掌'],
                },
                {
                    name: 'page-last',


                    keywords: ['最后一页', '最后一页内容'],
                },
                {
                    name: 'loudspeaker',


                    keywords: ['喇叭', '扬声器'],
                },
                {
                    name: 'microphone',


                    keywords: ['麦克风', '扩音器'],
                },
                {
                    name: 'music',


                    keywords: ['音乐', '音乐'],
                },
                {
                    name: 'pause-circle-stroke',


                    keywords: ['暂停圆形描边', '暂停圆圈描边'],
                },
                {
                    name: 'pause',


                    keywords: ['暂停', '停顿'],
                },
                {
                    name: 'next',


                    keywords: ['下一步', '下一个步骤'],
                },
                {
                    name: 'piano',


                    keywords: ['钢琴', '钢琴', '钢琴', '钢琴'],
                },
                {
                    name: 'play-circle-stroke-add',


                    keywords: ['添加圆形播放图标笔触', '添加圆形播放图标描边'],
                },
                {
                    name: 'play-circle-stroke',


                    keywords: ['圆圈播放笔触', '圆形播放描边'],
                },
                {
                    name: 'pause-circle',


                    keywords: ['暂停圈', '暂停圆形'],
                },
                {
                    name: 'play',


                    keywords: ['播放', '扮演'],
                },
                {
                    name: 'play-circle',


                    keywords: ['播放循环', '循环播放'],
                },
                {
                    name: 'play-demo',


                    keywords: ['"运行演示', '演示游戏"'],
                },
                {
                    name: 'page-first',


                    keywords: ['页面优先', '逐页优先'],
                },
                {
                    name: 'radio-1',


                    keywords: ['无线电', '无线电波'],
                },
                {
                    name: 'previous',


                    keywords: ['之前的', '以前的'],
                },
                {
                    name: 'radio-2',


                    keywords: ['无线电', '无线电波'],
                },
                {
                    name: 'play-rectangle',


                    keywords: ['播放矩形', '矩形播放'],
                },
                {
                    name: 'replay',


                    keywords: ['重播', '重放'],
                },
                {
                    name: 'sensors-2',


                    keywords: ['感应器', '传感器'],
                },
                {
                    name: 'shutter',


                    keywords: ['快门速度', '帘幕式快门', '朋友圈'],
                },
                {
                    name: 'sd-card-1',


                    keywords: ['SD卡', '存储卡'],
                },
                {
                    name: 'sound-down',


                    keywords: ['音量调低', '声音降低'],
                },
                {
                    name: 'sound-mute',


                    keywords: ['静音', '声音关闭'],
                },
                {
                    name: 'sound-low',


                    keywords: ['低音', '低频'],
                },
                {
                    name: 'screencast',


                    keywords: ['屏幕录制', '屏幕快照'],
                },
                {
                    name: 'sonic',


                    keywords: ['音速', '声速'],
                },
                {
                    name: 'sound-up',


                    keywords: ['声音放大', '声音增大'],
                },
                {
                    name: 'sound-mute-1',


                    keywords: ['静音', '声音关闭'],
                },
                {
                    name: 'sound',


                    keywords: ['声音', '声响'],
                },
                {
                    name: 'stop-circle-stroke',


                    keywords: ['停止圆圈描边', '停止圆形描边'],
                },
                {
                    name: 'stop',


                    keywords: ['停止', '停下'],
                },
                {
                    name: 'video-camera-2',


                    keywords: ['video camera', '摄像机'],
                },
                {
                    name: 'sound-high',


                    keywords: ['响度高', '声音大'],
                },
                {
                    name: 'tape',


                    keywords: ['磁带', '录像带'],
                },
                {
                    name: 'video-camera-music',


                    keywords: ['video camera music', '摄像机音乐'],
                },
                {
                    name: 'stop-circle',


                    keywords: ['停止圆形', '停止圈'],
                },
                {
                    name: 'video-camera-dollar',


                    keywords: ['视频摄像头美元', '摄像机美元'],
                },
                {
                    name: 'video-camera-1',


                    keywords: ['录像机', '摄像机'],
                },
                {
                    name: 'video-camera-minus',


                    keywords: ['摄像机减号', '摄像头减号'],
                },
                {
                    name: 'video',


                    keywords: ['视频', '录像'],
                },
                {
                    name: 'video-library',


                    keywords: ['视频库', '影视资料馆'],
                },
                {
                    name: 'video-camera-off',


                    keywords: ['"关闭摄像机', '摄像机关"'],
                },
                {
                    name: 'video-camera-3',


                    keywords: ['电视摄像机', '视频摄影机'],
                },
            ],
        },
        Gestures: {
            labelCN: '手势',
            labelEn: 'Gestures',
            icons: [
                {
                    name: 'fingerprint-2',


                    keywords: ['指纹', '指纹识别'],
                },
                {
                    name: 'fingerprint-3',


                    keywords: ['指纹', '指纹识别'],
                },
                {
                    name: 'fingerprint-1',


                    keywords: ['指纹', '指纹识别'],
                },
                {
                    name: 'gesture-applause',


                    keywords: ['掌声', '欢呼'],
                },
                {
                    name: 'gesture-down',


                    keywords: ['手势向下', '向下手势'],
                },
                {
                    name: 'gesture-left-slip',


                    keywords: ['左手滑', '左侧滑动'],
                },
                {
                    name: 'gesture-open',


                    keywords: ['手势打开', '手势开启'],
                },
                {
                    name: 'gesture-left',


                    keywords: ['手势向左', '向左挥动'],
                },
                {
                    name: 'gesture-expansion',


                    keywords: ['手势扩展', '手势扩大'],
                },
                {
                    name: 'gesture-pray',


                    keywords: ['祈祷手势', '祈祷动作'],
                },
                {
                    name: 'gesture-click',


                    keywords: ['手势点击', '手势触摸'],
                },
                {
                    name: 'gesture-right-slip',


                    keywords: ['手势向右滑', '向右滑动的手势'],
                },
                {
                    name: 'gesture-slide-left-and-right',


                    keywords: ['手势左右滑动', '左右滑动手势'],
                },
                {
                    name: 'gesture-typing',


                    keywords: ['手势输入', '手势打字'],
                },
                {
                    name: 'gesture-up-and-down',


                    keywords: ['手势上下', '手势上下来回'],
                },
                {
                    name: 'gesture-right',


                    keywords: ['手势向右', '向右的手势'],
                },
                {
                    name: 'thumb-down-1',


                    keywords: ['点赞', '点踩'],
                },
                {
                    name: 'gesture-ranslation',


                    keywords: ['手势翻译', '手势转录'],
                },
                {
                    name: 'gesture-up',


                    keywords: ['手势向上', '向上手势'],
                },
                {
                    name: 'gesture-slide-up',


                    keywords: ['手势上滑', '手势向上滑动'],
                },
                {
                    name: 'thumb-down-2',


                    keywords: ['点赞', '点踩'],
                },
                {
                    name: 'thumb-up-2',


                    keywords: ['点赞', '翘起大拇指'],
                },
                {
                    name: 'undertake-delivery',


                    keywords: ['承担交付', '负责送货'],
                },
                {
                    name: 'undertake-hold-up',


                    keywords: ['承担', '推迟', '搁置', '暂停', '延迟'],
                },
                {
                    name: 'gesture-wipe-down',


                    keywords: ['手势下扫', '向下挥手'],
                },
                {
                    name: 'thumb-up-1',


                    keywords: ['点赞', '竖起大拇指'],
                },
                {
                    name: 'undertake',


                    keywords: ['承担', '进行'],
                },
                {
                    name: 'wave-bye',


                    keywords: ['"Wave Goodbye', '挥手告别"'],
                },
                {
                    name: 'gesture-press',


                    keywords: ['手势按压', '手势触摸'],
                },
                {
                    name: 'wave-right',


                    keywords: ['波形右移', '右偏波形'],
                },
                {
                    name: 'undertake-transaction',


                    keywords: ['承担事务', '进行交易'],
                },
                {
                    name: 'undertake-environment-protection',


                    keywords: ['承担环境保护', '进行环境保护'],
                },
                {
                    name: 'wave-left',


                    keywords: ['波形左移', '左波形'],
                },
            ],
        },
        Buildings: {
            labelCN: '建筑',
            labelEn: 'Buildings',
            icons: [
                {
                    name: 'archway-1',


                    keywords: ['拱道,拱形通道'],
                },
                {
                    name: 'attic',


                    keywords: ['屋顶室', '阁楼'],
                },
                {
                    name: 'architecture-hui-style',


                    keywords: ['架构汇风格', '架构hui风格'],
                },
                {
                    name: 'archway',


                    keywords: ['拱道,拱形通道'],
                },
                {
                    name: 'bridge-2',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-4',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-1',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-3',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-6',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'bridge-5',


                    keywords: ['桥梁', '桥接'],
                },
                {
                    name: 'attic-1',


                    keywords: ['屋顶室', '天花板下的房间'],
                },
                {
                    name: 'building',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'building-5',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'building-2',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'building-3',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-1',


                    keywords: ['城堡', '城堡建筑'],
                },
                {
                    name: 'building-1',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-2',


                    keywords: ['城堡', '城堡', '城堡'],
                },
                {
                    name: 'castle-3',


                    keywords: ['城堡', '城堡建筑'],
                },
                {
                    name: 'castle-5',


                    keywords: ['城堡', '城堡', '城堡'],
                },
                {
                    name: 'building-4',


                    keywords: ['建筑', '建筑物'],
                },
                {
                    name: 'castle-4',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'castle-6',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'castle',


                    keywords: ['城堡', '城堡', '城堡'],
                },
                {
                    name: 'chimney-2',


                    keywords: ['烟囱', '炊烟'],
                },
                {
                    name: 'chimney-1',


                    keywords: ['烟囱', '煤气管'],
                },
                {
                    name: 'castle-7',


                    keywords: ['城堡', '城堡'],
                },
                {
                    name: 'city-1',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'chimney',


                    keywords: ['烟囱', '炊烟'],
                },
                {
                    name: 'church',


                    keywords: ['教堂', '教会'],
                },
                {
                    name: 'city-11',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-13',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-14',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-12',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-10',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-15',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-4',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-3',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-5',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-7',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-2',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-8',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-6',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'city-ancient-2',


                    keywords: ['城市古迹', '古代城市'],
                },
                {
                    name: 'city-ancient-1',


                    keywords: ['城市古迹', '古城'],
                },
                {
                    name: 'curtain',


                    keywords: ['窗帘', '帘子'],
                },
                {
                    name: 'city-ancient',


                    keywords: ['城市古迹', '古城'],
                },
                {
                    name: 'city',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'dam-1',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-2',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-6',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-4',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'city-9',


                    keywords: ['城市', '城市群'],
                },
                {
                    name: 'dam',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-3',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'dam-7',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'double-storey',


                    keywords: ['双层楼', '双层式'],
                },
                {
                    name: 'forest',


                    keywords: ['森林,树林'],
                },
                {
                    name: 'hospital',


                    keywords: ['医院', '病院'],
                },
                {
                    name: 'houses-1',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'ferris-wheel',


                    keywords: ['"旋转木马', '摩天轮"'],
                },
                {
                    name: 'hospital-1',


                    keywords: ['医院', '病院'],
                },
                {
                    name: 'lighthouse-2',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'dam-5',


                    keywords: ['堤坝', '水坝'],
                },
                {
                    name: 'houses',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'lighthouse-1',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'mosque-1',


                    keywords: ['清真寺', '清真寺'],
                },
                {
                    name: 'lighthouse',


                    keywords: ['灯塔', '航标'],
                },
                {
                    name: 'monument',


                    keywords: ['纪念碑,纪念建筑物'],
                },
                {
                    name: 'mosque',


                    keywords: ['清真寺', '清真寺'],
                },
                {
                    name: 'houses-2',


                    keywords: ['房子们', '房屋们'],
                },
                {
                    name: 'palace-1',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'museum-2',


                    keywords: ['博物馆', '美术馆'],
                },
                {
                    name: 'palace-3',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'museum-1',


                    keywords: ['博物馆', '美术馆'],
                },
                {
                    name: 'opera',


                    keywords: ['歌剧', '歌剧表演'],
                },
                {
                    name: 'palace',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'pearl-of-the-orient',


                    keywords: ['东方之珠', '东方明珠'],
                },
                {
                    name: 'patio',


                    keywords: ['露台', '庭院'],
                },
                {
                    name: 'museum',


                    keywords: ['博物馆', '美术馆'],
                },
                {
                    name: 'pyramid',


                    keywords: ['金字塔', '金字塔结构'],
                },
                {
                    name: 'shimen',


                    keywords: ['石们', '石门'],
                },
                {
                    name: 'palace-2',


                    keywords: ['皇宫', '宫殿'],
                },
                {
                    name: 'sailing-hotel',


                    keywords: ['航海酒店', '航行旅馆'],
                },
                {
                    name: 'shop-2',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'shop-1',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'pyramid-maya',


                    keywords: ['金字塔式maya', '金字塔结构maya'],
                },
                {
                    name: 'shop-3',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'statue-of-jesus',


                    keywords: ['耶稣雕像', '耶稣塑像'],
                },
                {
                    name: 'shop-4',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'teahouse',


                    keywords: ['茶室', '茶屋'],
                },
                {
                    name: 'tower-1',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-2',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-3',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'tower-clock',


                    keywords: ['钟楼,塔钟'],
                },
                {
                    name: 'temple',


                    keywords: ['寺庙', '寺院'],
                },
                {
                    name: 'tower',


                    keywords: ['塔楼', '堡垒'],
                },
                {
                    name: 'window',


                    keywords: ['窗户', '窗户'],
                },
                {
                    name: 'town',


                    keywords: [
                        '"town," 可以翻译为以下两个中文短语：\n\n1. "城镇,"\n2. "市镇,"',
                    ],
                },
                {
                    name: 'shop-5',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'window-1',


                    keywords: ['窗户', '窗子'],
                },
                {
                    name: 'palace-4',


                    keywords: ['皇宫', '宫殿'],
                },
            ],
        },
        Numbers: {
            labelCN: '数字',
            labelEn: 'Numbers',
            icons: [
                {
                    name: 'numbers-0',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-1-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-0-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-2',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-4-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-3-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-4',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-5-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-7-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-3',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-6-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-5',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-2-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-8-1',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-8',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-6',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-9',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-7',


                    keywords: ['数字', '数目'],
                },
                {
                    name: 'numbers-9-1',


                    keywords: ['数字', '数目'],
                },
            ],
        },
        Communication: {
            labelCN: '沟通',
            labelEn: 'Communication',
            icons: [
                {
                    name: 'chat-bubble-history',


                    keywords: ['聊天气泡历史', '聊天记录历史'],
                },
                {
                    name: 'chat-add',


                    keywords: ['添加聊天', '聊天添加'],
                },
                {
                    name: 'chat-bubble',


                    keywords: ['聊天气泡', '聊天泡泡'],
                },
                {
                    name: 'chat-error',


                    keywords: ['聊天错误', '交流错误'],
                },
                {
                    name: 'chat-bubble-locked',


                    keywords: ['聊天气泡锁定', '聊天信息已锁定'],
                },
                {
                    name: 'chat-clear',


                    keywords: ['清空聊天记录', '清除聊天内容'],
                },
                {
                    name: 'chat-message',


                    keywords: ['聊天信息', '聊天记录'],
                },
                {
                    name: 'chat-double',


                    keywords: ['聊天双重', '双重聊天'],
                },
                {
                    name: 'chat-checked',


                    keywords: ['已检查的聊天', '已核实的聊天记录'],
                },
                {
                    name: 'chat-bubble-smile',


                    keywords: ['聊天气泡微笑', '笑脸聊天泡'],
                },
                {
                    name: 'chat-heart',


                    keywords: ['聊天之心', '心形聊天图标'],
                },
                {
                    name: 'chat-poll',


                    keywords: ['聊天投票', '聊天民意调查'],
                },
                {
                    name: 'chat-off',


                    keywords: ['聊关闭,聊天关闭'],
                },
                {
                    name: 'chat',


                    keywords: ['聊天', '对话'],
                },
                {
                    name: 'questionnaire-double',


                    keywords: ['问卷双份', '双份问卷'],
                },
                {
                    name: 'tips-double',


                    keywords: ['提示双份', '提示双重'],
                },
                {
                    name: 'chat-setting',


                    keywords: ['聊天设置', '聊天配置'],
                },
                {
                    name: 'questionnaire',


                    keywords: ['问卷', '调查问卷'],
                },
                {
                    name: 'tips',


                    keywords: ['小费', '小费建议'],
                },
            ],
        },
        Document: {
            labelCN: '文档',
            labelEn: 'Document',
            icons: [
                {
                    name: 'align-vertical',


                    keywords: ['垂直对齐', '垂直居中'],
                },
                {
                    name: 'align-top',


                    keywords: ['顶部对齐', '顶端对齐'],
                },
                {
                    name: 'attach',


                    keywords: ['附加', '毗连'],
                },
                {
                    name: 'chat-bubble-1',


                    keywords: ['聊天气泡', '聊天泡泡'],
                },
                {
                    name: 'bulletpoint',


                    keywords: ['子弹点', 'bullet points'],
                },
                {
                    name: 'clear',


                    keywords: ['清除', '澄清'],
                },
                {
                    name: 'add-circle',


                    keywords: ['添加圆形', '画圆'],
                },
                {
                    name: 'clear-formatting',


                    keywords: ['清除格式', '去除格式'],
                },
                {
                    name: 'chat-bubble-add',


                    keywords: ['气泡添加', '添加聊天气泡'],
                },
                {
                    name: 'cut-1',


                    keywords: ['剪切', '割开'],
                },
                {
                    name: 'error',


                    keywords: ['错误', '差错'],
                },
                {
                    name: 'format-vertical-align-right',


                    keywords: ['格式垂直右对齐', '垂直对齐到右边'],
                },
                {
                    name: 'format-vertical-align-left',


                    keywords: ['垂直左对齐', '垂直居左对齐'],
                },
                {
                    name: 'functions',


                    keywords: ['功能', '作用'],
                },
                {
                    name: 'indent-left',


                    keywords: ['缩进左边', '左对齐'],
                },
                {
                    name: 'help',


                    keywords: ['帮助', '协助'],
                },
                {
                    name: 'frame',


                    keywords: ['框架', '结构'],
                },
                {
                    name: 'hashtag',


                    keywords: ['话题标签', '标签'],
                },
                {
                    name: 'indent-right',


                    keywords: ['右缩进', '右对齐'],
                },
                {
                    name: 'line-height',


                    keywords: ['行高', '字体行间距'],
                },
                {
                    name: 'order-ascending',


                    keywords: ['升序排列', '递增排序'],
                },
                {
                    name: 'format-vertical-align-center',


                    keywords: ['垂直居中对齐', '垂直居中排列'],
                },
                {
                    name: 'share-1',


                    keywords: ['分享', '共享'],
                },
                {
                    name: 'member',


                    keywords: ['会员', '成员'],
                },
                {
                    name: 'space',


                    keywords: ['太空', '空间'],
                },
                {
                    name: 'merge-cells',


                    keywords: ['合并单元格', '单元格合并'],
                },
                {
                    name: 'quote',


                    keywords: ['引号', '双引号', '符号'],
                },
                {
                    name: 'seal',


                    keywords: ['印章', '盖章'],
                },
                {
                    name: 'textformat-italic',


                    keywords: ['文本格式斜体', '文本格式斜体'],
                },
                {
                    name: 'list',


                    keywords: ['列表', '列表项'],
                },
                {
                    name: 'textformat-bold',


                    keywords: ['文本加粗', '文字粗体'],
                },
                {
                    name: 'textformat-color',


                    keywords: ['文本格式化颜色', '文本颜色格式化'],
                },
                {
                    name: 'order-descending',


                    keywords: ['降序排列', '逆序排列'],
                },
                {
                    name: 'textformat-strikethrough',


                    keywords: ['文本格式删除线', '文字删除线'],
                },
                {
                    name: 'textformat-wrap',


                    keywords: ['文本格式换行', '文本自动换行'],
                },
                {
                    name: 'view-list',


                    keywords: ['视图列表', '查看清单'],
                },
                {
                    name: 'textformat-underline',


                    keywords: ['文本格式-下划线,文本格式-底线'],
                },
            ],
        },
        Math: {
            labelCN: '数学',
            labelEn: 'Math',
            icons: [
                {
                    name: 'add-and-subtract',


                    keywords: ['加与减', '加减法'],
                },
                {
                    name: 'beta',


                    keywords: ['贝塔', 'β', 'Beta', '比塔'],
                },
                {
                    name: 'bifurcate',


                    keywords: ['分支', '分叉'],
                },
                {
                    name: 'calculation-1',


                    keywords: ['计算', '运算'],
                },
                {
                    name: 'calculator-1',


                    keywords: ['计算器', '计算器具'],
                },
                {
                    name: 'alpha',


                    keywords: [
                        'α 可以翻译为两个可能的中文短语：\n1. 阿尔法', '\n2. α（希腊字母）。',
                    ],
                },
                {
                    name: 'centimeter',


                    keywords: ['厘米', '公分'],
                },
                {
                    name: 'coordinate-system',


                    keywords: ['坐标系', '坐标系统'],
                },
                {
                    name: 'delta',


                    keywords: ['差值', '差异'],
                },
                {
                    name: 'combination',


                    keywords: ['组合', '组成'],
                },
                {
                    name: 'curve',


                    keywords: ['曲线', '弧线'],
                },
                {
                    name: 'equal',


                    keywords: ['相等', '相同'],
                },
                {
                    name: 'function-curve',


                    keywords: ['函数曲线', '函数图形'],
                },
                {
                    name: 'functions-1',


                    keywords: ['功能', '作用'],
                },
                {
                    name: 'divide',


                    keywords: ['除法', '划分'],
                },
                {
                    name: 'dividers',


                    keywords: ['分隔线', '分隔符'],
                },
                {
                    name: 'gamma',


                    keywords: ['伽马', '伽玛'],
                },
                {
                    name: 'less-than',


                    keywords: ['小于', '少于'],
                },
                {
                    name: 'greater-than',


                    keywords: ['大于', '比...大'],
                },
                {
                    name: 'less-than-or-equal',


                    keywords: ['小于等于', '不大于等于'],
                },
                {
                    name: 'greater-than-or-equal',


                    keywords: ['大于等于', '大于或等于'],
                },
                {
                    name: 'minus',


                    keywords: ['负数', '减法'],
                },
                {
                    name: 'multiply',


                    keywords: ['乘以', '乘'],
                },
                {
                    name: 'mathematics',


                    keywords: ['数学', '数学知识'],
                },
                {
                    name: 'parabola',


                    keywords: ['抛物线', '抛物线'],
                },
                {
                    name: 'plus',


                    keywords: ['加号', '正号'],
                },
                {
                    name: 'pi',


                    keywords: ['派', '圆周率'],
                },
                {
                    name: 'sum',


                    keywords: ['求和', '总和'],
                },
                {
                    name: 'quadratic',


                    keywords: ['二次的', '二次方程'],
                },
                {
                    name: 'ruler',


                    keywords: ['尺子', '尺', '度量尺'],
                },
                {
                    name: 'relation',


                    keywords: ['关系', '关联'],
                },
                {
                    name: 'slash',


                    keywords: ['斜杠', '正斜杠'],
                },
            ],
        },
        User: {
            labelCN: '用户',
            labelEn: 'User',
            icons: [
                {
                    name: 'certificate-1',


                    keywords: ['证书', '证明书'],
                },
                {
                    name: 'education',


                    keywords: ['教育', '教育体制'],
                },
                {
                    name: 'gender-male',


                    keywords: ['男性', '男性气质'],
                },
                {
                    name: 'cooperate',


                    keywords: ['合作', '协作'],
                },
                {
                    name: 'personal-information',


                    keywords: ['个人信息', '个人资料'],
                },
                {
                    name: 'flag-4',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'user-1',


                    keywords: ['用户', '顾客'],
                },
                {
                    name: 'user-arrow-left',


                    keywords: ['用户向左箭头', '用户左箭头'],
                },
                {
                    name: 'gender-female',


                    keywords: ['女性', '女性的'],
                },
                {
                    name: 'user-arrow-right',


                    keywords: ['用户向右箭头', '用户右箭头'],
                },
                {
                    name: 'user-arrow-down',


                    keywords: ['用户下箭头', '用户向下箭头'],
                },
                {
                    name: 'user-arrow-up',


                    keywords: ['用户向上箭头', '用户上箭头'],
                },
                {
                    name: 'user-add',


                    keywords: ['添加用户', '增加用户'],
                },
                {
                    name: 'user-avatar',


                    keywords: ['用户头像', '用户图像'],
                },
                {
                    name: 'user-blocked',


                    keywords: ['用户被阻止', '用户被封禁'],
                },
                {
                    name: 'user-checked-1',


                    keywords: ['用户已勾选', '用户已检查'],
                },
                {
                    name: 'user-circle',


                    keywords: ['用户圈', '用户圈子'],
                },
                {
                    name: 'user-invisible',


                    keywords: ['用户不可见', '隐藏用户'],
                },
                {
                    name: 'user-clear',


                    keywords: ['用户清除', '用户清理'],
                },
                {
                    name: 'user-checked',


                    keywords: ['用户已勾选', '用户已检查'],
                },
                {
                    name: 'user-business',


                    keywords: ['用户业务', '顾客商业'],
                },
                {
                    name: 'user-error-1',


                    keywords: ['用户错误', '误操作'],
                },
                {
                    name: 'user-marked',


                    keywords: ['用户标记', '用户指定的'],
                },
                {
                    name: 'user-locked',


                    keywords: ['用户锁定', '用户被锁定'],
                },
                {
                    name: 'user-password',


                    keywords: ['用户密码', '用户口令'],
                },
                {
                    name: 'user-list',


                    keywords: ['用户列表', '用户清单'],
                },
                {
                    name: 'user-search',


                    keywords: ['用户搜索', '搜寻用户'],
                },
                {
                    name: 'user-talk',


                    keywords: ['用户讨论', '用户交流'],
                },
                {
                    name: 'user-transmit',


                    keywords: ['用户传输', '用户传送'],
                },
                {
                    name: 'user-setting',


                    keywords: ['用户设置', '用户配置'],
                },
                {
                    name: 'user-talk-off-1',


                    keywords: ['用户禁言', '用户被禁言'],
                },
                {
                    name: 'user-time',


                    keywords: ['用户时间', '耗时'],
                },
                {
                    name: 'user-unknown',


                    keywords: ['未知用户', '未知之人'],
                },
                {
                    name: 'user-talk-1',


                    keywords: ['用户讨论', '用户交流'],
                },
                {
                    name: 'user-visible',


                    keywords: ['用户可见', '对用户可见'],
                },
                {
                    name: 'user',


                    keywords: ['用户', '顾客'],
                },
                {
                    name: 'user-unlocked',


                    keywords: ['用户解锁', '用户解除锁定'],
                },
                {
                    name: 'user-vip',


                    keywords: ['用户会员', 'VIP 用户'],
                },
                {
                    name: 'usergroup-clear',


                    keywords: ['用户组清除', '用户组清空'],
                },
                {
                    name: 'usergroup-add',


                    keywords: ['用户组添加', '用户组创建'],
                },
                {
                    name: 'usergroup',


                    keywords: ['用户组', '用户群组'],
                },
                {
                    name: 'verify',


                    keywords: ['校验', '验证'],
                },
                {
                    name: 'user-safety',


                    keywords: ['用户安全', '安全性'],
                },
            ],
        },
        File: {
            labelCN: '文件',
            labelEn: 'File',
            icons: [
                {
                    name: 'book-open',


                    keywords: ['书打开', '书翻开'],
                },
                {
                    name: 'book-unknown',


                    keywords: ['书未知', '未知的书'],
                },
                {
                    name: 'certificate',


                    keywords: ['证书', '证明书'],
                },
                {
                    name: 'bill',


                    keywords: ['帐单', '账单'],
                },
                {
                    name: 'catalog',


                    keywords: ['目录', '登记'],
                },
                {
                    name: 'cloud-upload',


                    keywords: ['云端上传', '云端文件上传'],
                },
                {
                    name: 'cloud-download',


                    keywords: ['云端下载', '云端下载文件'],
                },
                {
                    name: 'collection',


                    keywords: ['集合', '集合体'],
                },
                {
                    name: 'constraint',


                    keywords: ['约束', '限制'],
                },
                {
                    name: 'course',


                    keywords: ['课程', '教程'],
                },
                {
                    name: 'coupon',


                    keywords: ['优惠券', '折扣券'],
                },
                {
                    name: 'copy',


                    keywords: ['复制,拷贝'],
                },
                {
                    name: 'file-add',


                    keywords: ['文件添加', '添加文件'],
                },
                {
                    name: 'download-1',


                    keywords: ['下载', '下载文件'],
                },
                {
                    name: 'file-blocked',


                    keywords: ['文件被阻止', '文件受阻'],
                },
                {
                    name: 'discount',


                    keywords: ['折扣', '降价'],
                },
                {
                    name: 'file-add-1',


                    keywords: ['文件添加', '添加文件'],
                },
                {
                    name: 'file-code-1',


                    keywords: ['文件代码', '代码文件'],
                },
                {
                    name: 'file-code',


                    keywords: ['文件代码', '代码文件'],
                },
                {
                    name: 'file-1',


                    keywords: ['文件,档案'],
                },
                {
                    name: 'file-download',


                    keywords: ['文件下载', '下载文件'],
                },
                {
                    name: 'file-copy',


                    keywords: ['文件复制', '档案复制'],
                },
                {
                    name: 'file-icon',


                    keywords: ['文件图标', '文件图标'],
                },
                {
                    name: 'file-export',


                    keywords: ['文件导出', '文件输出'],
                },
                {
                    name: 'file-image',


                    keywords: ['文件图片', '图片文件'],
                },
                {
                    name: 'file-excel',


                    keywords: ['文件', '电子表格'],
                },
                {
                    name: 'file-minus',


                    keywords: ['文件减一', '减一个文件'],
                },
                {
                    name: 'file-import',


                    keywords: ['文件导入', '档案汇入'],
                },
                {
                    name: 'file-music',


                    keywords: ['音乐文件', '音频文件'],
                },
                {
                    name: 'file-locked',


                    keywords: ['文件被锁定', '文件被占用'],
                },
                {
                    name: 'file-onenote',


                    keywords: ['文件-onenote', '文件-onenote'],
                },
                {
                    name: 'file-paste',


                    keywords: ['文件粘贴', '档案贴上'],
                },
                {
                    name: 'file-powerpoint',


                    keywords: ['文件,PowerPoint,演示文稿'],
                },
                {
                    name: 'file-teams',


                    keywords: ['文件团队', '文件组'],
                },
                {
                    name: 'file-safety',


                    keywords: ['文件安全', '安全性文件'],
                },
                {
                    name: 'file-transmit-double',


                    keywords: ['文件传输双重', '文件传输双份'],
                },
                {
                    name: 'file-transmit',


                    keywords: ['文件传输', '文件传送'],
                },
                {
                    name: 'file-outlook',


                    keywords: ['文件 outlook', 'Outlook 文件'],
                },
                {
                    name: 'file-setting',


                    keywords: ['文件设置', '文件配置'],
                },
                {
                    name: 'file-unknown',


                    keywords: ['未知的文件', '未知类型的文件'],
                },
                {
                    name: 'file-word',


                    keywords: ['文件词', 'word文档'],
                },
                {
                    name: 'file-pdf',


                    keywords: ['文件-PDF', 'PDF文件'],
                },
                {
                    name: 'file-zip',


                    keywords: ['文件压缩', '档案压缩'],
                },
                {
                    name: 'file',


                    keywords: ['文件,档案'],
                },
                {
                    name: 'file-unlocked',


                    keywords: ['文件未锁定', '文件解锁'],
                },
                {
                    name: 'folder-add',


                    keywords: ['添加文件夹', '文件夹添加'],
                },
                {
                    name: 'folder-add-1',


                    keywords: ['添加文件夹', '文件夹添加'],
                },
                {
                    name: 'folder-details',


                    keywords: ['文件夹详情', '文件夹详细信息'],
                },
                {
                    name: 'folder-export',


                    keywords: ['文件夹导出', '文件夹共享'],
                },
                {
                    name: 'folder-1',


                    keywords: ['文件夹', '档案夹'],
                },
                {
                    name: 'folder-blocked',


                    keywords: ['文件夹被阻止', '文件夹受限制'],
                },
                {
                    name: 'folder-off',


                    keywords: ['文件夹关闭', '文件夹取消'],
                },
                {
                    name: 'folder-move',


                    keywords: ['文件夹移动', '文件夹迁移'],
                },
                {
                    name: 'folder-open-1',


                    keywords: ['文件夹打开', '文件夹展开'],
                },
                {
                    name: 'folder-minus',


                    keywords: ['文件夹减一', '减一文件夹'],
                },
                {
                    name: 'folder-open',


                    keywords: ['文件夹打开', '文件夹展开'],
                },
                {
                    name: 'folder-import',


                    keywords: ['文件夹导入', '文件夹引入'],
                },
                {
                    name: 'folder-locked',


                    keywords: ['文件夹锁定', '文件夹被锁定'],
                },
                {
                    name: 'folder-search',


                    keywords: ['文件夹搜索', '文件夹查找'],
                },
                {
                    name: 'folder-setting',


                    keywords: ['文件夹设置', '文件夹配置'],
                },
                {
                    name: 'folder-unlocked',


                    keywords: ['文件夹未锁定', '文件夹解锁'],
                },
                {
                    name: 'folder',


                    keywords: ['文件夹', '档案夹'],
                },
                {
                    name: 'folder-shared',


                    keywords: ['文件夹共享', '文件夹共用'],
                },
                {
                    name: 'hd',


                    keywords: ['高清', '高清晰度'],
                },
                {
                    name: 'link-1',


                    keywords: ['链接', '链接'],
                },
                {
                    name: 'media-library',


                    keywords: ['媒体库', '媒体藏书室'],
                },
                {
                    name: 'file-search',


                    keywords: ['文件搜索', '查找文件'],
                },
                {
                    name: 'music-2',


                    keywords: ['音乐', '音乐'],
                },
                {
                    name: 'screen-4k',


                    keywords: ['screen', '屏蔽', '筛选'],
                },
                {
                    name: 'folder-zip',


                    keywords: ['文件夹压缩', '文件夹zip'],
                },
                {
                    name: 'task-1',


                    keywords: ['任务', '工作'],
                },
                {
                    name: 'paste',


                    keywords: ['粘贴', '贴上'],
                },
                {
                    name: 'task-double',


                    keywords: ['任务加倍', '工作量翻倍'],
                },
                {
                    name: 'task-checked',


                    keywords: ['任务完成', '任务已核对'],
                },
                {
                    name: 'music-1',


                    keywords: ['乐谱', '歌曲'],
                },
                {
                    name: 'task-add',


                    keywords: ['任务添加', '添加任务'],
                },
                {
                    name: 'task-location',


                    keywords: ['任务地点', '工作地点'],
                },
                {
                    name: 'task-error',


                    keywords: ['任务错误', '作业错误'],
                },
                {
                    name: 'subtitle',


                    keywords: ['字幕', '字幕翻译'],
                },
                {
                    name: 'task-setting',


                    keywords: ['任务设定', '任务设置'],
                },
                {
                    name: 'task-marked',


                    keywords: ['任务标记', '任务打标'],
                },
                {
                    name: 'task-time',


                    keywords: ['任务时间', '工作时长'],
                },
                {
                    name: 'task-visible',


                    keywords: ['任务可见', '任务可视'],
                },
                {
                    name: 'template',


                    keywords: ['模板', '样板'],
                },
                {
                    name: 'task',


                    keywords: ['任务', '工作'],
                },
                {
                    name: 'ticket',


                    keywords: ['票', '票据'],
                },
                {
                    name: 'upload-1',


                    keywords: ['上传', '上传文件'],
                },
            ],
        },
        Component: {
            labelCN: '组件',
            labelEn: 'Component',
            icons: [
                {
                    name: 'calendar',


                    keywords: ['日历', '月份表'],
                },
                {
                    name: 'component-breadcrumb',


                    keywords: ['面包屑组件', '导航面包屑'],
                },
                {
                    name: 'card',


                    keywords: ['卡片', '牌'],
                },
                {
                    name: 'component-checkbox',


                    keywords: ['组件复选框', '组件选择框'],
                },
                {
                    name: 'button',


                    keywords: ['按钮', '按钮'],
                },
                {
                    name: 'component-divider-vertical',


                    keywords: ['垂直分隔组件', '垂直组件分隔线'],
                },
                {
                    name: 'component-layout',


                    keywords: ['组件布局', '组件排版'],
                },
                {
                    name: 'component-divider-horizontal',


                    keywords: ['水平分隔组件', '水平组件分割线'],
                },
                {
                    name: 'component-grid',


                    keywords: ['组件网格', '组件布局'],
                },
                {
                    name: 'chat-bubble-error',


                    keywords: ['错误聊天气泡', '错误信息气泡'],
                },
                {
                    name: 'component-input',


                    keywords: ['组件输入', '组件式输入'],
                },
                {
                    name: 'data-display',


                    keywords: ['数据显示', '数据展示'],
                },
                {
                    name: 'component-switch',


                    keywords: ['组件开关', '组件式开关'],
                },
                {
                    name: 'component-space',


                    keywords: ['组件空间', '组件领域'],
                },
                {
                    name: 'expand-down',


                    keywords: ['展开向下', '展开式向下'],
                },
                {
                    name: 'component-radio',


                    keywords: ['组件单选', '组件电台'],
                },
                {
                    name: 'component-steps',


                    keywords: ['组件步骤', '组件式步骤'],
                },
                {
                    name: 'expand-up',


                    keywords: ['扩展向上', '向上扩展'],
                },
                {
                    name: 'horizontal',


                    keywords: ['水平线', '水平面'],
                },
                {
                    name: 'icon',


                    keywords: ['图标', '图标', '图标', '图标'],
                },
                {
                    name: 'component-dropdown',


                    keywords: ['组件下拉菜单', '组件式下拉菜单'],
                },
                {
                    name: 'link',


                    keywords: ['链接', '链接', '链接', '链接'],
                },
                {
                    name: 'menu',


                    keywords: ['菜单', '菜单项'],
                },
                {
                    name: 'page-head',


                    keywords: ['页面头部', '页面顶端'],
                },
                {
                    name: 'scroll-bar',


                    keywords: ['滚动条', '滚动条'],
                },
                {
                    name: 'slideshow',


                    keywords: ['幻灯片展示', '幻灯片演示'],
                },
                {
                    name: 'link-unlink',


                    keywords: ['断开链接', '移除链接'],
                },
                {
                    name: 'tab',


                    keywords: ['制表符', '表格符号'],
                },
                {
                    name: 'table-2',


                    keywords: ['表格', '表格形式'],
                },
                {
                    name: 'tag',


                    keywords: ['标记', '标签'],
                },
                {
                    name: 'vertical',


                    keywords: ['垂直的', '竖直的'],
                },
                {
                    name: 'typography',


                    keywords: ['排版', '字体设计'],
                },
                {
                    name: 'form',


                    keywords: ['表格', '表单'],
                },
            ],
        },
        Else: {
            labelCN: '其他',
            labelEn: 'Else',
            icons: [
                {
                    name: 'loading',


                    keywords: ['装货中,加载中'],
                },
            ],
        },
        System: {
            labelCN: '系统',
            labelEn: 'System',
            icons: [
                {
                    name: 'add-rectangle',


                    keywords: ['添加矩形', '绘制矩形'],
                },
                {
                    name: 'application',


                    keywords: ['应用程序', '应用程式'],
                },
                {
                    name: 'app',


                    keywords: ['应用程序', '应用软件'],
                },
                {
                    name: 'ellipsis',


                    keywords: ['省略号', '三点省略号'],
                },
                {
                    name: 'check-rectangle',


                    keywords: ['检查矩形', '校验矩形'],
                },
                {
                    name: 'control-platform',


                    keywords: ['控制平台', '控制面板'],
                },
                {
                    name: 'filter-off',


                    keywords: ['过滤关闭', '过滤掉'],
                },
                {
                    name: 'hard-disk-storage',


                    keywords: ['硬盘存储', '硬盘储存'],
                },
                {
                    name: 'filter-clear',


                    keywords: ['过滤清除', '筛选清空'],
                },
                {
                    name: 'filter-sort',


                    keywords: ['过滤排序', '筛选排序'],
                },
                {
                    name: 'dashboard',


                    keywords: ['仪表板', '控制面板'],
                },
                {
                    name: 'hourglass',


                    keywords: ['沙漏', '时计'],
                },
                {
                    name: 'filter',


                    keywords: ['过滤', '筛选'],
                },
                {
                    name: 'load',


                    keywords: ['负载', '负荷'],
                },
                {
                    name: 'logo-windows',


                    keywords: ['"logo-windows', 'windows徽标"'],
                },
                {
                    name: 'menu-unfold',


                    keywords: ['菜单展开', '菜单未折叠'],
                },
                {
                    name: 'menu-fold',


                    keywords: ['菜单折叠', '菜单收起'],
                },
                {
                    name: 'minus-rectangle',


                    keywords: ['负矩形', '减矩形'],
                },
                {
                    name: 'more',


                    keywords: ['"更多', '额外"\n"另外', '增添"'],
                },
                {
                    name: 'menu-application',


                    keywords: ['菜单应用', '应用程序菜单'],
                },
                {
                    name: 'relativity',


                    keywords: ['相对论', '相对性'],
                },
                {
                    name: 'service',


                    keywords: ['服务', '服务项目'],
                },
                {
                    name: 'share',


                    keywords: ['分享', '分享'],
                },
                {
                    name: 'system-application',


                    keywords: ['系统应用', '应用程序系统'],
                },
                {
                    name: 'system-blocked',


                    keywords: ['系统阻塞', '禁用系统'],
                },
                {
                    name: 'system-code',


                    keywords: ['系统代码', '系统编码'],
                },
                {
                    name: 'system-2',


                    keywords: ['系统', '体系'],
                },
                {
                    name: 'system-components',


                    keywords: ['系统组件', '系统组成部件'],
                },
                {
                    name: 'system-coordinate',


                    keywords: ['系统坐标', '系统位置'],
                },
                {
                    name: 'system-device',


                    keywords: ['系统设备', '机器装置'],
                },
                {
                    name: 'system-interface',


                    keywords: ['系统接口', '系统界面'],
                },
                {
                    name: 'system-location',


                    keywords: ['系统位置', '设备位置'],
                },
                {
                    name: 'system-locked',


                    keywords: ['系统锁定', '机器锁定'],
                },
                {
                    name: 'system-3',


                    keywords: ['系统', '体系'],
                },
                {
                    name: 'system-messages',


                    keywords: ['系统消息', '系统信息'],
                },
                {
                    name: 'system-regulation',


                    keywords: ['系统调节', '制度性监管'],
                },
                {
                    name: 'system-setting',


                    keywords: ['系统设置', '系统配置'],
                },
                {
                    name: 'system-marked',


                    keywords: ['系统标记', '系统打标'],
                },
                {
                    name: 'system-search',


                    keywords: ['系统搜索', '系统查找'],
                },
                {
                    name: 'system-unlocked',


                    keywords: ['系统解锁', '解锁系统'],
                },
                {
                    name: 'system-storage',


                    keywords: ['系统存储', '储存系统'],
                },
                {
                    name: 'system-sum',


                    keywords: ['系统总计', '汇总系统'],
                },
                {
                    name: 'queue',


                    keywords: ['队列', '排队'],
                },
                {
                    name: 'view-module',


                    keywords: ['视图模块', '视图单元'],
                },
                {
                    name: 'system-log',


                    keywords: ['系统日志', '系统记录'],
                },
                {
                    name: 'mail',


                    keywords: ['邮件', '邮件通讯'],
                },
            ],
        },
        Arrows: {
            labelCN: '箭头',
            labelEn: 'Arrows',
            icons: [
                {
                    name: 'arrow-left-down-circle',


                    keywords: ['箭头向左下圆圈', '箭头左下向圆圈'],
                },
                {
                    name: 'arrow-left-circle',


                    keywords: ['向左箭头圆圈', '左向圆圈箭头'],
                },
                {
                    name: 'arrow-down',


                    keywords: ['箭头向下', '向下箭头'],
                },
                {
                    name: 'arrow-down-circle',


                    keywords: ['箭头向下圆圈', '向下箭头圆圈'],
                },
                {
                    name: 'arrow-left-right-1',


                    keywords: ['左右箭头', '左右方向箭头'],
                },
                {
                    name: 'arrow-left-right-3',


                    keywords: ['左右箭头', '左右方向箭头'],
                },
                {
                    name: 'arrow-left-up',


                    keywords: ['上左箭头', '左上角箭头'],
                },
                {
                    name: 'arrow-left-right-2',


                    keywords: ['左右箭头', '左右方向箭头'],
                },
                {
                    name: 'arrow-down-rectangle',


                    keywords: ['箭头向下矩形', '箭头下矩形'],
                },
                {
                    name: 'arrow-left-down',


                    keywords: ['箭头左下', '向左下方箭头'],
                },
                {
                    name: 'arrow-right-circle',


                    keywords: ['箭头向右圆圈', '箭头右向圆圈'],
                },
                {
                    name: 'arrow-left-up-circle',


                    keywords: ['上左箭头圆圈', '左上角向上箭头圆圈'],
                },
                {
                    name: 'arrow-right-down-circle',


                    keywords: ['箭头右下圆圈', '箭头右下向圆圈'],
                },
                {
                    name: 'arrow-right-down',


                    keywords: ['箭头向右下', '右下角箭头'],
                },
                {
                    name: 'arrow-left-right-circle',


                    keywords: ['左右箭头圆圈', '左右箭头循环'],
                },
                {
                    name: 'arrow-triangle-down',


                    keywords: ['箭头三角形向下', '箭头向下三角形'],
                },
                {
                    name: 'arrow-left',


                    keywords: ['箭头左', '左箭头'],
                },
                {
                    name: 'arrow-right-up-circle',


                    keywords: ['箭头向右上方圆圈', '箭头右上方带圆圈'],
                },
                {
                    name: 'arrow-right-up',


                    keywords: ['箭头向右上方', '箭头右上方'],
                },
                {
                    name: 'arrow-up-circle',


                    keywords: ['向上箭头圆圈', '箭头向上圆圈'],
                },
                {
                    name: 'arrow-triangle-up',


                    keywords: ['箭头向上三角形', '箭头在上三角'],
                },
                {
                    name: 'arrow-right',


                    keywords: ['箭头向右', '右箭头'],
                },
                {
                    name: 'arrow-up-down-1',


                    keywords: ['箭头上下', '上下箭头'],
                },
                {
                    name: 'arrow-up-down-2',


                    keywords: ['箭头上下', '上下箭头'],
                },
                {
                    name: 'backtop-rectangle',


                    keywords: ['反顶矩形', '背面矩形'],
                },
                {
                    name: 'arrow-up',


                    keywords: ['箭头向上', '箭头朝上'],
                },
                {
                    name: 'arrow-up-down-3',


                    keywords: ['箭头上下', '上下箭头'],
                },
                {
                    name: 'caret-down',


                    keywords: ['向下箭头', '下拉箭头'],
                },
                {
                    name: 'caret-down-small',


                    keywords: ['向下小箭头', '向下小三角'],
                },
                {
                    name: 'backtop',


                    keywords: ['"back to top"', '"回到顶部"'],
                },
                {
                    name: 'caret-left-small',


                    keywords: ['左边小箭头', '左侧小箭头'],
                },
                {
                    name: 'caret-right-small',


                    keywords: ['向右小箭头', '右移小箭头'],
                },
                {
                    name: 'arrow-up-down-circle',


                    keywords: ['上箭头圆圈', '下箭头圆圈'],
                },
                {
                    name: 'caret-right',


                    keywords: ['向右箭头', '右键指向'],
                },
                {
                    name: 'chevron-down-circle',


                    keywords: ['箭头向下圆圈', '向下箭头圆圈'],
                },
                {
                    name: 'chevron-down-double',


                    keywords: ['箭头向下双', '双箭头向下'],
                },
                {
                    name: 'caret-up-small',


                    keywords: ['上箭头小', '向上小箭头'],
                },
                {
                    name: 'chevron-down-rectangle',


                    keywords: ['箭头向下矩形', '箭头下矩形'],
                },
                {
                    name: 'chevron-down-double-s',


                    keywords: ['箭头向下双S', '双箭头向下S'],
                },
                {
                    name: 'chevron-left-circle',


                    keywords: [
                        '"chevron-left-circle" 可以翻译为以下两个中文短语：\n\n1. 左箭头的圆圈,\n2. 左向箭头圆圈',
                    ],
                },
                {
                    name: 'chevron-down',


                    keywords: ['箭头向下', '箭头降下'],
                },
                {
                    name: 'caret-left',


                    keywords: ['向左移动光标', '光标左移'],
                },
                {
                    name: 'chevron-down-s',


                    keywords: ['箭头向下', '小箭头向下'],
                },
                {
                    name: 'chevron-left-double-s',


                    keywords: ['"双箭头向左', '双S形向左"'],
                },
                {
                    name: 'caret-up',


                    keywords: ['向上箭头', '向上键'],
                },
                {
                    name: 'chevron-left-double',


                    keywords: ['"双箭头向左', '箭头向左双"'],
                },
                {
                    name: 'chevron-left-rectangle',


                    keywords: ['"箭头左矩形', '左箭头矩形"'],
                },
                {
                    name: 'chevron-left-s',


                    keywords: ['"箭头向左', '小箭头左"'],
                },
                {
                    name: 'chevron-left',


                    keywords: ['箭头向左', '左箭头'],
                },
                {
                    name: 'chevron-right-circle',


                    keywords: ['箭头向右圆圈', '右箭头圆圈'],
                },
                {
                    name: 'chevron-right-double-s',


                    keywords: ['箭头向右双S', '箭头右双S'],
                },
                {
                    name: 'chevron-right-s',


                    keywords: ['箭头向右', '箭头右下'],
                },
                {
                    name: 'chevron-right-rectangle',


                    keywords: ['箭头右矩形', '箭头右方矩形'],
                },
                {
                    name: 'chevron-up-double-s',


                    keywords: ['箭头向上双S', '箭头向上双S形状'],
                },
                {
                    name: 'chevron-up-double',


                    keywords: ['箭头向上双', '双箭头向上'],
                },
                {
                    name: 'chevron-right-double',


                    keywords: ['箭头向右双', '双箭头向右'],
                },
                {
                    name: 'chevron-up-rectangle',


                    keywords: ['箭头向上矩形', '箭头在上矩形'],
                },
                {
                    name: 'chevron-up-circle',


                    keywords: ['箭头向上圆圈', '箭头向上圆圈图标'],
                },
                {
                    name: 'chevron-up',


                    keywords: ['箭头向上', '箭头升'],
                },
                {
                    name: 'chevron-up-s',


                    keywords: ['箭头向上', '箭头向上', '箭头向上', '箭头向上'],
                },
                {
                    name: 'enter',


                    keywords: ['回车', '输入'],
                },
                {
                    name: 'download',


                    keywords: ['下载', '下载文件'],
                },
                {
                    name: 'fullscreen-2',


                    keywords: ['全屏', '全屏幕'],
                },
                {
                    name: 'fullscreen-1',


                    keywords: ['全屏', '全屏幕'],
                },
                {
                    name: 'expand-vertical',


                    keywords: ['垂直展开', '竖直扩展'],
                },
                {
                    name: 'fullscreen-exit-1',


                    keywords: ['全屏退出', '退出全屏模式'],
                },
                {
                    name: 'login',


                    keywords: ['登录', '登录'],
                },
                {
                    name: 'chevron-right',


                    keywords: ['箭头向右', '右箭头'],
                },
                {
                    name: 'logout',


                    keywords: ['登出', '注销'],
                },
                {
                    name: 'fullscreen-exit',


                    keywords: ['全屏退出', '退出全屏模式'],
                },
                {
                    name: 'expand-horizontal',


                    keywords: ['水平扩展', '水平展开'],
                },
                {
                    name: 'highlight',


                    keywords: ['高亮', '强调'],
                },
                {
                    name: 'order-adjustment-column',


                    keywords: ['订单调整列', '订单调整栏目'],
                },
                {
                    name: 'swap-left',


                    keywords: ['交换左侧', '左侧互换'],
                },
                {
                    name: 'rollfront',


                    keywords: [],
                },
                {
                    name: 'shrink-horizontal',


                    keywords: ['水平压缩', '水平缩减'],
                },
                {
                    name: 'move-1',


                    keywords: ['移动', '搬家'],
                },
                {
                    name: 'swap',


                    keywords: ['交换', '调换'],
                },
                {
                    name: 'rollback',


                    keywords: ['回滚操作', '撤销操作'],
                },
                {
                    name: 'shrink-vertical',


                    keywords: ['垂直缩小', '竖向压缩'],
                },
                {
                    name: 'swap-right',


                    keywords: ['向右交换', '右边互换'],
                },
                {
                    name: 'unfold-more',


                    keywords: ['展开更多', '展开全部内容'],
                },
                {
                    name: 'upload',


                    keywords: ['上传', '上传文件'],
                },
                {
                    name: 'unfold-less',


                    keywords: ['展开式', '无折叠'],
                },
            ],
        },
        Alert: {
            labelCN: '警报',
            labelEn: 'Alert',
            icons: [
                {
                    name: 'check-circle',


                    keywords: ['圆圈复选', '勾选圆形'],
                },
                {
                    name: 'error-circle',


                    keywords: ['错误圆圈', '错误圈'],
                },
                {
                    name: 'close-octagon',


                    keywords: ['闭合八角形,闭式八角形'],
                },
                {
                    name: 'info-circle',


                    keywords: ['信息圈', '资讯圈'],
                },
                {
                    name: 'minus-circle',


                    keywords: ['负圈,减圆'],
                },
                {
                    name: 'close-circle',


                    keywords: ['闭环', '闭合循环'],
                },
                {
                    name: 'notification-add',


                    keywords: ['通知添加', '添加通知', '铃铛'],
                },
                {
                    name: 'error-triangle',


                    keywords: ['错误三角形', '错误三角'],
                },
                {
                    name: 'notification',


                    keywords: ['通知', '通报', '铃铛'],
                },
                {
                    name: 'delete-time',


                    keywords: ['删除时间', '删除时刻', '垃圾桶'],
                },
                {
                    name: 'time',


                    keywords: ['时光', '时间'],
                },
                {
                    name: 'notification-error',


                    keywords: ['通知错误', '错误通知', '铃铛'],
                },
                {
                    name: 'help-circle',


                    keywords: ['帮助圈', '支援圈'],
                },
                {
                    name: 'shield-error',


                    keywords: ['盾牌错误', '盾形错误'],
                },
            ],
        },
        Emoji: {
            labelCN: '表情',
            labelEn: 'Emoji',
            icons: [
                {
                    name: 'angry',


                    keywords: ['生气', '愤怒'],
                },
                {
                    name: 'bad-laugh',


                    keywords: [
                        '"bad laugh," 可以翻译为两个可能的中文短语：\n1. "不好的笑"\n2. "笑声不好"',
                    ],
                },
                {
                    name: 'calm',


                    keywords: ['宁静', '平静'],
                },
                {
                    name: 'calm-1',


                    keywords: ['宁静', '平静'],
                },
                {
                    name: 'awkward',


                    keywords: ['尴尬', '不自在'],
                },
                {
                    name: 'cry-and-laugh',


                    keywords: ['笑中带泪', '哭笑不得'],
                },
                {
                    name: 'cry-loudly',


                    keywords: ['大声哭泣', '哭出声来'],
                },
                {
                    name: 'crooked-smile',


                    keywords: ['歪嘴笑', '邪笑'],
                },
                {
                    name: 'cat',


                    keywords: ['猫', '猫咪'],
                },
                {
                    name: 'dissatisfaction',


                    keywords: ['不满意', '不满'],
                },
                {
                    name: 'crack',


                    keywords: ['裂痕', '缝隙'],
                },
                {
                    name: 'emo-emotional',


                    keywords: ['情绪化', '感性'],
                },
                {
                    name: 'despise',


                    keywords: ['轻视', '鄙视'],
                },
                {
                    name: 'feel-at-ease',


                    keywords: ['感觉自在', '感到舒适'],
                },
                {
                    name: 'excited-1',


                    keywords: ['激动的', '兴奋的'],
                },
                {
                    name: 'doge',


                    keywords: ['狗狗', '狗的'],
                },
                {
                    name: 'ferocious',


                    keywords: ['凶猛的', '激烈的'],
                },
                {
                    name: 'depressed',


                    keywords: ['沮丧的', '情绪低落的'],
                },
                {
                    name: 'flip-smiling-face',


                    keywords: ['翻白眼', '嘴角上扬'],
                },
                {
                    name: 'giggle',


                    keywords: ['“咯咯笑', '嬉皮笑脸”'],
                },
                {
                    name: 'excited',


                    keywords: ['激动的', '兴奋的'],
                },
                {
                    name: 'joyful',


                    keywords: ['欢乐的', '快乐的'],
                },
                {
                    name: 'look-around',


                    keywords: ['环顾四周', '四处看看'],
                },
                {
                    name: 'no-expression',


                    keywords: ['无表达式', '不表达式'],
                },
                {
                    name: 'open-mouth',


                    keywords: ['张嘴', '咧嘴'],
                },
                {
                    name: 'shutup',


                    keywords: ['闭嘴', '停止说话'],
                },
                {
                    name: 'happy',


                    keywords: ['快乐', '高兴'],
                },
                {
                    name: 'roast',


                    keywords: ['烤', '炙'],
                },
                {
                    name: 'serenity',


                    keywords: ['宁静', '安详'],
                },
                {
                    name: 'smile',


                    keywords: ['微笑', '笑容'],
                },
                {
                    name: 'sinister-smile',


                    keywords: ['邪恶的微笑', '阴险的笑容'],
                },
                {
                    name: 'sneer',


                    keywords: ['嘲笑', '讥讽'],
                },
                {
                    name: 'pout',


                    keywords: ['噘嘴', '嘟囔'],
                },
                {
                    name: 'sleep',


                    keywords: ['睡觉', '休息'],
                },
                {
                    name: 'speechless',


                    keywords: ['哑口无言', '说不出话来'],
                },
                {
                    name: 'speechless-1',


                    keywords: ['哑口无言', '说不出话来'],
                },
                {
                    name: 'uncomfortable-1',


                    keywords: ['不舒适', '不自在'],
                },
                {
                    name: 'swear-1',


                    keywords: ['发誓', '咒语'],
                },
                {
                    name: 'unhappy-1',


                    keywords: ['不高兴', '不快乐'],
                },
                {
                    name: 'swear-2',


                    keywords: ['发誓', '咒语'],
                },
                {
                    name: 'surprised-1',


                    keywords: ['吃惊', '惊讶'],
                },
                {
                    name: 'unhappy',


                    keywords: ['不高兴', '不快乐'],
                },
                {
                    name: 'uncomfortable-2',


                    keywords: ['不舒适的', '不自在的'],
                },
                {
                    name: 'wry-smile',


                    keywords: ['歪嘴笑', '扭曲的微笑'],
                },
                {
                    name: 'wink',


                    keywords: ['眨眼', '频眨眼'],
                },
                {
                    name: 'surprised',


                    keywords: ['吃惊', '惊讶'],
                },
                {
                    name: 'uncomfortable',


                    keywords: ['不舒适', '不自在'],
                },
            ],
        },
        Action: {
            labelCN: '行动',
            labelEn: 'Action',
            icons: [
                {
                    name: 'address-book',


                    keywords: ['通讯录', '通讯簿'],
                },
                {
                    name: 'alarm-add',


                    keywords: ['添加闹钟', '增加闹钟'],
                },
                {
                    name: 'accessibility',


                    keywords: ['可达性', '无障碍性'],
                },
                {
                    name: 'alarm-off',


                    keywords: ['闹钟关闭', '取消闹钟'],
                },
                {
                    name: 'anchor',


                    keywords: ['锚', '锚点', '锚定'],
                },
                {
                    name: 'assignment-code',


                    keywords: ['作业代码', '分配代码'],
                },
                {
                    name: 'api',


                    keywords: [
                        '"api 的中文短语1：应用程序编程接口', 'api 的中文短语2：应用程序接口"',
                    ],
                },
                {
                    name: 'article',


                    keywords: ['文章', '文章内容'],
                },
                {
                    name: 'analytics',


                    keywords: ['分析', '剖析'],
                },
                {
                    name: 'assignment-user',


                    keywords: ['任务分配给用户', '用户的任务分配'],
                },
                {
                    name: 'alarm',


                    keywords: ['闹钟', '警报'],
                },
                {
                    name: 'assignment-checked',


                    keywords: ['任务检查', '赋值检查'],
                },
                {
                    name: 'assignment-error',


                    keywords: ['作业错误', '分配错误'],
                },
                {
                    name: 'book',


                    keywords: ['书', '册', '卷'],
                },
                {
                    name: 'assignment',


                    keywords: ['作业', '分配任务'],
                },
                {
                    name: 'add',


                    keywords: ['添加', '增加'],
                },
                {
                    name: 'backup',


                    keywords: ['备份', '备份文件'],
                },
                {
                    name: 'bookmark-double',


                    keywords: ['书签双重', '双重书签'],
                },
                {
                    name: 'bookmark-checked',


                    keywords: ['已标记为已读', '已加书签'],
                },
                {
                    name: 'bookmark',


                    keywords: ['书签', '书签'],
                },
                {
                    name: 'bookmark-minus',


                    keywords: ['书签减一', '书签减号'],
                },
                {
                    name: 'barcode',


                    keywords: ['条码', '条形码'],
                },
                {
                    name: 'bug-report',


                    keywords: ['错误报告', '错误报告'],
                },
                {
                    name: 'browse-gallery',


                    keywords: ['浏览图库', '查看图库'],
                },
                {
                    name: 'bookmark-add',


                    keywords: ['书签添加', '添加书签'],
                },
                {
                    name: 'browse',


                    keywords: ['浏览', '浏览网页', '眼睛'],
                },
                {
                    name: 'calendar-edit',


                    keywords: ['日历编辑', '日程安排编辑'],
                },
                {
                    name: 'calendar-2',


                    keywords: ['日历', '月份表'],
                },
                {
                    name: 'cart-add',


                    keywords: ['购物车添加', '添加到购物车'],
                },
                {
                    name: 'browse-off',


                    keywords: ['浏览关闭', '关闭浏览', '眼睛'],
                },
                {
                    name: 'cardmembership',


                    keywords: ['卡片会员资格', '会员卡资格'],
                },
                {
                    name: 'calendar-1',


                    keywords: ['日历', '月份表'],
                },
                {
                    name: 'cart',


                    keywords: ['购物车', '购物篮'],
                },
                {
                    name: 'calendar-event',


                    keywords: ['日历事件', '日程安排'],
                },
                {
                    name: 'chart',


                    keywords: ['图表', '图表展示'],
                },
                {
                    name: 'check',


                    keywords: ['核对', '检查'],
                },
                {
                    name: 'close',


                    keywords: ['关闭', '闭合'],
                },
                {
                    name: 'check-double',


                    keywords: ['"检查重复项,核实双重"'],
                },
                {
                    name: 'copyright',


                    keywords: ['版权', '著作权'],
                },
                {
                    name: 'creditcard-add',


                    keywords: ['信用卡添加', '信用卡通加'],
                },
                {
                    name: 'creditcard-off',


                    keywords: ['信用卡关闭', '信用卡停用'],
                },
                {
                    name: 'chat-bubble-help',


                    keywords: ['聊天气泡帮助', '聊天帮助气泡'],
                },
                {
                    name: 'color-invert',


                    keywords: ['色彩反转', '颜色颠倒'],
                },
                {
                    name: 'creditcard',


                    keywords: ['信用卡', '信用卡通'],
                },
                {
                    name: 'currency-exchange',


                    keywords: ['货币兑换', '汇率转换'],
                },
                {
                    name: 'chart-add',


                    keywords: ['图表添加', '图表新增'],
                },
                {
                    name: 'dashboard-1',


                    keywords: ['仪表板', '控制面板'],
                },
                {
                    name: 'close-rectangle',


                    keywords: ['闭合矩形', '关闭矩形'],
                },
                {
                    name: 'delete',


                    keywords: ['删除', '删去', '垃圾桶'],
                },
                {
                    name: 'edit',


                    keywords: ['编辑', '校正'],
                },
                {
                    name: 'edit-off',


                    keywords: ['关闭编辑', '禁用编辑'],
                },
                {
                    name: 'extension-off',


                    keywords: ['扩展关闭', '扩展禁用'],
                },
                {
                    name: 'explore-off',


                    keywords: ['探索关闭', '探索取消'],
                },
                {
                    name: 'fact-check',


                    keywords: ['事实核查', '事实查证'],
                },
                {
                    name: 'file-attachment',


                    keywords: ['文件附件', '附件文件'],
                },
                {
                    name: 'extension',


                    keywords: ['扩展', '拓展'],
                },
                {
                    name: 'file-restore',


                    keywords: ['文件恢复', '档案还原'],
                },
                {
                    name: 'explore',


                    keywords: ['探索', '探究'],
                },
                {
                    name: 'flag-1',


                    keywords: ['国旗', '旗帜'],
                },
                {
                    name: 'delete-1',


                    keywords: ['删除', '删去', '垃圾桶'],
                },
                {
                    name: 'flag-3',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'fingerprint',


                    keywords: ['指纹', '指纹识别'],
                },
                {
                    name: 'flight-landing',


                    keywords: ['航班降落', '飞行着陆'],
                },
                {
                    name: 'flight-takeoff',


                    keywords: ['飞机起飞', '起飞'],
                },
                {
                    name: 'flip-to-front',


                    keywords: ['翻转正面', '翻到正面'],
                },
                {
                    name: 'flip-to-back',


                    keywords: ['翻转背面对', '翻到背面去'],
                },
                {
                    name: 'grid-view',


                    keywords: ['网格视图', '网格布局'],
                },
                {
                    name: 'flag-2',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'flag',


                    keywords: ['国旗', '国徽'],
                },
                {
                    name: 'help-rectangle',


                    keywords: ['帮助矩形', '辅助矩形'],
                },
                {
                    name: 'heart',


                    keywords: ['心情', '心脏'],
                },
                {
                    name: 'grid-add',


                    keywords: ['网格添加', '网格新增'],
                },
                {
                    name: 'gift',


                    keywords: ['礼物', '赠品'],
                },
                {
                    name: 'https',


                    keywords: ['超文本传输协议,安全超文本传输协议'],
                },
                {
                    name: 'home',


                    keywords: ['家园', '家乡'],
                },
                {
                    name: 'install-mobile',


                    keywords: ['安装手机', '手机安装'],
                },
                {
                    name: 'history-setting',


                    keywords: ['历史背景', '历史设定'],
                },
                {
                    name: 'install-desktop',


                    keywords: ['安装桌面', '桌面安装'],
                },
                {
                    name: 'jump-off',


                    keywords: ['跳车', '出发'],
                },
                {
                    name: 'internet',


                    keywords: ['因特网', '互联网'],
                },
                {
                    name: 'jump-double',


                    keywords: ['跳两次', '双重跳'],
                },
                {
                    name: 'history',


                    keywords: ['历史', '历史记录'],
                },
                {
                    name: 'jump',


                    keywords: ['跳', '跳跃'],
                },
                {
                    name: 'institution-checked',


                    keywords: ['机构审核', '机构核查'],
                },
                {
                    name: 'institution',


                    keywords: ['机构', '机构单位'],
                },
                {
                    name: 'lightbulb-circle',


                    keywords: ['电灯泡,圆形,电灯泡,环形'],
                },
                {
                    name: 'key',


                    keywords: ['密钥', '密钥信息'],
                },
                {
                    name: 'leaderboard',


                    keywords: ['排行榜', '得分榜'],
                },
                {
                    name: 'location-1',


                    keywords: ['位置', '所在地'],
                },
                {
                    name: 'lock-on',


                    keywords: ['锁定', '开锁'],
                },
                {
                    name: 'lock-time',


                    keywords: ['锁定时间', '锁定期'],
                },
                {
                    name: 'mark-as-unread',


                    keywords: ['标记为未读', '设为未读'],
                },
                {
                    name: 'lightbulb',


                    keywords: ['电灯泡', '灯泡'],
                },
                {
                    name: 'lock-off',


                    keywords: ['锁定关闭', '封锁关闭'],
                },
                {
                    name: 'mobile-blocked',


                    keywords: ['手机被屏蔽', '手机被限制'],
                },
                {
                    name: 'mobile-shortcut',


                    keywords: ['移动快捷方式', '手机快捷方式'],
                },
                {
                    name: 'module',


                    keywords: ['模块', '模组'],
                },
                {
                    name: 'mobile-list',


                    keywords: ['移动列表', '流动清单'],
                },
                {
                    name: 'lighting-circle',


                    keywords: ['灯光圈', '照明圈'],
                },
                {
                    name: 'money',


                    keywords: ['资金', '款项'],
                },
                {
                    name: 'move',


                    keywords: ['移动', '搬家'],
                },
                {
                    name: 'outbox',


                    keywords: ['发件箱', '发件文件夹'],
                },
                {
                    name: 'percent',


                    keywords: ['百分比', '百分率'],
                },
                {
                    name: 'notification-circle',


                    keywords: ['通知圆圈', '圆形通知', '铃铛'],
                },
                {
                    name: 'print',


                    keywords: ['打印', '输出'],
                },
                {
                    name: 'refresh',


                    keywords: ['更新', '刷新'],
                },
                {
                    name: 'poweroff',


                    keywords: ['关机', '断电'],
                },
                {
                    name: 'pending',


                    keywords: ['待处理', '待决'],
                },
                {
                    name: 'rocket',


                    keywords: ['火箭', '航天器'],
                },
                {
                    name: 'saving-pot',


                    keywords: ['"saving pot', '储蓄罐"\n"saving pot', '存钱罐"'],
                },
                {
                    name: 'search-error',


                    keywords: ['搜索错误', '搜索失误'],
                },
                {
                    name: 'send',


                    keywords: ['发送', '传送'],
                },
                {
                    name: 'send-cancel',


                    keywords: ['发送取消', '发出取消'],
                },
                {
                    name: 'search',


                    keywords: ['搜索', '搜寻'],
                },
                {
                    name: 'remove',


                    keywords: ['移除', '去除'],
                },
                {
                    name: 'sensors-off',


                    keywords: ['传感器关闭', '关闭传感器'],
                },
                {
                    name: 'radar',


                    keywords: ['无线电探测与测距', '无线电雷达'],
                },
                {
                    name: 'sensors',


                    keywords: ['传感器', '感应器'],
                },
                {
                    name: 'setting',


                    keywords: ['设置', '配置'],
                },
                {
                    name: 'secured',


                    keywords: [],
                },
                {
                    name: 'server',


                    keywords: ['服务器', '服务器'],
                },
                {
                    name: 'setting-1',


                    keywords: ['设置', '配置'],
                },
                {
                    name: 'star',


                    keywords: ['星星', '星光'],
                },
                {
                    name: 'shop',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'sticky-note',


                    keywords: ['便利贴', '粘性便签'],
                },
                {
                    name: 'store',


                    keywords: ['商店', '店铺'],
                },
                {
                    name: 'task-checked-1',


                    keywords: ['任务完成', '任务已核对'],
                },
                {
                    name: 'task-add-1',


                    keywords: ['任务添加', '添加任务'],
                },
                {
                    name: 'theaters',


                    keywords: ['剧院,电影院,演出场所,剧场'],
                },
                {
                    name: 'terminal-rectangle-1',


                    keywords: ['终端矩形', '终端长方形'],
                },
                {
                    name: 'thumb-down',


                    keywords: ['拇指向下', '翘起拇指表示不喜欢'],
                },
                {
                    name: 'tools-circle',


                    keywords: ['工具圈', '工具圈'],
                },
                {
                    name: 'support',


                    keywords: ['支持', '支援'],
                },
                {
                    name: 'translate-1',


                    keywords: ['转移', '翻译'],
                },
                {
                    name: 'translate',


                    keywords: ['翻译', '转换'],
                },
                {
                    name: 'thumb-up',


                    keywords: ['点赞', '翘起大拇指'],
                },
                {
                    name: 'vehicle',


                    keywords: ['车辆', '汽车'],
                },
                {
                    name: 'tools',


                    keywords: ['工具', '工具'],
                },
                {
                    name: 'trending-up',


                    keywords: ['趋势上升', '走势向上'],
                },
                {
                    name: 'trending-down',


                    keywords: ['趋势下降', '走向低迷'],
                },
                {
                    name: 'wealth-1',


                    keywords: ['财富', '财富积累'],
                },
                {
                    name: 'verified',


                    keywords: ['验证过的', '已核实的'],
                },
                {
                    name: 'wealth',


                    keywords: ['财富', '财产'],
                },
                {
                    name: 'view-agenda',


                    keywords: ['日程视图', '议程视图'],
                },
                {
                    name: 'work-off',


                    keywords: ['加班', '补偿'],
                },
                {
                    name: 'zoom-in',


                    keywords: ['放大', '放大视野'],
                },
                {
                    name: 'work-history',


                    keywords: ['工作经历', '工作历程'],
                },
                {
                    name: 'wallet',


                    keywords: ['皮夹', '钱包'],
                },
                {
                    name: 'view-in-ar',


                    keywords: ['增强现实查看', '扩增实境视野'],
                },
                {
                    name: 'work',


                    keywords: ['工作', '作业'],
                },
                {
                    name: 'zoom-out',


                    keywords: ['缩小', '缩小尺寸'],
                },
            ],
        },
        Design: {
            labelCN: '设计',
            labelEn: 'Design',
            icons: [
                {
                    name: 'anticlockwise',


                    keywords: ['逆时针', '逆时针方向'],
                },
                {
                    name: 'artboard',


                    keywords: ['画板,美术板'],
                },
                {
                    name: 'contrast',


                    keywords: ['对比', '强烈对比'],
                },
                {
                    name: 'collage',


                    keywords: ['拼贴画', '拼贴'],
                },
                {
                    name: 'clear-formatting-1',


                    keywords: ['清除格式', '去除格式'],
                },
                {
                    name: 'dividers-1',


                    keywords: ['分隔线', '分隔符'],
                },
                {
                    name: 'drag-move',


                    keywords: ['拖拽移动', '拖动操作'],
                },
                {
                    name: 'cut',


                    keywords: ['剪切', '割开'],
                },
                {
                    name: 'drag-drop',


                    keywords: ['拖放', '拖拽放置'],
                },
                {
                    name: 'brush',


                    keywords: ['画笔', '毛笔'],
                },
                {
                    name: 'edit-2',


                    keywords: ['编辑,校订'],
                },
                {
                    name: 'focus',


                    keywords: ['焦点', '焦点所在'],
                },
                {
                    name: 'edit-1',


                    keywords: ['编辑,校订'],
                },
                {
                    name: 'format-horizontal-align-center',


                    keywords: ['水平居中格式', '水平对齐居中'],
                },
                {
                    name: 'fill-color',


                    keywords: ['填充颜色', '填充色彩'],
                },
                {
                    name: 'format-horizontal-align-bottom',


                    keywords: ['水平对齐底部', '水平底端对齐'],
                },
                {
                    name: 'format-horizontal-align-top',


                    keywords: ['水平对齐顶部', '水平顶对齐'],
                },
                {
                    name: 'ink',


                    keywords: ['墨水', '墨水', '染料', '颜料'],
                },
                {
                    name: 'layers',


                    keywords: ['层', '层次'],
                },
                {
                    name: 'frame-1',


                    keywords: ['框架', '结构'],
                },
                {
                    name: 'mirror',


                    keywords: ['镜子', '镜子的反射', '镜面的'],
                },
                {
                    name: 'layout',


                    keywords: ['布局', '排列'],
                },
                {
                    name: 'measurement-2',


                    keywords: ['度量', '测量'],
                },
                {
                    name: 'pen-ball',


                    keywords: ['笔球', '乒乓球'],
                },
                {
                    name: 'palette-1',


                    keywords: ['调色板', '色彩面板'],
                },
                {
                    name: 'pen-brush',


                    keywords: ['笔刷', '毛笔'],
                },
                {
                    name: 'pen-mark',


                    keywords: ['笔迹', '笔标记'],
                },
                {
                    name: 'root-list',


                    keywords: ['根列表', '根目录列表'],
                },
                {
                    name: 'pen-quill',


                    keywords: ['钢笔', '毛笔'],
                },
                {
                    name: 'pen',


                    keywords: ['钢笔', '毛笔'],
                },
                {
                    name: 'screenshot',


                    keywords: ['屏幕截图', '屏幕快照'],
                },
                {
                    name: 'rotation',


                    keywords: ['旋转', '轮转'],
                },
                {
                    name: 'textbox',


                    keywords: ['文本框', '输入框'],
                },
                {
                    name: 'sip',


                    keywords: [
                        '"sip"可以翻译为以下两个中文短语：\n\n1. 小口喝', '啜饮\n2. 吸饮', '轻啜',
                    ],
                },
                {
                    name: 'table-1',


                    keywords: ['表格', '表格形式'],
                },
                {
                    name: 'transform-1',


                    keywords: ['转变', '变换'],
                },
                {
                    name: 'view-column',


                    keywords: ['列视图', '视图列'],
                },
                {
                    name: 'transform-3',


                    keywords: ['转变', '转换'],
                },
                {
                    name: 'slice',


                    keywords: ['切片', '片段'],
                },
            ],
        },
        Foods: {
            labelCN: '食品',
            labelEn: 'Foods',
            icons: [
                {
                    name: 'bamboo-shoot',


                    keywords: ['竹笋', '竹芽'],
                },
                {
                    name: 'banana',


                    keywords: ['香蕉', '香蕉的'],
                },
                {
                    name: 'beer',


                    keywords: ['啤酒', '啤酒', '啤酒'],
                },
                {
                    name: 'barbecue',


                    keywords: ['烧烤', '烤肉'],
                },
                {
                    name: 'apple',


                    keywords: ['苹果', '苹果公司'],
                },
                {
                    name: 'bone',


                    keywords: ['骨头', '骨骼'],
                },
                {
                    name: 'broccoli',


                    keywords: ['西兰花', '花椰菜'],
                },
                {
                    name: 'bean',


                    keywords: ['豆子', '豆荚'],
                },
                {
                    name: 'bread',


                    keywords: ['面包', '面包'],
                },
                {
                    name: 'candy',


                    keywords: ['糖果', '糖果', '甜蜜', '甜美的食品'],
                },
                {
                    name: 'cheese',


                    keywords: ['奶酪', '芝士'],
                },
                {
                    name: 'cherry',


                    keywords: ['樱桃', '樱桃树'],
                },
                {
                    name: 'cabbage',


                    keywords: ['卷心菜,洋白菜'],
                },
                {
                    name: 'chicken',


                    keywords: ['鸡肉', '鸡肉类'],
                },
                {
                    name: 'cake',


                    keywords: ['蛋糕', '糕点'],
                },
                {
                    name: 'cola',


                    keywords: ['可乐', '碳酸饮料'],
                },
                {
                    name: 'corn',


                    keywords: ['玉米,玉蜀黍,苞谷'],
                },
                {
                    name: 'cucumber',


                    keywords: [],
                },
                {
                    name: 'chili',


                    keywords: ['辣椒', '辣椒粉'],
                },
                {
                    name: 'drumstick',


                    keywords: ['鼓棒', '鼓槌'],
                },
                {
                    name: 'drink',


                    keywords: ['喝酒', '饮品'],
                },
                {
                    name: 'fish',


                    keywords: ['鱼', '鱼类'],
                },
                {
                    name: 'chinese-cabbage',


                    keywords: ['白菜', '中国白菜'],
                },
                {
                    name: 'eggplant',


                    keywords: ['茄子', '茄子'],
                },
                {
                    name: 'garlic',


                    keywords: ['大蒜', '蒜'],
                },
                {
                    name: 'lemon-slice',


                    keywords: ['柠檬片', '柠檬切片'],
                },
                {
                    name: 'hamburger',


                    keywords: ['汉堡包', '汉堡'],
                },
                {
                    name: 'liquor',


                    keywords: ['酒', '酒精饮料'],
                },
                {
                    name: 'lemon',


                    keywords: ['柠檬', '柠檬水'],
                },
                {
                    name: 'grape',


                    keywords: ['葡萄', '葡萄树'],
                },
                {
                    name: 'meat-pepper',


                    keywords: ['辣椒炒肉', '辣味肉类'],
                },
                {
                    name: 'green-onion',


                    keywords: ['青葱', '葱'],
                },
                {
                    name: 'fries',


                    keywords: ['薯片', '炸薯条'],
                },
                {
                    name: 'ice-cream',


                    keywords: ['冰淇淋', '冰琪淋'],
                },
                {
                    name: 'mushroom-1',


                    keywords: ['蘑菇', '蕈类'],
                },
                {
                    name: 'mushroom',


                    keywords: ['蘑菇', '蘑菇类'],
                },
                {
                    name: 'peach',


                    keywords: ['桃子', '桃子'],
                },
                {
                    name: 'nut',


                    keywords: ['坚果', '坚果类'],
                },
                {
                    name: 'pear',


                    keywords: ['梨', '琵琶'],
                },
                {
                    name: 'noodle',


                    keywords: ['面条', '米线'],
                },
                {
                    name: 'pea',


                    keywords: ['豌豆', '豌豆植物'],
                },
                {
                    name: 'milk',


                    keywords: ['牛奶', '牛奶', '乳制品'],
                },
                {
                    name: 'pumpkin',


                    keywords: ['南瓜', '南瓜派'],
                },
                {
                    name: 'radish',


                    keywords: ['萝卜', '白萝卜'],
                },
                {
                    name: 'rice-ball',


                    keywords: ['饭团', '米饭球'],
                },
                {
                    name: 'rice',


                    keywords: ['米', '大米'],
                },
                {
                    name: 'tangerinr',


                    keywords: ['丹吉尔', '坦吉尔'],
                },
                {
                    name: 'sandwich',


                    keywords: ['夹心面包', '三明治'],
                },
                {
                    name: 'shrimp',


                    keywords: ['虾', '虾仁'],
                },
                {
                    name: 'sausage',


                    keywords: ['腊肠', '香肠'],
                },
                {
                    name: 'tomato',


                    keywords: ['番茄', '番茄酱'],
                },
                {
                    name: 'popsicle',


                    keywords: ['冰棍', '冰棒'],
                },
                {
                    name: 'watermelon',


                    keywords: ['西瓜', '水瓜'],
                },
                {
                    name: 'tea',


                    keywords: ['茶', '茶饮料', '茶点'],
                },
            ],
        },
        Device: {
            labelCN: '设备',
            labelEn: 'Device',
            icons: [
                {
                    name: 'airplay-wave',


                    keywords: ['airplay 镜像', 'wave 广播'],
                },
                {
                    name: 'battery-charging',


                    keywords: ['电池充电', '蓄电池充电'],
                },
                {
                    name: 'barcode-1',


                    keywords: ['条码', '条形码'],
                },
                {
                    name: 'battery-add',


                    keywords: ['电池添加', '添加电池'],
                },
                {
                    name: 'audio',


                    keywords: ['音频', '声音'],
                },
                {
                    name: 'base-station',


                    keywords: ['基站', '基地站'],
                },
                {
                    name: 'bluetooth',


                    keywords: ['蓝牙', '蓝牙技术'],
                },
                {
                    name: 'call-forwarded',


                    keywords: ['呼叫转发', '转发呼叫'],
                },
                {
                    name: 'battery',


                    keywords: ['电池', '电池组'],
                },
                {
                    name: 'battery-low',


                    keywords: ['电量低', '低电量'],
                },
                {
                    name: 'call-cancel',


                    keywords: ['取消呼叫', '取消电话'],
                },
                {
                    name: 'call-off',


                    keywords: ['取消订单', '撤回订单'],
                },
                {
                    name: 'call-1',


                    keywords: ['打电话', '呼叫'],
                },
                {
                    name: 'call-incoming',


                    keywords: ['来电', '来电接入'],
                },
                {
                    name: 'camera',


                    keywords: ['相机', '摄像机'],
                },
                {
                    name: 'data-base',


                    keywords: ['数据库', '数据库系统'],
                },
                {
                    name: 'cpu',


                    keywords: ['中央处理器', 'CPU'],
                },
                {
                    name: 'camera-off',


                    keywords: ['相机关闭', '关闭相机'],
                },
                {
                    name: 'data-error',


                    keywords: ['数据错误', '错误数据'],
                },
                {
                    name: 'desktop',


                    keywords: ['桌面', '桌面环境'],
                },
                {
                    name: 'cast',


                    keywords: ['"cast', '投射"\n"cast', '铸造"'],
                },
                {
                    name: 'data-checked',


                    keywords: ['已检查', '已勾选'],
                },
                {
                    name: 'device',


                    keywords: ['设备', '装置'],
                },
                {
                    name: 'film',


                    keywords: ['胶卷', '电影胶片'],
                },
                {
                    name: 'desktop-1',


                    keywords: ['桌面', '桌面环境'],
                },
                {
                    name: 'flashlight',


                    keywords: ['手电筒', '手电筒'],
                },
                {
                    name: 'data',


                    keywords: ['数据', '资讯'],
                },
                {
                    name: 'data-search',


                    keywords: ['数据搜索', '搜寻数据'],
                },
                {
                    name: 'hotspot-wave',


                    keywords: ['热点波', '热点波浪'],
                },
                {
                    name: 'keyboard',


                    keywords: ['键盘', '键盘', '键盘', '键盘'],
                },
                {
                    name: 'mobile-vibrate',


                    keywords: ['手机振动', '手机震动模式'],
                },
                {
                    name: 'hard-drive',


                    keywords: ['硬盘驱动器', '硬盘'],
                },
                {
                    name: 'gps',


                    keywords: ['全球定位系统', '导航系统'],
                },
                {
                    name: 'call',


                    keywords: ['调用', '呼叫'],
                },
                {
                    name: 'laptop',


                    keywords: ['笔记本电脑', '便携式电脑'],
                },
                {
                    name: 'gamepad',


                    keywords: ['游戏手柄', '游戏控制器'],
                },
                {
                    name: 'install',


                    keywords: ['安装', '装置'],
                },
                {
                    name: 'mode-light',


                    keywords: ['模式轻量', '模式轻型'],
                },
                {
                    name: 'mode-dark',


                    keywords: ['暗黑模式,深色主题'],
                },
                {
                    name: 'mobile',


                    keywords: ['移动', '行动'],
                },
                {
                    name: 'mouse',


                    keywords: ['鼠标', '鼠标器'],
                },
                {
                    name: 'precise-monitor',


                    keywords: ['精确监控', '精确监测'],
                },
                {
                    name: 'qrcode',


                    keywords: ['二维码', '二维条码'],
                },
                {
                    name: 'phone-search',


                    keywords: ['手机搜索', '查找手机'],
                },
                {
                    name: 'rotate-locked',


                    keywords: ['旋转锁定', '旋转上锁'],
                },
                {
                    name: 'rotate',


                    keywords: ['旋转', '轮流'],
                },
                {
                    name: 'router-wave',


                    keywords: ['路由波动', '路由波动'],
                },
                {
                    name: 'save',


                    keywords: ['保存', '存储'],
                },
                {
                    name: 'phone-locked',


                    keywords: ['手机锁定', '锁定手机'],
                },
                {
                    name: 'scan',


                    keywords: ['扫描', '扫描成'],
                },
                {
                    name: 'sensors-1',


                    keywords: ['感应器', '传感器'],
                },
                {
                    name: 'tv',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'sim-card-2',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'tv-1',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'remote-wave',


                    keywords: ['远程波动', '远程波'],
                },
                {
                    name: 'sd-card',


                    keywords: ['SD卡', '存储卡'],
                },
                {
                    name: 'sim-card-1',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'usb',


                    keywords: ['通用串行总线', 'USB端口'],
                },
                {
                    name: 'rss',


                    keywords: [],
                },
                {
                    name: 'uninstall',


                    keywords: ['卸载', '取消安装'],
                },
                {
                    name: 'sim-card',


                    keywords: ['SIM卡', '用户身份模块卡'],
                },
                {
                    name: 'tv-2',


                    keywords: ['电视', '电视机'],
                },
                {
                    name: 'watch',


                    keywords: ['看', '监视'],
                },
                {
                    name: 'widget',


                    keywords: ['小组件', '小部件'],
                },
                {
                    name: 'wifi-off',


                    keywords: ['关闭Wi-Fi', '关闭无线网络'],
                },
                {
                    name: 'video-camera',


                    keywords: ['video camera', '摄像机'],
                },
                {
                    name: 'wifi-off-1',


                    keywords: ['关闭Wi-Fi', '关闭无线网络'],
                },
                {
                    name: 'wifi-1',


                    keywords: ['无线网络', '无线电波'],
                },
                {
                    name: 'wifi',


                    keywords: ['无线保真', '无线互联网'],
                },
            ],
        },
    },
};